import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./questionpaperdetail.css";
import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
import NotesIcon from "../../../Assets/Images/CommanImages/grommet-icons_notes.png";
import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import ExcludeInput from "./ExcludeInput";
import MultiProgress from "../MultiProgressBar/MultiProgress";
import TabComponent from "./TabComponent";
import TableDetailsQuesList from "./TableDetailsQuesList";
import SectionSelectedDropdown from "./SectionSelectedDropdown";
import TableDetailsSelectedQues from "./TableDetailsSelectedQuestions";
import DropDownFilterTags from "./DropDownFilterTags";
import QuestionTextRenderer from "./QuestionTextRenderer";
import ToggleButton from "../../../Components/Shared/ToggleButtons/ToggleButton";
import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
import DraggablePill from "./DraggablePill";

function QuestionPaperDetail({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
  setMessageBoxHeight,
}) {
  const tagFilterRef = useRef(null);
  const headersRef = useRef([]);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [isOpenSubject, setIsOpenSubject] = useState(true);
  const [isOpenSubjectFilterTags, setIsOpenSubjectFilterTags] = useState(true);
  const [isOpenSingleSelectQues, setIsOpenSingleSelectQues] = useState(false);
  const [isOpenMultiSelectQues, setIsOpenMultiSelectQues] = useState(false);
  const [isOpenFillInBlanckQues, setIsFillInBlanckQues] = useState(false);
  const [isOpenBooleanQues, setIsBooleanQues] = useState(false);
  const [isOpenSectionAQues, setIsOpenSectionAQues] = useState(false);
  const [isOpenSectionBQues, setIsOpenSectionBQues] = useState(false);
  const [isOpenSectionCQues, setIsOpenSectionCQues] = useState(false);
  const [isOpenSectionDQues, setIsOpenSectionDQues] = useState(false);
  const accessToken = localStorage.getItem("other");
  const [accessibleSubjects, setAccessibleSubjects] = useState([]);
  const [selectedSections, setSelectedSections] = useState(1);
  const [sectionsTypeID, setSectionsTypeID] = useState(1);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [selectedHeaders, setSelectedHeaders] = useState([]);
  const [difficultyCount, setDifficultyCount] = useState({
    easy: 0,
    medium: 0,
    tough: 0,
  });
  const [fixedTopicCountsByType, setFixedTopicCountsByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [fixedTopicEnabledByType, setFixedTopicEnabledByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [showFlagModal, setShowFlagModal] = useState(false);
  const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});
  const [selecteSectionTypeID, setSelecteSectionTypeID] = useState(1);
  const [excludeRepeatCount, setExcludeRepeatCount] = useState(0);
  const [sectionInstructions, setSectionInstructions] = useState({});
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientBranchId =
    dataClient?.client_schema_name[6][0].client_branch_id || null;
  const userId = dataClient?.client_schema_name[6][0].user_id || null;
  const [isReadOnlyMode, setIsReadOnlyMode] = useState(false);
  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };
  const toggleAccordionSubjectsFilterTags = () => {
    setIsOpenSubjectFilterTags(!isOpenSubjectFilterTags);
  };
  const toggleAccordionSingleSelectQues = () => {
    setIsOpenSingleSelectQues(!isOpenSingleSelectQues);
  };
  const toggleAccordionMultiSelectQues = () => {
    setIsOpenMultiSelectQues(!isOpenMultiSelectQues);
  };
  const toggleAccordionFillInBlancksQues = () => {
    setIsFillInBlanckQues(!isOpenFillInBlanckQues);
  };
  const toggleAccordionBoolean = () => {
    setIsBooleanQues(!isOpenBooleanQues);
  };
  const toggleAccordionSectionA = () => {
    setIsOpenSectionAQues(!isOpenSectionAQues);
  };
  const toggleAccordionSectionB = () => {
    setIsOpenSectionBQues(!isOpenSectionBQues);
  };
  const toggleAccordionSectionC = () => {
    setIsOpenSectionCQues(!isOpenSectionCQues);
  };
  const toggleAccordionSectionD = () => {
    setIsOpenSectionDQues(!isOpenSectionDQues);
  };
  const questionPaperId = new URLSearchParams(window.location.search).get(
    "MNTQuestionNumbers"
  );
  const [draftData, setDraftData] = useState(null);
  const [draftInitialized, setDraftInitialized] = useState(false);
  const [excludeRepeatEdited, setExcludeRepeatEdited] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [sectionSettingsBySubject, setSectionSettingsBySubject] = useState({});
  const [specialInstructions, setSpecialInstructions] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [version, setVersion] = useState(0);
  const [activeSubjectId, setActiveSubjectId] = useState(null);
  const [enableSingleSlider, setEnableSingleSlider] = useState(false);
  const [enableMultiSlider, setEnableMultiSlider] = useState(false);
  const [enableBooleanSlider, setEnableBooleanSlider] = useState(false);
  const [enableFillSlider, setEnableFillSlider] = useState(false);
  const [sectionDetailsPerSubject, setSectionDetailsPerSubject] = useState({});
  const [subjectStatusById, setSubjectStatusById] = useState({});
  const [scopeId, setScopeId] = useState(null);
  const [loadingTab, setLoadingTab] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();
        const questionPaper = result.question_paper;
        setData(questionPaper);
        // Build subject status map
        const subjectStatusMap = {};
        (questionPaper.subjects || []).forEach((sub) => {
          subjectStatusMap[sub.subject_id] = sub.subject_status;
        });
        setSubjectStatusById(subjectStatusMap);

        // ✅ Always set scopeId, default to 0 if not found
        const layoutScopeId = questionPaper?.scopes?.[0]?.scope_id || 0;
        setScopeId(layoutScopeId);

        // logic for num of section and naming pattern auto selected from api
        if (questionPaper?.ques_paper_details?.ques_paper_type === 2) {
          const layoutSubjects = questionPaper.subjects || [];
          const layoutSectionSettings = {};

          layoutSubjects.forEach((subject) => {
            const typeId = subject.section_naming_pattern === "Numeric" ? 2 : 1; // 2 = Numeric, 1 = Alphabetic
            layoutSectionSettings[subject.subject_id] = {
              selectedSections: subject.no_of_sections || 1,
              selecteSectionTypeID: typeId,
              isFixedFromLayout: true,
            };
          });

          // ✅ Save to layout-based sectionSettings
          setSectionSettingsBySubject((prev) => ({
            ...layoutSectionSettings,
            ...prev, // keep draft data if it comes later
          }));
        }
        const specialInstMap = {};
        questionPaper.subjects.forEach((sub) => {
          specialInstMap[sub.subject_id] = sub.special_inst;
        });
        setSpecialInstructions(specialInstMap);

        // Build sectionDetailsPerSubject from questionPaper.all_section_details
        const sectionDetailsMap = {};
        (questionPaper.all_section_details || []).forEach((section) => {
          const { subject_id, section_name } = section;
          if (!sectionDetailsMap[subject_id]) {
            sectionDetailsMap[subject_id] = {};
          }
          sectionDetailsMap[subject_id][section_name] = {
            section_no: section.section_no,
            ms_id: section.ms_id,
            mandatory_ques_cnt: section.mandatory_ques_cnt,
            optional_ques_cnt: section.optional_ques_cnt,
            total_ques_cnt: section.total_ques_cnt,
            instruction: section.section_instructions,
            section_question_type_id: section.section_question_type_id,
          };
        });
        setSectionDetailsPerSubject(sectionDetailsMap);

        // Extract question paper id
        const quesPaperId = questionPaper.ques_paper_details.ques_paper_id;
        // Extract subject IDs (as an array of numbers)
        const subjectIds = questionPaper.subjects.map(
          (subject) => subject.subject_id
        );
        const assignedCreators = questionPaper.assigned_creators || {};

        const subjectsWithAccessibility = questionPaper.subjects.map(
          (subject) => ({
            ...subject,
            isAccessible:
              assignedCreators[subject.subject_id]?.includes(userId) || false,
          })
        );
        setAccessibleSubjects(subjectsWithAccessibility);

        // NEW JSON DATA
        // const subjectsWithAccessibility = questionPaper.subjects.map((subject) => ({
        //   ...subject,
        //   isAccessible: Array.isArray(assignedCreators[subject.subject_id]) &&
        //     assignedCreators[subject.subject_id].some(creator => creator.user_id === userId),
        // }));

        // if (!activeSubjectId && subjectsWithAccessibility.length > 0) {
        //   // setActiveSubjectId(subjectsWithAccessibility[0].subject_id);
        //   setActiveSubjectId(subjectsWithAccessibility.subject_id);
        // }
        if (!activeSubjectId) {
          const firstAssigned = subjectsWithAccessibility.find(
            (s) => s.isAccessible
          );
          if (firstAssigned) setActiveSubjectId(firstAssigned.subject_id);
        }

        const updatedDifficultyDistributions = {
          single: {},
          multi: {},
          fill: {},
          boolean: {},
        };

        for (const subject of questionPaper.subjects) {
          const chapterIds = subject.chapters?.map((ch) => ch.chapter_id) || [];
          if (chapterIds.length === 0) continue;
          for (const chapterId of chapterIds) {
            // Only assign if the chapter is selected in the subject
            const difficulty = {
              firstSegment: subject.easy || 0,
              secondSegment: subject.medium || 0,
              calculatedValue: subject.tough || 0,
              total:
                (subject.easy || 0) +
                (subject.medium || 0) +
                (subject.tough || 0),
            };
            ["single", "multi", "fill", "boolean"].forEach((type) => {
              if (!updatedDifficultyDistributions[type][chapterId]) {
                updatedDifficultyDistributions[type][chapterId] = difficulty;
              }
            });
          }
        }
        setDifficultyDistributions(updatedDifficultyDistributions);
        const draftApiUrl = new URL(
          `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/`
        );
        draftApiUrl.searchParams.append("ques_paper_id", quesPaperId);
        subjectIds.forEach((id) =>
          draftApiUrl.searchParams.append("subject_ids", id)
        );
        const draftResponse = await fetch(draftApiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (!draftResponse.ok) {
          throw new Error("Failed to fetch draft data");
        }
        const draftData = await draftResponse.json();
        setDraftData(draftData);

        if (draftData?.subjects) {
          const instMap = {};
          draftData.subjects.forEach((sub) => {
            if (sub.sections && sub.sections.length > 0) {
              sub.sections.forEach((sec) => {
                instMap[`${sub.subject_id}_${sec.section_name}`] =
                  sec.section_instruction || "";
              });
            }
          });
          setSectionInstructions(instMap);
        }

        // Build difficultyDistributions from draftData
        const updatedDraftDistributions = {
          single: {},
          multi: {},
          fill: {},
          boolean: {},
        };
        const quesTypeMap = {
          1: "single",
          2: "multi",
          3: "fill",
          4: "boolean",
        };
        draftData?.subjects?.forEach((subject) => {
          subject.ques_types?.forEach((qt) => {
            const typeKey = quesTypeMap[qt.ques_type_id];
            if (!typeKey) return;
            qt.chapters?.forEach((chapter) => {
              const chapId = chapter.chapter_id;
              updatedDraftDistributions[typeKey][chapId] = {
                total: chapter.chapter_ques_cnt || 0,
                firstSegment: chapter.easy || 0,
                secondSegment: chapter.medium || 0,
                calculatedValue: chapter.tough || 0,
              };
            });
          });
        });

        setDifficultyDistributions((prev) => ({
          ...prev,
          ...updatedDraftDistributions,
        }));

        const draftSubjectData = draftData?.subjects?.[0]; // Assuming 1 subject for now

        if (draftSubjectData) {
          setSelectedSections(draftSubjectData.no_of_sections || 1);
          setSelectedTemplateId(
            draftSubjectData.ques_paper_user_template_id || null
          );
          setExcludeRepeatCount(draftSubjectData.exclude_repeat_n_times || 0);
          setSelecteSectionTypeID(draftSubjectData.section_naming_type || 1); // If applicable
          setDraftInitialized(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const timer = setTimeout(() => {
      fetchData();
    }, 500);
    return () => clearTimeout(timer);
  }, [dataClient]);

  useEffect(() => {
    if (!activeSubjectId || !sectionSettingsBySubject[activeSubjectId]) return;
    // Set selected dropdowns only once when activeSubjectId is first available
    setSelectedSections(
      sectionSettingsBySubject[activeSubjectId]?.selectedSections || 1
    );
    setSelecteSectionTypeID(
      sectionSettingsBySubject[activeSubjectId]?.selecteSectionTypeID || 1
    );
  }, [activeSubjectId, sectionSettingsBySubject]);

  const scopeTypeMap = {
    1: "Batch Name",
    2: "Branch Name",
    3: "Zone Name",
    4: "City Name",
    5: "State Name",
    7: "All India",
  };
  const groupedScopes = data?.scopes?.reduce((acc, scope) => {
    if (!acc[scope.scope_id]) {
      acc[scope.scope_id] = [];
    }
    acc[scope.scope_id].push(scope.scope_ref_name);
    return acc;
  }, {});
  const [chapterData, setChapterData] = useState([]);
  const [topicData, setTopicData] = useState({});
  const [checkedChaptersByType, setCheckedChaptersByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [selectedTopicsByType, setSelectedTopicsByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [difficultyDistributions, setDifficultyDistributions] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  // const [manualChapterFixedCounts, setManualChapterFixedCounts] = useState({ single: {}, multi: {}, fill: {}, boolean: {}, });
  const isActiveSubjectReadOnly = () => {
    const activeSubjStatus = draftData?.subjects?.find(
      (s) => s.subject_id === activeSubjectId
    )?.status;
    return activeSubjStatus === 2 || activeSubjStatus === 3;
  };
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = ""; // Modern browsers require returnValue to be set
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const handleTabChange = (subjectId, requestedId = null) => {
    const newSubjectId = requestedId ?? subjectId;

    if (hasUnsavedChanges && newSubjectId !== activeSubjectId) {
      setNoTimeSet(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Your changes will be lost before switching the tab. Do you want to
              continue?
            </span>
          </div>
          <div
            className="messagebox-insider2"
            style={{ display: "flex", gap: "10px", marginTop: "10px" }}
          >
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                setHasUnsavedChanges(false);
                switchTab(newSubjectId);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(WarnningIcon);
      setIsMessageBoxVisible(true);
      return;
    }

    // Normal tab switch
    switchTab(newSubjectId);
  };

  const switchTab = async (newSubjectId) => {
    setLoadingTab(true);
    try {
      setActiveSubjectId(newSubjectId);

      // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
      // FIX: Immediately clear stale data from previous subject
      // This prevents cross-subject contamination during async gap
      // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
      setReportDashboardData([]); // clears QUESTIONS LIST table
      setSelectedQuestions([]); // clears right-pane cards
      setSelectedRows([]); // clears checkbox state
      setDifficultyCount({ easy: 0, medium: 0, tough: 0 }); // clears progress bars
      setSectionWiseQuestions({}); // clears section assignments

      const settings = sectionSettingsBySubject[newSubjectId] || {};
      setExcludeRepeatCount(settings.excludeRepeatCount || 0);
      setSelectedSections(settings.selectedSections || 1);
      setSelecteSectionTypeID(settings.selecteSectionTypeID || 1);

      const subjectStatus = subjectStatusById[newSubjectId];
      const quesTypeMap = { 1: "single", 2: "multi", 3: "fill", 4: "boolean" };

      // ---------------- ASSIGNED ----------------
      if (subjectStatus === 0) {
        const url = `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`;
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) throw new Error("Layout API failed");

        const result = await response.json();
        const layoutSubject = result.question_paper.subjects?.find(
          (s) => s.subject_id === newSubjectId
        );

        const updatedChecked = { single: {}, multi: {}, fill: {}, boolean: {} };
        const updatedTopics = { single: {}, multi: {}, fill: {}, boolean: {} };

        // ✅ Step 1: tick all chapters
        const chapterIds =
          layoutSubject?.chapters?.map((c) => c.chapter_id) || [];
        chapterIds.forEach((id) => {
          ["single", "multi", "fill", "boolean"].forEach((typeKey) => {
            updatedChecked[typeKey][id] = true;
          });
        });

        setCheckedChaptersByType((prev) => ({
          ...prev,
          ...updatedChecked,
        }));

        // ✅ Step 2: fetch topics
        if (chapterIds.length > 0) {
          const topicsResponse = await fetch(
            `${FULL_API_BASE_URL}/get-topics-by-chapter-list/`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(chapterIds),
            }
          );
          const topicsResult = await topicsResponse.json();

          const selectedTopics = {};
          topicsResult?.data?.forEach((topic) => {
            if (!selectedTopics[topic.chapter_id]) {
              selectedTopics[topic.chapter_id] = [];
            }
            selectedTopics[topic.chapter_id].push(topic.topic_id);
          });

          // ✅ Apply topics to all types
          ["single", "multi", "fill", "boolean"].forEach((typeKey) => {
            updatedTopics[typeKey] = { ...selectedTopics };
          });

          setSelectedTopicsByType((prev) => ({
            ...prev,
            ...updatedTopics,
          }));
        }
      }

      // ---------------- DRAFT ----------------
      else if (subjectStatus === 1) {
        const url = `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/?ques_paper_id=${questionPaperId}&subject_ids=${newSubjectId}`;
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) throw new Error("Draft API failed");

        const result = await response.json();
        const draftSubject = result.subjects?.find(
          (sub) => sub.subject_id === newSubjectId
        );

        // ✅ Restore tags
        const tagList = draftSubject?.parse_tags || [];
        const formattedTags = tagList.map((tag) => ({
          tag_id: tag.parse_tag_id,
          tag_value_id: tag.parse_tag_value_id,
        }));
        setSelectedTagsBySubject((prev) => ({
          ...prev,
          [newSubjectId]: formattedTags,
        }));
        setSelectedTags(formattedTags);

        // ✅ Restore chapters + topics
        const updatedChecked = { single: {}, multi: {}, fill: {}, boolean: {} };
        const updatedTopics = { single: {}, multi: {}, fill: {}, boolean: {} };

        draftSubject?.ques_types?.forEach((qt) => {
          const typeKey = quesTypeMap[qt.ques_type_id];
          if (!typeKey) return;

          qt.chapters?.forEach((chapter) => {
            const chapId = chapter.chapter_id;
            updatedChecked[typeKey][chapId] = true;
            updatedTopics[typeKey][chapId] = chapter.topic.map(
              (t) => t.topic_id
            );
          });
        });

        setCheckedChaptersByType((prev) => ({
          ...prev,
          ...updatedChecked,
        }));

        setSelectedTopicsByType((prev) => ({
          ...prev,
          ...updatedTopics,
        }));
      }
    } catch (error) {
      console.error("Error switching tab:", error);
    } finally {
      setLoadingTab(false);
    }
  };

  useEffect(() => {
    // Once draft is loaded, mark no unsaved changes initially
    if (draftData) {
      setHasUnsavedChanges(false);
    }
  }, [draftData]);

  useEffect(() => {
    if (!activeSubjectId || !draftData?.subjects) return;
    const activeSubjStatus = draftData.subjects.find(
      (s) => s.subject_id === activeSubjectId
    )?.status;
    setIsReadOnlyMode(activeSubjStatus === 2);
  }, [activeSubjectId, draftData]);

  useEffect(() => {
    if (!activeSubjectId) return;
    fetch(
      `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${activeSubjectId}`
    )
      .then((res) => res.json())
      .then((data) => setChapterData(data || []))
      .catch((err) => console.error("Error fetching chapters:", err));
  }, [activeSubjectId]);

  const handleChapterCheck = (chapterId, type) => {
    setHasUnsavedChanges(true);
    setCheckedChaptersByType((prev) => {
      const isChecked = !prev[type][chapterId];
      if (isChecked && !topicData[chapterId]) {
        fetch(
          `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`
        )
          .then((response) => response.json())
          .then((data) => {
            setTopicData((prevData) => ({ ...prevData, [chapterId]: data }));

            setSelectedTopicsByType((prevTopics) => ({
              ...prevTopics,
              [type]: {
                ...prevTopics[type],
                [chapterId]: data.map((topic) => topic.topic_id),
              },
            }));
          });
      } else {
        // Update selection
        setSelectedTopicsByType((prevTopics) => ({
          ...prevTopics,
          [type]: {
            ...prevTopics[type],
            [chapterId]: isChecked
              ? topicData[chapterId]?.map((t) => t.topic_id) || []
              : [],
          },
        }));
      }

      return {
        ...prev,
        [type]: {
          ...prev[type],
          [chapterId]: isChecked,
        },
      };
    });
  };

  const [expandedChaptersByType, setExpandedChaptersByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });

  const handleChapterExpand = (chapterId, type) => {
    setExpandedChaptersByType((prev) => ({
      ...prev,
      [type]: { ...prev[type], [chapterId]: !prev[type]?.[chapterId] },
    }));
    if (!topicData[chapterId]) {
      fetch(
        `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`
      )
        .then((res) => res.json())
        .then((data) => {
          setTopicData((prev) => ({ ...prev, [chapterId]: data }));
        })
        .catch((err) => console.error("Error fetching topics:", err));
    }
  };

  const handleSliderChange = (chapterId, values, type = "single") => {
    setDifficultyDistributions((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [chapterId]: {
          ...prev[type]?.[chapterId],
          ...values,
        },
      },
    }));
  };

  const handleTopicCheck = (chapterId, topicId, type) => {
    setHasUnsavedChanges(true);
    const totalTopics = topicData[chapterId]?.map((t) => t.topic_id) || [];
    setSelectedTopicsByType((prev) => {
      const current = prev[type]?.[chapterId] || [];
      const isSelected = current.includes(topicId);
      const updated = isSelected
        ? current.filter((id) => id !== topicId)
        : [...current, topicId];

      // ✅ Also update chapter checked state
      setCheckedChaptersByType((prevChecked) => ({
        ...prevChecked,
        [type]: {
          ...prevChecked[type],
          [chapterId]: updated.length > 0,
        },
      }));

      // ✅ Always keep chapter expanded (so we show "-" even if all topics are unselected)
      setExpandedChaptersByType((prevExpanded) => ({
        ...prevExpanded,
        [type]: {
          ...prevExpanded[type],
          [chapterId]: true,
        },
      }));

      return {
        ...prev,
        [type]: {
          ...prev[type],
          [chapterId]: updated,
        },
      };
    });
  };

  useEffect(() => {
    const types = ["single", "multi", "fill", "boolean"];

    const updatedChecked = {};
    const updatedExpanded = {};

    types.forEach((type) => {
      const currentChecked = { ...checkedChaptersByType[type] };
      const currentExpanded = { ...expandedChaptersByType[type] };
      const selectedTopics = selectedTopicsByType[type] || {};

      Object.entries(selectedTopics).forEach(([chapterId, topicIds]) => {
        const allTopics = topicData[chapterId] || [];
        const isAllUnselected = allTopics.length > 0 && topicIds.length === 0;

        if (isAllUnselected) {
          currentChecked[chapterId] = false;
          currentExpanded[chapterId] = false; // or true, if you want to keep expanded
        }
      });

      updatedChecked[type] = currentChecked;
      updatedExpanded[type] = currentExpanded;
    });

    setCheckedChaptersByType((prev) => ({
      ...prev,
      ...updatedChecked,
    }));

    setExpandedChaptersByType((prev) => ({
      ...prev,
      ...updatedExpanded,
    }));
  }, [selectedTopicsByType, topicData]);

  const handleSelectAllTopics = (chapterId, type) => {
    const allTopics =
      topicData[chapterId]?.map((topic) => topic.topic_id) || [];
    setSelectedTopicsByType((prev) => {
      const alreadySelected = prev[type]?.[chapterId] || [];
      const allSelected = alreadySelected.length === allTopics.length;

      const updated = allSelected ? [] : allTopics;

      // ✅ Sync chapter checked state
      setCheckedChaptersByType((prevChecked) => ({
        ...prevChecked,
        [type]: {
          ...prevChecked[type],
          [chapterId]: updated.length > 0,
        },
      }));

      // ✅ Keep chapter expanded
      setExpandedChaptersByType((prevExpanded) => ({
        ...prevExpanded,
        [type]: {
          ...prevExpanded[type],
          [chapterId]: true,
        },
      }));

      return {
        ...prev,
        [type]: {
          ...prev[type],
          [chapterId]: updated,
        },
      };
    });
  };

  // FOR AUTO SELECTING CHAPTERS AND TOPICS LOGIC
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.json();
        const paperData = result.question_paper;
        setData(paperData);
        const allSubjectsFromApi = paperData.subjects || [];
        const assignedCreators = paperData.assigned_creators || {};

        const subjectsWithAccessibility = paperData.subjects.map((subject) => ({
          ...subject,
          isAccessible:
            assignedCreators[subject.subject_id]?.includes(userId) || false,
        }));
        setAccessibleSubjects(subjectsWithAccessibility);
        for (const selectedSubject of allSubjectsFromApi) {
          const subjectId = selectedSubject.subject_id;
          const chapterIds = selectedSubject.chapters.map(
            (ch) => ch.chapter_id
          );

          const checked = {};
          const expanded = {};
          const selectedTopics = {};

          for (const chapterId of chapterIds) {
            checked[chapterId] = true;
            expanded[chapterId] = false;

            const topicRes = await fetch(
              `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`
            );
            const topicJson = await topicRes.json();

            setTopicData((prev) => ({ ...prev, [chapterId]: topicJson }));
            selectedTopics[chapterId] = topicJson.map((t) => t.topic_id);
          }
          setCheckedChaptersByType((prev) => ({
            ...prev,
            single: { ...prev.single, ...checked },
            multi: { ...prev.multi, ...checked },
            fill: { ...prev.fill, ...checked },
            boolean: { ...prev.boolean, ...checked },
          }));

          setSelectedTopicsByType((prev) => ({
            ...prev,
            single: { ...prev.single, ...selectedTopics },
            multi: { ...prev.multi, ...selectedTopics },
            fill: { ...prev.fill, ...selectedTopics },
            boolean: { ...prev.boolean, ...selectedTopics },
          }));

          setExpandedChaptersByType((prev) => ({
            ...prev,
            single: { ...prev.single, ...expanded },
            multi: { ...prev.multi, ...expanded },
            fill: { ...prev.fill, ...expanded },
            boolean: { ...prev.boolean, ...expanded },
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const timer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  //  Tags
  const [tags, setTags] = useState([]);
  const [selectedTagsBySubject, setSelectedTagsBySubject] = useState({});
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);

    // Always set tags
    setFinalTags(hasValidTags ? [...selectedTags] : []);

    // 🔑 Always regenerate filters from chapters/topics
    const filters = generateFiltersV2();
    setFinalFilters(filters);
  }, [
    selectedTags,
    checkedChaptersByType,
    selectedTopicsByType,
    activeSubjectId,
    topicData,
  ]);

  const fetchTags = async () => {
    try {
      // const token = sessionStorage.getItem("other");
      const response = await fetch(`${FULL_API_BASE_URL}/get-parse-tags-all/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setTags(data.data);
      } else {
        console.error("Error fetching tags:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleDropdownChange = (tag, selectedOption) => {
    setSelectedTags((prev) => {
      const filtered = prev.filter((item) => item.tag_id !== tag.parse_tag_id);

      if (
        !selectedOption ||
        selectedOption.id === null ||
        selectedOption.id === undefined
      ) {
        setSelectedTagsBySubject((prevSubjects) => ({
          ...prevSubjects,
          [activeSubjectId]: filtered,
        }));
        return filtered;
      }

      const updated = [
        ...filtered,
        {
          tag_id: tag.parse_tag_id,
          tag_value_id: selectedOption.id,
        },
      ];

      setSelectedTagsBySubject((prevSubjects) => ({
        ...prevSubjects,
        [activeSubjectId]: updated,
      }));

      setHasUnsavedChanges(true); // ✅ track unsaved
      return updated;
    });
  };

  // const handleCheckboxChange = (tag, checked) => {
  //   setSelectedTags((prev) => {
  //     const filtered = prev.filter((item) => item.tag_id !== tag.parse_tag_id);
  //     const updated = [
  //       ...filtered,
  //       {
  //         tag_id: tag.parse_tag_id,
  //         tag_value_id: checked ? 1 : 0,
  //       },
  //     ];

  //     setSelectedTagsBySubject((prevSubjects) => ({
  //       ...prevSubjects,
  //       [activeSubjectId]: updated,
  //     }));

  //     setHasUnsavedChanges(true); // ✅ track unsaved
  //     return updated;
  //   });
  // };

  const handleCheckboxChange = (tag, checked) => {
    setSelectedTags((prev) => {
      // Remove any existing tag
      const filtered = prev.filter((item) => item.tag_id !== tag.parse_tag_id);

      if (!checked) {
        // ✅ unchecked → don't add back at all
        setSelectedTagsBySubject((prevSubjects) => ({
          ...prevSubjects,
          [activeSubjectId]: filtered,
        }));
        return filtered;
      }

      // ✅ checked → add with 1
      const updated = [
        ...filtered,
        {
          tag_id: tag.parse_tag_id,
          tag_value_id: 1,
        },
      ];

      setSelectedTagsBySubject((prevSubjects) => ({
        ...prevSubjects,
        [activeSubjectId]: updated,
      }));

      setHasUnsavedChanges(true);
      return updated;
    });
  };

  const [questionFilters, setQuestionFilters] = useState([]);

  const generateFilters = (quesTypeId = 1) => {
    if (!data) return [];

    const courseId = data?.ques_paper_details?.course_id || 0;

    const filters = Object.keys(checkedChaptersByType)
      .filter((chapterId) => checkedChaptersByType[chapterId])
      .map((chapterId) => {
        const topicIds = selectedTopicsByType[chapterId] || [];

        return {
          subject_id: data?.subjects?.[0]?.subject_id, // Update if you handle more subjects
          course_id: courseId,
          chapter_id: [parseInt(chapterId)],
          topic_id: topicIds,
          ques_type_id: [quesTypeId], // e.g. 1 = Single Select
        };
      });

    return filters;
  };

  const scopeRefIds = data?.scopes?.map((scope) => scope.scope_ref_id) || [0];

  const generateFiltersV2 = () => {
    if (!data || !activeSubjectId) return [];

    // const activeSubject = data.subjects.find(
    //   (subj) => subj.subject_id === activeSubjectId
    // );
    // const validChapterIds = new Set(
    //   activeSubject?.chapters?.map((ch) => ch.chapter_id) || []
    // );

    const permittedChapterIds = new Set(
      (chapterData || []).map((ch) => parseInt(ch.chapter_id, 10))
    );
    const activeQuesTypes =
      data.ques_paper_details?.parse_ques_set_ques_type || [];

    const quesTypes = activeQuesTypes
      .map((quesTypeId) => {
        let typeKey = "";
        switch (quesTypeId) {
          case 1:
            typeKey = "single";
            break;
          case 2:
            typeKey = "multi";
            break;
          case 3:
            typeKey = "fill";
            break;
          case 4:
            typeKey = "boolean";
            break;
          default:
            return null;
        }

        const chaptersObj = checkedChaptersByType[typeKey] || {};
        const topicsObj = selectedTopicsByType[typeKey] || {};

        // ✅ Only include real checked chapters that belong to this subject
        // const filteredChapters = Object.entries(chaptersObj)
        //   // .filter(([chapterId, isChecked]) => isChecked && validChapterIds.has(parseInt(chapterId)))
        //   .filter(([, isChecked]) => isChecked)
        //   .map(([chapterId]) => ({
        //     chapter_id: parseInt(chapterId),
        //     topics: topicsObj[chapterId] || []
        //   }));

        const filteredChapters = Object.entries(chaptersObj)
          // keep only chapters checked AND belonging to ACTIVE SUBJECT
          .filter(
            ([chapterId, isChecked]) =>
              isChecked && permittedChapterIds.has(parseInt(chapterId, 10))
          )
          .map(([chapterId]) => {
            const topics = Array.from(
              new Set((topicsObj[chapterId] || []).filter(Boolean))
            );
            return {
              chapter_id: parseInt(chapterId, 10),
              topics,
            };
          });
        // ✅ If no chapters selected, skip this ques_type
        if (filteredChapters.length === 0) return null;

        return {
          ques_type_id: quesTypeId,
          chapters: filteredChapters,
        };
      })
      .filter(Boolean);

    return [
      {
        ques_types: quesTypes,
      },
    ];
  };

  useEffect(() => {
    const filters = generateFilters(1); // or whatever ques_type_id is active
    setQuestionFilters(filters);
  }, [checkedChaptersByType, selectedTopicsByType, data]); // Add dependencies as needed

  const [finalTags, setFinalTags] = useState([]);
  const [finalFilters, setFinalFilters] = useState([]);
  const memoizedTags = useMemo(
    () => selectedTags,
    [JSON.stringify(selectedTags)]
  );
  const memoizedFilters = useMemo(
    () => finalFilters,
    [JSON.stringify(finalFilters)]
  );

  // Auto-generate filters when tags or chapter/topic selections change
  // useEffect(() => {
  //   const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);
  //   if (hasValidTags) {
  //     setFinalTags([...selectedTags]);
  //     setFinalFilters(generateFiltersV2()); // uses activeSubjectId & tag logic
  //   } else {
  //     setFinalTags([]);
  //     setFinalFilters([]);
  //   }
  // }, [selectedTags, checkedChaptersByType, selectedTopicsByType, activeSubjectId]);

  // to track if all topics are loaded on 25/08/2025
  const [allTopicsLoaded, setAllTopicsLoaded] = useState(false);
  // when fetching topics for each chapter
  useEffect(() => {
    if (chapterData.length === 0) return;
    let fetchedCount = 0;
    chapterData.forEach((ch) => {
      fetch(
        `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${ch.chapter_id}`
      )
        .then((res) => res.json())
        .then((data) => {
          // store topics in state (you probably already do this)
          // setTopics(prev => [...prev, ...data])

          fetchedCount++;
          if (fetchedCount === chapterData.length) {
            setAllTopicsLoaded(true); // ✅ fire only after all are loaded
          }
        });
    });
  }, [chapterData]);

  useEffect(() => {
    if (!allTopicsLoaded) return; // ✅ wait until topics for new subject are loaded

    const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);
    setFinalTags(hasValidTags ? [...selectedTags] : []);

    let filters = generateFiltersV2();

    // ✅ Re-check valid chapters/topics for the active subject
    const hasValidFilters = filters?.some((f) =>
      f.ques_types?.some((qt) =>
        qt.chapters?.some(
          (ch) => ch.chapter_id > 0 && ch.topics && ch.topics.length > 0
        )
      )
    );

    if (!hasValidFilters) {
      // 🚫 don’t send dummy filter
      // ✅ wait until subject’s chapter/topic state is ready
      return;
    }

    setFinalFilters(filters);
  }, [
    activeSubjectId, // 🔑 re-run when subject changes
    selectedTags,
    checkedChaptersByType,
    selectedTopicsByType,
    allTopicsLoaded,
  ]);

  const totalChapterQuestionCount = Object.entries(
    difficultyDistributions
  ).reduce((acc, [chapterId, dist]) => {
    if (checkedChaptersByType[chapterId]) {
      return acc + (dist.total || 0);
    }
    return acc;
  }, 0);

  const activeSubject = accessibleSubjects.find(
    (subj) => subj.subject_id === activeSubjectId
  );
  const easyCount = difficultyCount.easy || 0;
  const mediumCount = difficultyCount.medium || 0;
  const toughCount = difficultyCount.tough || 0;
  const totaldiff = easyCount + mediumCount + toughCount;
  const maxBarHeight = 180;
  const maxValue = Math.max(
    activeSubject?.easy || 0,
    activeSubject?.medium || 0,
    activeSubject?.tough || 0,
    1
  );
  const overallRecommended =
    (activeSubject?.easy || 0) +
    (activeSubject?.medium || 0) +
    (activeSubject?.tough || 0);
  const unitHeight = maxBarHeight / maxValue;
  const recommendedEasy = activeSubject?.easy || 0;
  const recommendedMedium = activeSubject?.medium || 0;
  const recommendedTough = activeSubject?.tough || 0;
  const easyBarHeight = recommendedEasy * unitHeight;
  const mediumBarHeight = recommendedMedium * unitHeight;
  const toughBarHeight = recommendedTough * unitHeight;
  const cappedEasyCount = Math.min(easyCount, recommendedEasy);
  // const easyFillHeight = cappedEasyCount * unitHeight;
  const localSelectedRowIds = JSON.parse(
    localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
  );
  const selectedForSubject = localSelectedRowIds[activeSubjectId] || [];
  const selectedCount = selectedForSubject.length;

  const maxFillVisualHeight = 210;
  const easyFillHeight = Math.min(easyCount * unitHeight, maxFillVisualHeight);
  const mediumFillHeight = Math.min(
    mediumCount * unitHeight,
    maxFillVisualHeight
  );
  const cappedMediumCount = Math.min(mediumCount, recommendedMedium);
  // const mediumFillHeight = cappedMediumCount * unitHeight;
  const cappedToughCount = Math.min(toughCount, recommendedTough);
  // const toughFillHeight = cappedToughCount * unitHeight;
  const toughFillHeight = Math.min(
    toughCount * unitHeight,
    maxFillVisualHeight
  );
  const easyBottom = `${easyFillHeight + 22}px`;
  const mediumBottom = `${mediumFillHeight + 22}px`;
  const toughBottom = `${toughFillHeight + 22}px`;
  const allRecommendedZero =
    (activeSubject?.easy || 0) === 0 &&
    (activeSubject?.medium || 0) === 0 &&
    (activeSubject?.tough || 0) === 0;
  const overallRecommendedCount =
    (activeSubject?.easy || 0) +
    (activeSubject?.medium || 0) +
    (activeSubject?.tough || 0);
  const cappedOverallCount =
    cappedEasyCount + cappedMediumCount + cappedToughCount;
  // const overallFillPercent = overallRecommendedCount > 0 ? Math.min((cappedOverallCount / overallRecommendedCount) * 100, 100) : 0;
  // const overallFillPercent = overallRecommendedCount > 0
  // ? Math.min((totaldiff / overallRecommendedCount) * 100, 100)
  // : 0;

  const overallFillPercent =
    overallRecommendedCount > 0
      ? Math.min((selectedCount / overallRecommendedCount) * 100, 100)
      : 0;
  const isSelected = selectedCount > 0; // or !!selectedQuestionId

  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [templateData, setTemplateData] = useState([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      if (!activeSubjectId || isNaN(activeSubjectId)) {
        console.warn("Invalid or missing subject ID. Skipping fetch.");
        return;
      }

      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subject-template-list-by-user/?username=${userName}&client_branch_id=${clientBranchId}&subject_id=${activeSubjectId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        setTemplateData(result?.data?.template_list || []);
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };
    fetchTemplates();
  }, [activeSubjectId]);

  useEffect(() => {
    if (
      selectedTemplateId === null ||
      selectedTemplateId === "" ||
      selectedTemplateId === undefined
    ) {
      setTemplateDetailData(null);
      setSelectedTags([]);
      setFinalTags([]); // Clear tags from memoized filters
      setFinalFilters([]); // ✅ Explicitly clear filters here

      // Also reset chapter/topic selections
      setCheckedChaptersByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });
      setSelectedTopicsByType({ single: {}, multi: {}, fill: {}, boolean: {} });
      setExpandedChaptersByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });

      // Reset any fixed topic counts
      setFixedTopicCountsByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });
      setFixedTopicEnabledByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });
    }
  }, [selectedTemplateId]);

  // const handleSectionInstructionChange = (sectionLabel, value) => {
  //   setSectionInstructions((prev) => ({
  //     ...prev,
  //     [sectionLabel]: value,
  //   }));
  // };

  const handleSectionInstructionChange = (sectionLabel, value) => {
    setSectionInstructions((prev) => ({
      ...prev,
      [`${activeSubjectId}_${sectionLabel}`]: value,
    }));
  };

  const [showTemplatePopup, setShowTemplatePopup] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [templateDesc, setTemplateDesc] = useState("");
  const [templateNameError, setTemplateNameError] = useState(false);
  const [templateDescError, setTemplateDescError] = useState(false);
  const [templatePopupError, setTemplatePopupError] = useState("");

  const handleSaveQuestionPaper = async (
    status = 2,
    skipDifficultyCheck = false
  ) => {
    if (!data) return;
    // Validation function (only run for Final save)
    const validateBeforeSave = () => {
      const localSelectedRowIds = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const localSectionMap = JSON.parse(
        localStorage.getItem("subjectWiseSectionMap") || "{}"
      );

      const selectedIds = localSelectedRowIds[activeSubjectId] || [];
      const sectionMap = localSectionMap[activeSubjectId] || {};

      const unassignedIds = selectedIds.filter((id) => !sectionMap[id]);

      if (unassignedIds.length > 0) {
        return `${unassignedIds.length} question(s) do not have a section assigned.`;
      }

      if (selectedSections > 1) {
        for (let i = 0; i < selectedSections; i++) {
          const sectionLabel =
            selecteSectionTypeID === 2
              ? `${i + 1}`
              : String.fromCharCode(65 + i);
          const countInSection =
            sectionWiseQuestions[sectionLabel]?.length || 0;
          if (countInSection === 0) {
            return `Section ${sectionLabel} has no questions selected.`;
          }
        }
      }

      for (const [type, chapters] of Object.entries(fixedTopicEnabledByType)) {
        for (const [chapId, isEnabled] of Object.entries(chapters)) {
          if (isEnabled) {
            const topics = fixedTopicCountsByType[type][chapId];
            for (const [topicId, fixedCount] of Object.entries(topics)) {
              const actualCount = selectedQuestions.filter(
                (q) => q.topic_id === parseInt(topicId)
              ).length;
              if (actualCount !== fixedCount) {
                return `Topic ${topicId} fixed count mismatch (Fixed: ${fixedCount}, Selected: ${actualCount}).`;
              }
            }
          }
        }
      }

      const chapterCounts = {};
      const topicCounts = {};

      selectedQuestions.forEach((q) => {
        chapterCounts[q.chapter_id] = (chapterCounts[q.chapter_id] || 0) + 1;
        topicCounts[q.topic_id] = (topicCounts[q.topic_id] || 0) + 1;
      });

      const totalChapterCount = Object.values(chapterCounts).reduce(
        (a, b) => a + b,
        0
      );
      const totalTopicCount = Object.values(topicCounts).reduce(
        (a, b) => a + b,
        0
      );

      if (totalChapterCount !== totalTopicCount) {
        return `Total chapter count (${totalChapterCount}) does not match total topic count (${totalTopicCount}).`;
      }

      if (selectedSections > 0) {
        const localQuesTypeMap =
          JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds") || "{}")[
            activeSubjectId
          ] || {};

        for (let i = 0; i < selectedSections; i++) {
          const sectionLabel =
            selecteSectionTypeID === 2
              ? `${i + 1}`
              : String.fromCharCode(65 + i);
          const sectionKey = sectionLabel;
          const questionsInSection = sectionWiseQuestions[sectionLabel] || [];
          const sectionData =
            sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
          const expectedTypeId = sectionData?.section_question_type_id;

          if (!expectedTypeId) continue;

          const mismatchedQuesIds = questionsInSection
            .map((question) => {
              const qid =
                question.id ||
                question.ques_id ||
                question.parse_ques_set_question_id;
              const actualTypeId = parseInt(localQuesTypeMap[qid]);
              return actualTypeId !== expectedTypeId ? qid : null;
            })
            .filter(Boolean); // remove nulls

          if (mismatchedQuesIds.length > 0) {
            const readableType = questionTypeMap[expectedTypeId] || "Unknown";
            return `Only "${readableType}" type questions are permitted in Section ${sectionLabel} for this test series. Please check the Question Type column and update the section.`;
          }
        }
      }

      // ✅ Final validation: total selected vs total expected
      // if (selectedSections > 0) {
      //   for (let i = 0; i < selectedSections; i++) {
      //     const sectionLabel = selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
      //     const sectionKey = sectionLabel;
      //     const questionsInSection = sectionWiseQuestions[sectionLabel] || [];
      //     const sectionData = sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];

      //     if (sectionData) {
      //       const expectedTotal = sectionData.total_ques_cnt || 0;
      //       if (questionsInSection.length !== expectedTotal) {
      //         return `Section ${sectionLabel}: Selected ${questionsInSection.length} of ${expectedTotal} questions.`;
      //       }
      //     }
      //   }}

      // ✅ Final validation: total selected vs total expected
      if (selectedSections > 0) {
        for (let i = 0; i < selectedSections; i++) {
          const sectionLabel =
            selecteSectionTypeID === 2
              ? `${i + 1}`
              : String.fromCharCode(65 + i);
          const questionsInSection = sectionWiseQuestions[sectionLabel] || [];

          if (data?.ques_paper_details?.ques_paper_type === 2) {
            // 🔹 TEST validation (per-section totals)
            const sectionData =
              sectionDetailsPerSubject?.[activeSubjectId]?.[sectionLabel];
            if (sectionData) {
              const expectedTotal = sectionData.total_ques_cnt || 0;
              if (questionsInSection.length !== expectedTotal) {
                return `Section ${sectionLabel}: Selected ${questionsInSection.length} of ${expectedTotal} questions.`;
              }
            }
          } else if (data?.ques_paper_details?.ques_paper_type === 1) {
            // 🔹 DPP validation (sum of easy+medium+tough)
            const expectedTotal =
              (activeSubject?.easy || 0) +
              (activeSubject?.medium || 0) +
              (activeSubject?.tough || 0);

            if (
              expectedTotal > 0 &&
              questionsInSection.length !== expectedTotal
            ) {
              return `Section ${sectionLabel}: Selected ${questionsInSection.length} of ${expectedTotal} questions.`;
            }
          }
        }
      }

      return null;
    };

    // 🛑 Run validation only if FINAL SAVE (status 2)
    if (status === 2) {
      const error = validateBeforeSave();
      if (error) {
        setMessageBox(
          <div>
            <p style={{ margin: "4px 0" }}>{error}</p>
          </div>
        );
        setActiveImg(ErrorIcon);
        setIsMessageBoxVisible(true);
        return; // ❌ Stop if error found
      }

      // ⚠️ Difficulty mismatch warning (do not block, just confirm)
      const recommendedEasy = activeSubject?.easy || 0;
      const recommendedMedium = activeSubject?.medium || 0;
      const recommendedTough = activeSubject?.tough || 0;

      const selectedEasy = difficultyCount.easy || 0;
      const selectedMedium = difficultyCount.medium || 0;
      const selectedTough = difficultyCount.tough || 0;

      if (!skipDifficultyCheck) {
        if (
          selectedEasy !== recommendedEasy ||
          selectedMedium !== recommendedMedium ||
          selectedTough !== recommendedTough
        ) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span style={{ whiteSpace: "nowrap" }}>
                  Recommended counts (Easy: {recommendedEasy}, Medium:{" "}
                  {recommendedMedium}, Tough: {recommendedTough}) do not match
                  your selection (Easy: {selectedEasy}, Medium: {selectedMedium}
                  , Tough: {selectedTough}). Do you still want to proceed?
                </span>
              </div>
              <div
                className="messagebox-insider2"
                style={{ display: "flex", gap: "10px", marginTop: "10px" }}
              >
                <button
                  className="messagebox-cancel-btn-ok"
                  onClick={() => {
                    setIsMessageBoxVisible(false);
                    handleSaveQuestionPaper(2, true); // ✅ now skipDifficultyCheck = true
                  }}
                >
                  YES
                </button>
                <button
                  className="messagebox-cancel-btn-ok"
                  onClick={() => setIsMessageBoxVisible(false)}
                >
                  NO
                </button>
              </div>
            </div>
          );
          setActiveImg(WarnningIcon);
          setIsMessageBoxVisible(true);
          setNoTimeSet(true);
          return; // 🛑 Stop here until user clicks YES
        }
      }

      const localSelectedRowIds = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const localSectionMap = JSON.parse(
        localStorage.getItem("subjectWiseSectionMap") || "{}"
      );

      const selectedIds = localSelectedRowIds[activeSubjectId] || [];
      const sectionMap = localSectionMap[activeSubjectId] || {};

      const unassignedIds = selectedIds.filter((id) => !sectionMap[id]);

      if (unassignedIds.length > 0) {
        setMessageBox(
          <div>
            <p>{`${unassignedIds.length} question(s) do not have a section assigned.`}</p>
          </div>
        );
        setActiveImg(ErrorIcon);
        setIsMessageBoxVisible(true);
        return; // Stop save
      }
    }

    // ✅ After here = Save logic for both Draft and Final
    let questionsPayload = [];
    const quesTypeMapping = {
      "Single Correct MCQ": 1,
      "Multi Correct MCQ": 2,
      "Fill in the blanks": 3,
      "True/False": 4,
    };

    if (status === 1) {
      const subjectWise = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const quesTypeLocal = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const deletedData = JSON.parse(
        localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
      );

      const selectedIdsArray = subjectWise[activeSubjectId] || [];
      const selectedIdsSet = new Set(selectedIdsArray);
      const localTypeMap = quesTypeLocal[activeSubjectId] || {};
      const deletedIdsArray = deletedData[activeSubjectId] || [];

      const allQuesMap = new Map();

      // Step 1️⃣: Add selected questions from localStorage with status 1
      selectedIdsArray.forEach((quesId, index) => {
        const matchedRow = reportDashboardData.find((row) => row[1] === quesId); // row[1] = Ques ID
        const quesTypeText = matchedRow?.[3]; // row[3] = Ques Type string
        const fallbackQuesTypeId = quesTypeMapping[quesTypeText] || null;
        const quesTypeId = localTypeMap[quesId] || fallbackQuesTypeId;

        let sectionName = null;
        for (const [sectionLabel, questions] of Object.entries(
          sectionWiseQuestions
        )) {
          if (
            questions.find(
              (q) => q.id === quesId || q.parse_ques_set_question_id === quesId
            )
          ) {
            sectionName = sectionLabel;
            break;
          }
        }

        allQuesMap.set(quesId, {
          parse_ques_set_question_id: quesId,
          org_ques_position: index + 1,
          status: 1,
          section_name: sectionName,
          ques_type_id: quesTypeId,
          added_by: userName,
          removed_by: userName,
        });
      });

      // Step 2️⃣: Add non-selected questions from reportDashboardData with status 0
      reportDashboardData.forEach((row, index) => {
        const quesId = row[0];
        if (allQuesMap.has(quesId)) return;

        const quesTypeText = row[2]; // Question type
        const fallbackQuesTypeId = quesTypeMapping[quesTypeText] || null;

        allQuesMap.set(quesId, {
          parse_ques_set_question_id: quesId,
          org_ques_position: index + 1,
          status: 0,
          section_name: null,
          ques_type_id: fallbackQuesTypeId,
          added_by: userName,
          removed_by: userName,
        });
      });

      // Step 3️⃣: Add missing deleted question IDs with status 2
      deletedIdsArray.forEach((quesId, index) => {
        if (!allQuesMap.has(quesId)) {
          const quesTypeId = localTypeMap[quesId] || null;

          allQuesMap.set(quesId, {
            parse_ques_set_question_id: quesId,
            org_ques_position: selectedIdsArray.length + index + 1,
            status: 2,
            section_name: null,
            ques_type_id: 0,
            added_by: userName,
            removed_by: userName,
          });
        } else {
          const existing = allQuesMap.get(quesId);
          existing.status = 2; // Override if already added
        }
      });
      questionsPayload = Array.from(allQuesMap.values());
    } else {
      const subjectWise = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const quesTypeLocal = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const deletedData = JSON.parse(
        localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
      );

      const selectedIds = subjectWise[activeSubjectId] || [];
      const localTypeMap = quesTypeLocal[activeSubjectId] || {};
      const deletedIdsArray = deletedData[activeSubjectId] || [];

      const allQuesMap = new Map();

      // ✅ Step 1: Selected questions with status 1
      selectedIds.forEach((quesId, index) => {
        const quesTypeStr = localTypeMap[quesId] || "Single Correct MCQ"; // fallback
        const quesTypeId = quesTypeMapping[quesTypeStr] || 1;

        let sectionName = null;
        for (const [sectionLabel, questions] of Object.entries(
          sectionWiseQuestions
        )) {
          if (
            questions.find(
              (q) => q.id === quesId || q.parse_ques_set_question_id === quesId
            )
          ) {
            sectionName = sectionLabel;
            break;
          }
        }

        allQuesMap.set(quesId, {
          parse_ques_set_question_id: quesId,
          org_ques_position: index + 1,
          status: 1,
          section_name: sectionName,
          ques_type_id: quesTypeId,
          added_by: userName,
          removed_by: userName,
        });
      });

      // ✅ Step 2: Deleted questions with status 2
      deletedIdsArray.forEach((quesId, index) => {
        if (!allQuesMap.has(quesId)) {
          const quesTypeStr = localTypeMap[quesId] || "Single Correct MCQ";
          const quesTypeId = quesTypeMapping[quesTypeStr] || 1;

          allQuesMap.set(quesId, {
            parse_ques_set_question_id: quesId,
            org_ques_position: selectedIds.length + index + 1,
            status: 2,
            section_name: null,
            ques_type_id: quesTypeId,
            added_by: userName,
            removed_by: userName,
          });
        } else {
          const existing = allQuesMap.get(quesId);
          existing.status = 2; // overwrite status
        }
      });
      questionsPayload = Array.from(allQuesMap.values());
    }
    const activeQuesTypeIds =
      data?.ques_paper_details?.parse_ques_set_ques_type || [];
    const payload = {
      ques_paper_id: parseInt(questionPaperId),
      // subjects: accessibleSubjects
      //   .filter((subject) => {
      //     const draftStatus = draftData?.subjects?.find((d) => d.subject_id === subject.subject_id)?.status;
      //     if (!subject.isAccessible) return false;
      //     if (status === 1) return draftStatus !== 2; // ✅ Only save draft if not already submitted
      //     if (status === 2) return subject.subject_id === activeSubjectId;
      //     return true;
      //   })
      subjects: accessibleSubjects
        .filter(
          (subject) =>
            subject.subject_id === activeSubjectId && subject.isAccessible
        )
        .map((subject, index) => {
          const subjectId = subject.subject_id;
          const subjectChapterIds = new Set(
            subject.chapters.map((c) => c.chapter_id)
          );
          // ✅ Use subject-specific section settings
          const settings = sectionSettingsBySubject[subjectId] || {};
          const selectedSectionsLocal = settings.selectedSections || 1;
          const excludeRepeatCountLocal = settings.excludeRepeatCount || 0;
          const sectionTypeLocal = settings.selecteSectionTypeID || 1;
          // const ques_types = activeQuesTypeIds.map((ques_type_id) => {
          //   const typeKey = ques_type_id === 1 ? "single" : ques_type_id === 2 ? "multi" : ques_type_id === 3 ? "fill" : "boolean";
          //   const chaptersObj = checkedChaptersByType[typeKey] || {};
          //   const topicsObj = selectedTopicsByType[typeKey] || {};
          //   const fixedCounts = fixedTopicCountsByType[typeKey] || {};
          //   const difficulty = difficultyDistributions[typeKey] || {};
          //   const chapters = Object.entries(chaptersObj)
          //     .filter(([chapterId, isChecked]) => isChecked && subjectChapterIds.has(parseInt(chapterId)))
          //     .map(([chapterId]) => {
          //       const chapterIdNum = parseInt(chapterId); const selectedTopics = topicsObj[chapterId] || [];
          //       return {
          //         chapter_id: chapterIdNum,
          //         chapter_ques_cnt: difficulty[chapterId]?.total || 0,
          //         easy: difficulty[chapterId]?.firstSegment || 0,
          //         medium: difficulty[chapterId]?.secondSegment || 0,
          //         tough: difficulty[chapterId]?.calculatedValue || 0,
          //         topic: selectedTopics.map((tid) => ({
          //           topic_id: tid,
          //           topic_fix_ques_cnt: fixedCounts?.[chapterId]?.[tid] || 0,
          //         })),
          //       };
          //     });

          //   return {
          //     ques_type_id,
          //     chapters,
          //   };
          // });

          const ques_types = activeQuesTypeIds.map((ques_type_id) => {
            const typeKey =
              ques_type_id === 1
                ? "single"
                : ques_type_id === 2
                ? "multi"
                : ques_type_id === 3
                ? "fill"
                : "boolean";
            const chaptersObj = checkedChaptersByType[typeKey] || {};
            const topicsObj = selectedTopicsByType[typeKey] || {};
            const fixedCounts = fixedTopicCountsByType[typeKey] || {};
            const difficulty = difficultyDistributions[typeKey] || {};

            const permittedChapterIds = new Set(
              (chapterData || []).map((ch) => parseInt(ch.chapter_id, 10))
            );
            // const chapters = Object.entries(chaptersObj)
            //   .filter(([chapterId, isChecked]) => isChecked) // ✅ keep ALL the chapters the user selected
            const chapters = Object.entries(chaptersObj)
              .filter(
                ([chapterId, isChecked]) =>
                  isChecked && permittedChapterIds.has(parseInt(chapterId, 10))
              )
              .map(([chapterId]) => {
                const chapterIdNum = parseInt(chapterId);
                const selectedTopics = topicsObj[chapterId] || [];
                return {
                  chapter_id: chapterIdNum,
                  chapter_ques_cnt: difficulty[chapterId]?.total || 0,
                  easy: difficulty[chapterId]?.firstSegment || 0,
                  medium: difficulty[chapterId]?.secondSegment || 0,
                  tough: difficulty[chapterId]?.calculatedValue || 0,
                  topic: selectedTopics.map((tid) => ({
                    topic_id: tid,
                    topic_fix_ques_cnt: fixedCounts?.[chapterId]?.[tid] || 0,
                  })),
                };
              });

            return { ques_type_id, chapters };
          });

          const getSubjectPosition = (subjectId) => {
            const position = data.subjects.findIndex(
              (subj) => subj.subject_id === subjectId
            );
            return position >= 0 ? position + 1 : null; // add 1 to make it 1-based index
          };
          return {
            subject_id: subjectId,
            no_of_sections: selectedSectionsLocal,
            exclude_repeat_n_times: excludeRepeatCountLocal,
            ques_paper_user_template_id: selectedTemplateId,
            status,
            user_name: userName,
            org_subject_position: getSubjectPosition(subjectId),
            ques_types,
            parse_tags: (selectedTagsBySubject[subjectId] || [])
              .filter(
                (tag) =>
                  tag.tag_value_id !== null && tag.tag_value_id !== undefined
              )
              .map((tag) => ({
                parse_tag_id: tag.tag_id,
                parse_tag_value_id: tag.tag_value_id,
              })),
            // sections: [...Array(selectedSectionsLocal)].map((_, secIndex) => {
            //   const sectionLabel =
            //     sectionTypeLocal === 2
            //       ? `${secIndex + 1}`
            //       : String.fromCharCode(65 + secIndex);
            //   return {
            //     section_name: sectionLabel,
            //     section_instruction: sectionInstructions[sectionLabel] || "",
            //   };
            // }),

            sections: [...Array(selectedSectionsLocal)].map((_, secIndex) => {
              const sectionLabel =
                sectionTypeLocal === 2
                  ? `${secIndex + 1}`
                  : String.fromCharCode(65 + secIndex);
              return {
                section_name: sectionLabel,
                section_instruction:
                  sectionInstructions[`${subjectId}_${sectionLabel}`] || "",
              };
            }),
            questions: questionsPayload,
          };
        }),
    };
    setIsSaving(true);
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/create-ques-paper-by-assignee/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      // Handle non-JSON responses on error on 25/09/2025
      // if (!response.ok || (result && result.status && result.status == 500)) {
      //   const serverMsg = (result && (result.message || result.detail)) || "";
      //   const hardText = "Save failed due to a server error. Please try again or contact the administrator.";
      //   setMessageBox(
      //     <div className="Container-messageBOX">
      //       <div className="messagebox-insider1">
      //         <div className="loader-tc"></div>
      //         <span>
      //           {hardText}
      //           {serverMsg ? (
      //             <>
      //               <br />
      //               <small style={{ opacity: 0.8 }}>
      //                 Details: {serverMsg}
      //               </small>
      //             </>
      //           ) : null}
      //         </span>
      //       </div>
      //     </div>
      //   );
      //   setActiveImg(ErrorIcon);
      //   setIsMessageBoxVisible(true);
      //   return; // 🚫 stop here on error
      // }
      const result = await response.json();
      if (response.ok) {
        if (status === 2) {
          setSubjectStatusById((prev) => ({
            ...prev,
            [activeSubjectId]: 2,
          }));

          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  Question paper submitted successfully. Do you want to save
                  this as a template?
                </span>
              </div>
              <div
                className="messagebox-insider2"
                style={{ display: "flex", gap: "10px", marginTop: "10px" }}
              >
                <button
                  className="messagebox-cancel-btn-ok"
                  onClick={() => {
                    setIsMessageBoxVisible(false);
                    setShowTemplatePopup(true);
                  }}
                >
                  YES
                </button>
                <button
                  className="messagebox-cancel-btn-ok"
                  onClick={() => {
                    setIsMessageBoxVisible(false);
                    localStorage.removeItem("subjectWiseSelectedRowIds");
                    localStorage.removeItem("subjectWiseDeletedRowIds");
                    localStorage.removeItem("subjectWiseQuesTypeIds");
                    localStorage.removeItem("subjectWiseSectionMap");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                    //  navigate("/DashboardCreateQuestionpaper");
                  }}
                >
                  NO
                </button>
              </div>
            </div>
          );
          setActiveImg(InfoIcon);
          setIsMessageBoxVisible(true);
          setNoTimeSet(true);
        } else {
          setSubjectStatusById((prev) => ({
            ...prev,
            [activeSubjectId]: 1,
          }));

          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Question paper saved as draft!</span>
              </div>
            </div>
          );
          setActiveImg(InfoIcon);
          setHasUnsavedChanges(false);
          setNoTimeSet(false);
        }
        // localStorage.removeItem("selectedRowIds");
        const subjectWise = JSON.parse(
          localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
        );
        // delete subjectWise[activeSubjectId];
        localStorage.setItem(
          "subjectWiseSelectedRowIds",
          JSON.stringify(subjectWise)
        );
        // localStorage.removeItem("subjectWiseDeletedRowIds");
      }
    } catch (error) {
      console.error("Error while saving:", error);
      setMessageBox("Something went wrong while saving.");
      setIsMessageBoxVisible(true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCreateTemplate = async () => {
    const isNameEmpty = !templateName.trim();
    const isDescEmpty = !templateDesc.trim();
    setTemplateNameError(isNameEmpty);
    setTemplateDescError(isDescEmpty);
    if (isNameEmpty || isDescEmpty) return;

    try {
      const encodedName = encodeURIComponent(templateName);
      const encodedDesc = encodeURIComponent(templateDesc);
      const templateURL = `${FULL_API_BASE_URL}/create-subject-template-by-user/?ques_paper_id=${questionPaperId}&question_paper_subject_id=${activeSubjectId}&ques_paper_subject_template_name=${encodedName}&ques_paper_subject_template_desc=${encodedDesc}&client_branch_id=${clientBranchId}&username=${userName}`;

      const response = await fetch(templateURL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Template created successfully!</span>
            </div>
          </div>
        );
        setShowTemplatePopup(false);
        // 🔽 Remove localStorage items
        localStorage.removeItem("subjectWiseSelectedRowIds");
        localStorage.removeItem("subjectWiseDeletedRowIds");
        localStorage.removeItem("subjectWiseQuesTypeIds");
        localStorage.removeItem("subjectWiseSectionMap");

        setTimeout(() => window.location.reload(), 1000);
      } else if (
        result.status === 404 &&
        result.message?.toLowerCase().includes("already exists")
      ) {
        setTemplatePopupError(result.message);
      } else {
        throw new Error(result.message || "Unexpected error");
      }
    } catch (error) {
      console.error("Template creation failed:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message || "Failed to create template"}</span>
          </div>
        </div>
      );
      setActiveImg(InfoIcon);
    }
  };

  const [templateDetailData, setTemplateDetailData] = useState(null);

  useEffect(() => {
    const fetchTemplateDetails = async () => {
      if (!selectedTemplateId) return;
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subject-template-details-by-template-id?ques_paper_subject_template_id=${selectedTemplateId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const result = await response.json();
        const submittedStatus =
          draftData?.subjects?.find(
            (subj) => subj.subject_id === activeSubjectId
          )?.status === 2;
        if (
          (!response.ok || !result?.data?.subjects?.length) &&
          !submittedStatus
        ) {
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  No data found in the selected template. Please choose a
                  different template.
                </span>
              </div>
            </div>
          );
          setActiveImg(WarnningIcon);
          return;
        }
        const templateData = result?.data;

        if (templateData) {
          setTemplateDetailData(result);

          // ✅ Sections & repeat count
          if (!draftInitialized) {
            setSelectedSections(templateData.no_of_sections || 1);
            if (!excludeRepeatEdited) {
              setExcludeRepeatCount(templateData.exclude_repeat_n_times || 0);
            }
          }

          // ✅ Tags
          if (templateData.subjects?.[0]?.tags) {
            const formattedTags = templateData.subjects[0].tags.map((tag) => ({
              tag_id: tag.parse_tag_id,
              tag_value_id: tag.parse_tag_value_id,
            }));
            setSelectedTags(formattedTags);
          }

          // ✅ Chapters/Topics per question type
          const updatedChecked = {
            single: {},
            multi: {},
            fill: {},
            boolean: {},
          };
          const updatedExpanded = {
            single: {},
            multi: {},
            fill: {},
            boolean: {},
          };
          const updatedTopics = {
            single: {},
            multi: {},
            fill: {},
            boolean: {},
          };
          const updatedFixed = { single: {}, multi: {}, fill: {}, boolean: {} };
          const fixedEnabled = { single: {}, multi: {}, fill: {}, boolean: {} };

          const quesTypeMap = {
            1: "single",
            2: "multi",
            3: "fill",
            4: "boolean",
          };

          for (const quesTypeData of templateData.subjects[0]
            ?.chapter_topic_structure || []) {
            const typeKey = quesTypeMap[quesTypeData.parse_ques_set_ques_type];
            if (!typeKey) continue;

            for (const chapter of quesTypeData.chapters || []) {
              const chapId = chapter.chapter_id;
              updatedChecked[typeKey][chapId] = true;
              updatedExpanded[typeKey][chapId] = true;

              const topicIds = chapter.topics?.map((t) => t.topic_id) || [];
              updatedTopics[typeKey][chapId] = topicIds;

              const fixedMap = {};
              let anyFixed = false;

              chapter.topics?.forEach((t) => {
                if (t.topic_ques_cnt > 0) {
                  fixedMap[t.topic_id] = t.topic_ques_cnt;
                  anyFixed = true;
                }
              });

              if (anyFixed) {
                updatedFixed[typeKey][chapId] = fixedMap;
                fixedEnabled[typeKey][chapId] = true;
              }
            }
          }

          // ✅ Update all the states
          setCheckedChaptersByType((prev) => ({ ...prev, ...updatedChecked }));
          setExpandedChaptersByType((prev) => ({
            ...prev,
            ...updatedExpanded,
          }));
          setSelectedTopicsByType((prev) => ({ ...prev, ...updatedTopics }));
          setFixedTopicCountsByType((prev) => ({ ...prev, ...updatedFixed }));
          setFixedTopicEnabledByType((prev) => ({ ...prev, ...fixedEnabled }));
        }
      } catch (error) {
        console.error("Error fetching template details:", error);
      }
    };
    fetchTemplateDetails();
  }, [selectedTemplateId, draftInitialized, excludeRepeatEdited]);

  useEffect(() => {
    if (draftData && draftData.subjects?.length > 0) {
      const firstSubject = draftData.subjects[0];

      if (typeof firstSubject.no_of_sections === "number") {
        setSectionsTypeID(firstSubject.no_of_sections);
        setSelectedSections(firstSubject.no_of_sections);
      }

      // ✅ Insert the following here:
      const draftSectionSettings = {};
      draftData.subjects.forEach((subject) => {
        draftSectionSettings[subject.subject_id] = {
          selectedSections: subject.no_of_sections ?? 1,
          excludeRepeatCount: subject.exclude_repeat_n_times ?? 0,
          selecteSectionTypeID:
            subject.section_naming_type !== undefined
              ? subject.section_naming_type
              : sectionSettingsBySubject[subject.subject_id]
                  ?.selecteSectionTypeID ?? 1,
        };
      });

      setSectionSettingsBySubject((prev) => ({
        ...prev,
        ...draftSectionSettings,
      }));

      // ✅ Then your existing tag logic (if any) can follow
      const tagsBySubject = {};
      draftData.subjects.forEach((subject) => {
        if (subject.parse_tags?.length > 0) {
          tagsBySubject[subject.subject_id] = subject.parse_tags.map((tag) => ({
            tag_id: tag.parse_tag_id,
            tag_value_id: tag.parse_tag_value_id,
          }));
        }
      });
      setSelectedTagsBySubject(tagsBySubject);

      if (activeSubjectId) {
        setSelectedTags(tagsBySubject[activeSubjectId] || []);
      } else {
        setSelectedTags(tagsBySubject[firstSubject.subject_id] || []);
      }
    }
  }, [draftData, activeSubjectId]);

  // deep-merge helpers that preserve existing selections
  const mergeShallow = (a = {}, b = {}) => ({ ...a, ...b });
  const mergeTypeMap = (oldMap = {}, newMap = {}) => ({
    single: mergeShallow(oldMap.single, newMap.single),
    multi: mergeShallow(oldMap.multi, newMap.multi),
    fill: mergeShallow(oldMap.fill, newMap.fill),
    boolean: mergeShallow(oldMap.boolean, newMap.boolean),
  });

  // REMPVE topicData DEPENDENCY FROM BELOW
  useEffect(() => {
    if (!draftData || !topicData || !data) return;

    const draftSubjects = draftData.subjects || [];
    const layoutSubjects = data.subjects || [];

    // ✅ Use only draft data if available
    if (draftSubjects.length === 0) return;

    const quesTypeMap = {
      1: "single",
      2: "multi",
      3: "fill",
      4: "boolean",
    };

    const updatedChecked = { single: {}, multi: {}, fill: {}, boolean: {} };
    const updatedExpanded = { single: {}, multi: {}, fill: {}, boolean: {} };
    const updatedTopics = { single: {}, multi: {}, fill: {}, boolean: {} };
    const updatedFixed = { single: {}, multi: {}, fill: {}, boolean: {} };
    const fixedEnabled = { single: {}, multi: {}, fill: {}, boolean: {} };

    draftSubjects.forEach((subject) => {
      subject.ques_types.forEach((qt) => {
        const typeKey = quesTypeMap[qt.ques_type_id];
        if (!typeKey) return;

        qt.chapters.forEach((chapter) => {
          const chapId = chapter.chapter_id;
          updatedChecked[typeKey][chapId] = true;
          updatedExpanded[typeKey][chapId] = true;

          const topicIds = chapter.topic.map((t) => t.topic_id);
          updatedTopics[typeKey][chapId] = topicIds;

          const fixedMap = {};
          let anyFixed = false;

          chapter.topic.forEach((t) => {
            if (t.topic_fix_ques_cnt > 0) {
              fixedMap[t.topic_id] = t.topic_fix_ques_cnt;
              anyFixed = true;
            }
          });

          if (anyFixed) {
            updatedFixed[typeKey][chapId] = fixedMap;
            fixedEnabled[typeKey][chapId] = true;
          }
        });
      });
    });

    // setCheckedChaptersByType((prev) => ({ ...prev, ...updatedChecked }));
    // setExpandedChaptersByType((prev) => ({ ...prev, ...updatedExpanded }));
    // setSelectedTopicsByType((prev) => ({ ...prev, ...updatedTopics }));
    setFixedTopicCountsByType((prev) => ({ ...prev, ...updatedFixed }));
    setFixedTopicEnabledByType((prev) => ({ ...prev, ...fixedEnabled }));
    setCheckedChaptersByType((prev) => mergeTypeMap(prev, updatedChecked));
    setSelectedTopicsByType((prev) => mergeTypeMap(prev, updatedTopics));
    // setExpandedChaptersByType((prev) => mergeTypeMap(prev, updatedExpanded));
  }, [draftData, data]);

  const previousErrorsRef = useRef([]);
  const handleValidate = () => {
    const currentErrors = [];

    // Recommended counts
    const recommendedEasy = activeSubject?.easy || 0;
    const recommendedMedium = activeSubject?.medium || 0;
    const recommendedTough = activeSubject?.tough || 0;

    const selectedEasy = difficultyCount.easy || 0;
    const selectedMedium = difficultyCount.medium || 0;
    const selectedTough = difficultyCount.tough || 0;

    const totalRecommended =
      recommendedEasy + recommendedMedium + recommendedTough;
    const totalSelected = selectedEasy + selectedMedium + selectedTough;

    if (totalRecommended !== totalSelected) {
      currentErrors.push(
        `Total recommended (${totalRecommended}) questions do not match selected questions (${totalSelected}).`
      );
    }

    if (recommendedEasy > 0 && selectedEasy !== recommendedEasy) {
      currentErrors.push(
        `Easy question count mismatch (Recommended: ${recommendedEasy}, Selected: ${selectedEasy}).`
      );
    }

    if (recommendedMedium > 0 && selectedMedium !== recommendedMedium) {
      currentErrors.push(
        `Medium question count mismatch (Recommended: ${recommendedMedium}, Selected: ${selectedMedium}).`
      );
    }

    if (recommendedTough > 0 && selectedTough !== recommendedTough) {
      currentErrors.push(
        `Tough question count mismatch (Recommended: ${recommendedTough}, Selected: ${selectedTough}).`
      );
    }

    const unassignedQuestions = selectedQuestions.filter(
      (q) => !q.section_name
    );
    if (unassignedQuestions.length > 0) {
      currentErrors.push(
        `${unassignedQuestions.length} question(s) do not have a section assigned.`
      );
    }

    if (selectedSections > 1) {
      for (let i = 0; i < selectedSections; i++) {
        const sectionLabel =
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
        const countInSection = sectionWiseQuestions[sectionLabel]?.length || 0;
        if (countInSection === 0) {
          currentErrors.push(
            `Section ${sectionLabel} has no questions selected.`
          );
        }
      }
    }

    if (selectedSections > 1) {
      for (let i = 0; i < selectedSections; i++) {
        const sectionLabel =
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
        const countInSection = sectionWiseQuestions[sectionLabel]?.length || 0;

        const sectionKey = `Section ${sectionLabel}`;
        const sectionData =
          sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
        const mandatoryCount = sectionData?.mandatory_ques_cnt || 0;
        const totalCount = sectionData?.total_ques_cnt || 0;

        if (countInSection === 0) {
          currentErrors.push(
            `Section ${sectionLabel} has no questions selected.`
          );
        }

        if (countInSection !== totalCount && totalCount > 0) {
          currentErrors.push(
            `Section ${sectionLabel}: Selected ${countInSection} of ${totalCount} questions. Mandatory count is ${mandatoryCount}.`
          );
        }
      }
    }

    Object.entries(fixedTopicEnabledByType).forEach(([type, chapters]) => {
      Object.entries(chapters).forEach(([chapId, isEnabled]) => {
        if (isEnabled) {
          const topics = fixedTopicCountsByType[type][chapId];
          Object.entries(topics).forEach(([topicId, fixedCount]) => {
            const actualCount = selectedQuestions.filter(
              (q) => q.topic_id === parseInt(topicId)
            ).length;
            if (actualCount !== fixedCount) {
              currentErrors.push(
                `Topic ${topicId} fixed count mismatch (Fixed: ${fixedCount}, Selected: ${actualCount}).`
              );
            }
          });
        }
      });
    });

    const chapterCounts = {};
    const topicCounts = {};

    selectedQuestions.forEach((q) => {
      chapterCounts[q.chapter_id] = (chapterCounts[q.chapter_id] || 0) + 1;
      topicCounts[q.topic_id] = (topicCounts[q.topic_id] || 0) + 1;
    });

    const totalChapterCount = Object.values(chapterCounts).reduce(
      (a, b) => a + b,
      0
    );
    const totalTopicCount = Object.values(topicCounts).reduce(
      (a, b) => a + b,
      0
    );

    if (totalChapterCount !== totalTopicCount) {
      currentErrors.push(
        `Total chapter count (${totalChapterCount}) does not match total topic count (${totalTopicCount}).`
      );
    }

    if (selectedSections > 0) {
      const localQuesTypeMap =
        JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds") || "{}")[
          activeSubjectId
        ] || {};

      for (let i = 0; i < selectedSections; i++) {
        const sectionLabel =
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
        const sectionKey = `Section ${sectionLabel}`;
        const sectionData =
          sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
        const expectedTypeId = sectionData?.section_question_type_id;

        // if (!expectedTypeId) {
        //   currentErrors.push(`Section ${sectionLabel} has no question type assigned.`);
        //   continue;
        // }

        const questionsInSection = sectionWiseQuestions[sectionLabel] || [];
        // ✅ SKIP validation for Section A
        if (sectionLabel === "A") {
          continue;
        }

        if (!expectedTypeId) {
          currentErrors.push(
            `Section ${sectionLabel} has no question type assigned.`
          );
          continue;
        }

        const expectedTypeName =
          questionTypeMap[expectedTypeId] || `Type ID ${expectedTypeId}`;
        currentErrors.push(
          `Section ${sectionLabel} only allows "${expectedTypeName}" type questions.`
        );
        const hasMismatch = questionsInSection.some((q) => {
          const quesId = q.id || q.ques_id || q.parse_ques_set_question_id;
          const localType =
            parseInt(localQuesTypeMap[quesId]) ||
            q.ques_type_id ||
            q.ques_type ||
            q.question_type_id;
          return parseInt(localType) !== parseInt(expectedTypeId);
        });

        if (hasMismatch) {
          currentErrors.push(
            `⚠ Some questions in Section ${sectionLabel} have a different type. Please review.`
          );
        }
      }
    }

    // ✅ Compare with previous errors
    const unresolvedErrors = currentErrors.filter(
      (err) =>
        previousErrorsRef.current.includes(err) ||
        previousErrorsRef.current.length === 0
    );

    // ✅ Update previous errors for next validation
    previousErrorsRef.current = currentErrors;

    if (unresolvedErrors.length > 0) {
      setMessageBox(
        <div>
          {unresolvedErrors.map((err, idx) => (
            <p key={idx} style={{ margin: "4px 0" }}>
              {err}
            </p>
          ))}
        </div>
      );
      setMessageBoxHeight("auto");
    } else {
      setMessageBox(
        <div>
          <p>✅ All validations passed successfully!</p>
        </div>
      );
      setMessageBoxHeight("10vh");
    }

    setActiveImg(WarnningIcon);
    setIsMessageBoxVisible(true);
  };

  const [questionOptions, setQuestionOptions] = useState({});
  const [showOptions, setShowOptions] = useState(false);

  const handlePreviewClick = async () => {
    const quesIds =
      JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
        activeSubjectId
      ] || [];
    if (quesIds.length === 0) return;
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ques_id_list: quesIds }),
        }
      );

      if (response.ok) {
        const result = await response.json();

        // ✅ Transform response to { ques_id: [options] }
        const optionsMap = {};
        result.data?.questions?.forEach((q) => {
          optionsMap[q.ques_id] = q.ques_options || [];
        });

        setQuestionOptions(optionsMap);
        setShowPreviewPopup(true);
      } else {
        console.error("Failed to fetch options");
      }
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const statusMap = {
    0: "Assigned",
    1: "Draft",
    2: "Submitted",
    3: "Reviewed",
    4: "Approved",
    5: "Reopened",
  };

  const allStatuses = accessibleSubjects
    .filter((subj) => subj.isAccessible)
    .map((subj, index, filteredList) => {
      const statusText =
        statusMap[subjectStatusById[subj.subject_id]] || "Unknown";
      const isActive = subj.subject_id === activeSubjectId;
      return (
        <span key={subj.subject_id}>
          <span style={{ fontWeight: isActive ? "bold" : "normal" }}>
            {subj.subject_name} - {statusText}
          </span>
          {index !== filteredList.length - 1 && " | "}
        </span>
      );
    });

  useEffect(() => {
    setSectionWiseQuestions({});
  }, [activeSubjectId]);

  // add this logic to handle the case when getting to num_of_sections and section_naming_pattern
  const noOfSections = draftData?.subjects?.find(
    (s) => s.subject_id === activeSubjectId
  )?.no_of_sections;
  const sectionNamingPattern = draftData?.subjects?.find(
    (s) => s.subject_id === activeSubjectId
  )?.section_naming_pattern;
  const isFixedLayout =
    data?.ques_paper_details?.ques_paper_type === 2 &&
    noOfSections > 0 &&
    sectionNamingPattern !== null;

  const questionTypeMap = {
    1: "Single Select",
    2: "Multiple Select",
    3: "Fill-in the Blanks",
    4: "Boolean",
  };

  const hasInstructions = specialInstructions?.[activeSubjectId]?.trim();
  const hasMandatory = sectionDetailsPerSubject?.[activeSubjectId];

  const dynamicMarginTop =
    hasInstructions && hasMandatory
      ? "40px"
      : hasInstructions || hasMandatory
      ? "194px"
      : "234px";

  const handleAutoGenerate = () => {
    try {
      if (!activeSubjectId) {
        console.warn("⚠️ No activeSubjectId; aborting auto-generate.");
        return;
      }

      console.groupCollapsed("▶ AutoGenerate (Chapter → Subject → Backfill)", {
        activeSubjectId,
      });

      // ---------- constants / helpers ----------
      const QTYPE_TEXT_TO_ID = {
        "Single Correct MCQ": 1,
        "Multi Correct MCQ": 2,
        "Fill in the blanks": 3,
        "True/False": 4,
      };
      const QTYPE_ID_TO_TEXT = Object.fromEntries(
        Object.entries(QTYPE_TEXT_TO_ID).map(([k, v]) => [v, k])
      );
      const TYPE_KEYS = ["single", "multi", "fill", "boolean"]; // UI keys
      const TYPE_KEY_TO_ID = { single: 1, multi: 2, fill: 3, boolean: 4 };
      const DIFFS = ["Easy", "Medium", "Tough"];
      const norm = (s) => (s || "").toString().trim().toLowerCase();

      // read a row from table (array/object safe)
      const readRow = (row) => {
        if (!row)
          return {
            id: null,
            text: "",
            typeText: "",
            typeId: 0,
            difficulty: "",
            chapterName: "",
            topicName: "",
          };
        if (Array.isArray(row)) {
          return {
            id: row[0],
            text: row[1],
            typeText: row[2],
            difficulty: row[13],
            chapterName: row[10], // string column
            topicName: row[29], // string column
            typeId: QTYPE_TEXT_TO_ID[(row[2] || "").toString().trim()] || 0,
          };
        }
        const typeText = row.question_type ?? row.type ?? "";
        return {
          id: row.question_id ?? row.id ?? null,
          text: row.question_text ?? row.text ?? "",
          typeText,
          typeId: QTYPE_TEXT_TO_ID[(typeText || "").toString().trim()] || 0,
          difficulty: row.difficulty ?? row.difficulty_level ?? "",
          chapterName: row.chapter ?? row.chapter_name ?? "",
          topicName: row.topic ?? row.topic_name ?? "",
        };
      };

      // sections (A/B/.. or 1/2/..)
      const sectionLabels = Array.from(
        { length: Number(selectedSections || 0) },
        (_, i) =>
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i)
      );

      // ---------- subject need ----------
      const subj = (accessibleSubjects || []).find(
        (s) => String(s.subject_id) === String(activeSubjectId)
      );
      const subjectNeed = {
        Easy: Number(subj?.easy ?? 0),
        Medium: Number(subj?.medium ?? 0),
        Tough: Number(subj?.tough ?? 0),
      };
      const subjectTotal =
        subjectNeed.Easy + subjectNeed.Medium + subjectNeed.Tough;
      console.log(
        "📌 Subject Need:",
        subjectNeed,
        "| Subject Total:",
        subjectTotal
      );

      // ---------- chapter/topic needs from UI ----------
      // Build maps chapterId->name and topicId->name (topicData is { [chapterId]: [{topic_id, topic_name}...] })
      const chapterIdToName = {};
      (chapterData || []).forEach((c) => {
        if (c?.chapter_id) chapterIdToName[c.chapter_id] = c.chapter_name || "";
      });

      const topicIdToName = {};
      Object.entries(topicData || {}).forEach(([cid, arr]) => {
        (arr || []).forEach((t) => {
          if (t?.topic_id) topicIdToName[t.topic_id] = t.topic_name || "";
        });
      });

      console.log("📚 ChapterId→Name:", chapterIdToName);
      console.log("📚 TopicId→Name:", topicIdToName);

      // ---------- selection pools per type ----------
      const chosenByType = { 1: [], 2: [], 3: [], 4: [] }; // typeId -> rows
      const chosenSet = new Set(); // to avoid duplicates across flows
      const originOf = {}; // questionId -> {origin, typeKey, chapterId, topicId, difficulty}

      // metrics for message: track requested vs picked from chapter/topic path
      let chapterTopicRequested = 0;
      let chapterTopicPicked = 0;

      const takeSome = (arr, n) => {
        const out = [];
        for (let i = 0; i < arr.length && out.length < n; i++) {
          const rr = readRow(arr[i]);
          if (!rr.id || chosenSet.has(rr.id)) continue;
          out.push(arr[i]);
          chosenSet.add(rr.id);
        }
        return out;
      };

      // --------- Prepare searchable table ---------
      const table = (reportDashboardData || []).map(readRow);

      // Helper: pool by type/chapter/topic/diff
      const poolFor = ({ typeKey, chapterId, topicId = null, diff = null }) => {
        const typeId = TYPE_KEY_TO_ID[typeKey] || 0;
        const chapName = chapterId ? chapterIdToName[chapterId] || "" : "";
        const topicName = topicId ? topicIdToName[topicId] || "" : null;

        const pool = table.filter((r) => {
          if (!r.id || chosenSet.has(r.id)) return false;
          if (r.typeId !== typeId) return false;
          if (chapName && norm(r.chapterName) !== norm(chapName)) return false;
          if (topicName && norm(r.topicName) !== norm(topicName)) return false;
          if (diff && r.difficulty !== diff) return false;
          return true;
        });
        return { pool, chapName, topicName };
      };

      // ---------- Step A: Chapter/Topic-first fill ----------
      TYPE_KEYS.forEach((typeKey) => {
        const typeId = TYPE_KEY_TO_ID[typeKey];
        if (!typeId) return;

        const checkedChapters = Object.keys(
          checkedChaptersByType?.[typeKey] || {}
        ).filter((cid) => !!checkedChaptersByType[typeKey][cid]);
        const selectedTopicsMap = selectedTopicsByType?.[typeKey] || {};
        const fixedTopicEnabledMap = fixedTopicEnabledByType?.[typeKey] || {};
        const fixedTopicCountsMap = fixedTopicCountsByType?.[typeKey] || {};
        const diffNeedsForType = difficultyDistributions?.[typeKey] || {};

        if (checkedChapters.length) {
          console.groupCollapsed(
            `🗂 Type=${typeKey.toUpperCase()} | Chapters selected (${
              checkedChapters.length
            })`
          );
          checkedChapters.forEach((cid) => {
            const name = chapterIdToName[cid] || `(id:${cid})`;
            const topicsChosen = (selectedTopicsMap[cid] || []).map(
              (tid) => topicIdToName[tid] || `(topic id:${tid})`
            );
            console.log(
              `• Chapter ${cid} → "${name}" | topics:`,
              topicsChosen.length ? topicsChosen : "(none)"
            );
          });
          console.groupEnd();
        }

        checkedChapters.forEach((cid) => {
          const topicsChosen = selectedTopicsMap[cid] || [];
          const useFixedTopic = !!fixedTopicEnabledMap[cid];

          console.groupCollapsed(
            `➡ Chapter/Topic allocation: chapterId=${cid}, name="${
              chapterIdToName[cid] || ""
            }", type=${typeKey}${
              useFixedTopic ? " (FIXED TOPIC COUNTS)" : " (DIFFICULTY)"
            }`
          );

          if (useFixedTopic) {
            // FIXED TOPIC COUNTS
            const topicIdsToUse =
              topicsChosen.length > 0 ? topicsChosen : [null]; // null = chapter-only

            topicIdsToUse.forEach((tid) => {
              const req = tid
                ? Number(fixedTopicCountsMap?.[cid]?.[tid] ?? 0)
                : Number(fixedTopicCountsMap?.[cid]?.["__chapterOnly"] ?? 0);

              if (!req) {
                console.log(
                  `   • Topic ${
                    tid
                      ? `${tid} "${topicIdToName[tid] || ""}"`
                      : "(chapter only)"
                  } → Need=0 (skipped)`
                );
                return;
              }

              chapterTopicRequested += req;

              const { pool, chapName, topicName } = poolFor({
                typeKey,
                chapterId: cid,
                topicId: tid,
              });
              const picked = takeSome(pool, req);
              const ids = picked.map((r) => readRow(r).id);

              chapterTopicPicked += ids.length;

              picked.forEach((r) => {
                const rr = readRow(r);
                originOf[rr.id] = {
                  origin: "chapter/topic-fixed",
                  typeKey,
                  chapterId: cid,
                  topicId: tid,
                  difficulty: rr.difficulty,
                };
              });

              chosenByType[typeId].push(...picked);
              console.log(
                `   • Topic ${
                  tid ? `${tid} "${topicName}"` : "(chapter only)"
                } | Need=${req} | Available=${pool.length} | Picked=${
                  ids.length
                } → IDs=`,
                ids
              );
            });
          } else {
            // DIFFICULTY PATH
            const topicIdsToUse =
              topicsChosen.length > 0 ? topicsChosen : [null];

            const needObj = {
              Easy: Number(diffNeedsForType?.[cid]?.firstSegment ?? 0),
              Medium: Number(diffNeedsForType?.[cid]?.secondSegment ?? 0),
              Tough: Number(diffNeedsForType?.[cid]?.calculatedValue ?? 0),
            };

            topicIdsToUse.forEach((tid) => {
              DIFFS.forEach((diff) => {
                const req = needObj[diff];
                if (!req) return;

                chapterTopicRequested += req;

                const { pool, chapName, topicName } = poolFor({
                  typeKey,
                  chapterId: cid,
                  topicId: tid,
                  diff,
                });
                const picked = takeSome(pool, req);
                const ids = picked.map((r) => readRow(r).id);

                chapterTopicPicked += ids.length;

                picked.forEach((r) => {
                  const rr = readRow(r);
                  originOf[rr.id] = {
                    origin: "chapter/topic-difficulty",
                    typeKey,
                    chapterId: cid,
                    topicId: tid,
                    difficulty: diff,
                  };
                });

                chosenByType[typeId].push(...picked);
                console.log(
                  `   • ${diff} | ${
                    tid ? `Topic ${tid} "${topicName}"` : "(any topic)"
                  } | Need=${req} | Available=${pool.length} | Picked=${
                    ids.length
                  } → IDs=`,
                  ids
                );
              });
            });
          }

          console.groupEnd();
        });
      });

      // ---------- Step B: Subject-level fill (for remaining subject needs) ----------
      const already = { Easy: 0, Medium: 0, Tough: 0 };
      Object.values(chosenByType)
        .flat()
        .forEach((row) => {
          const rr = readRow(row);
          if (DIFFS.includes(rr.difficulty)) already[rr.difficulty]++;
        });

      const remain = {
        Easy: Math.max(0, subjectNeed.Easy - already.Easy),
        Medium: Math.max(0, subjectNeed.Medium - already.Medium),
        Tough: Math.max(0, subjectNeed.Tough - already.Tough),
      };
      const remainTotal = remain.Easy + remain.Medium + remain.Tough;

      let usedSubjectFill = false;

      if (remainTotal > 0) {
        usedSubjectFill = true;
        console.groupCollapsed("📌 Subject-level fill (remaining)", { remain });

        TYPE_KEYS.forEach((typeKey) => {
          const typeId = TYPE_KEY_TO_ID[typeKey];
          if (!typeId) return;

          DIFFS.forEach((diff) => {
            if (remain[diff] <= 0) return;
            const { pool } = poolFor({
              typeKey,
              chapterId: null,
              topicId: null,
              diff,
            });
            const requested = remain[diff];
            const picked = takeSome(pool, requested);
            const ids = picked.map((r) => readRow(r).id);

            picked.forEach((r) => {
              const rr = readRow(r);
              originOf[rr.id] = {
                origin: "subject-fill",
                typeKey,
                chapterId: null,
                topicId: null,
                difficulty: diff,
              };
            });

            chosenByType[typeId].push(...picked);
            remain[diff] -= picked.length;

            console.log(
              `   • Type=${typeKey.toUpperCase()} ${diff}: requested=${requested}, picked=${
                ids.length
              }, IDs=`,
              ids
            );
          });
        });

        console.groupEnd();
      }

      // ---------- Step C: Backfill to hit subject total ----------
      const chosenAllAfterSubject = Object.values(chosenByType).flat();
      const totalChosenSoFar = chosenAllAfterSubject.length;
      const subjectShortfall = Math.max(0, subjectTotal - totalChosenSoFar);

      let usedBackfill = false;

      if (subjectShortfall > 0) {
        usedBackfill = true;
        console.groupCollapsed(
          `🧩 Backfill (any difficulty) to reach total ${subjectTotal} — need ${subjectShortfall}`
        );
        TYPE_KEYS.forEach((typeKey) => {
          if (subjectShortfall <= 0) return;
          const typeId = TYPE_KEY_TO_ID[typeKey];
          const { pool } = poolFor({
            typeKey,
            chapterId: null,
            topicId: null,
            diff: null,
          });
          const picked = takeSome(pool, subjectShortfall);
          const ids = picked.map((r) => readRow(r).id);

          picked.forEach((r) => {
            const rr = readRow(r);
            originOf[rr.id] = {
              origin: "backfill-total",
              typeKey,
              chapterId: null,
              topicId: null,
              difficulty: rr.difficulty,
            };
          });

          chosenByType[typeId].push(...picked);
          console.log(
            `   • Type=${typeKey.toUpperCase()} picked=${ids.length} IDs=`,
            ids
          );
        });
        console.groupEnd();
      }

      // ---------- Final accounting ----------
      const finalAll = Object.values(chosenByType).flat();
      const finalCounts = {
        Easy: finalAll.filter((r) => readRow(r).difficulty === "Easy").length,
        Medium: finalAll.filter((r) => readRow(r).difficulty === "Medium")
          .length,
        Tough: finalAll.filter((r) => readRow(r).difficulty === "Tough").length,
        totalChosen: finalAll.length,
      };
      console.log("✅ Final chosen counts:", finalCounts);

      // ---------- Step D: Place into sections (or fallback to a single synthetic section) ----------
      const sectionsMeta = sectionLabels.map((label) => ({
        label,
        ...(sectionDetailsPerSubject?.[activeSubjectId]?.[label] || {}),
      }));

      const hasUsableSections =
        sectionsMeta.length > 0 &&
        sectionsMeta.some(
          (m) =>
            Number(m.section_question_type_id || 0) > 0 &&
            Number(m.total_ques_cnt || 0) > 0
        );

      let sectionWise = {};
      let quesTypeMapForChosen = {};
      let labelsForPersist = sectionLabels.slice();

      if (!hasUsableSections) {
        // 🔁 FALLBACK: no sections → single synthetic "A"
        labelsForPersist = ["A"];
        const allPicked = Object.values(chosenByType).flat();
        const pickedIds = allPicked.map((r) => readRow(r).id).filter(Boolean);

        sectionWise["A"] = allPicked.map((row) => {
          const rr = readRow(row);
          quesTypeMapForChosen[rr.id] = rr.typeId;
          return { id: rr.id, text: rr.text, _raw: row };
        });

        console.warn(
          `➡ Synthetic Section A (no section template found): got ${pickedIds.length}, IDs=`,
          pickedIds
        );
      } else {
        // Normal template-based placement
        const queuesByType = {};
        Object.keys(chosenByType).forEach(
          (tid) => (queuesByType[tid] = [...chosenByType[tid]])
        );

        sectionWise = {};
        quesTypeMapForChosen = {};

        sectionsMeta.forEach((m) => {
          const tid = Number(m.section_question_type_id || 0);
          const cap = Number(m.total_ques_cnt || 0);
          const q = queuesByType[tid] || [];

          const picked = q.splice(0, cap);
          const ids = picked.map((r) => readRow(r).id);

          sectionWise[m.label] = picked.map((row) => {
            const rr = readRow(row);
            quesTypeMapForChosen[rr.id] = tid;
            return { id: rr.id, text: rr.text, _raw: row };
          });

          console.log(
            `➡ Section ${m.label} (cap=${cap}, type=${
              QTYPE_ID_TO_TEXT[tid] || tid
            }) got ${ids.length}, IDs=`,
            ids
          );
        });
      }

      // ---------- Persist + reflect in UI ----------
      const assignedIds = new Set(
        Object.values(sectionWise)
          .flat()
          .map((x) => x.id)
      );
      const finalIds = Array.from(assignedIds);

      const sid = String(activeSubjectId);

      // selectedRowIds
      const selMap = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      selMap[sid] = finalIds;
      localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));

      // deletedRowIds (remove any that are now assigned)
      const delMap = JSON.parse(
        localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
      );
      delMap[sid] = (delMap[sid] || []).filter((id) => !assignedIds.has(id));
      localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

      // question type map
      const typeMapAll = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      typeMapAll[sid] = { ...(typeMapAll[sid] || {}), ...quesTypeMapForChosen };
      localStorage.setItem(
        "subjectWiseQuesTypeIds",
        JSON.stringify(typeMapAll)
      );

      // section map
      const sectionMapAll = JSON.parse(
        localStorage.getItem("subjectWiseSectionMap") || "{}"
      );
      sectionMapAll[sid] = {};
      labelsForPersist.forEach((label) => {
        for (const q of sectionWise[label] || [])
          sectionMapAll[sid][q.id] = label;
      });
      localStorage.setItem(
        "subjectWiseSectionMap",
        JSON.stringify(sectionMapAll)
      );

      // UI state
      setSectionWiseQuestions(sectionWise);

      // right pane cards
      const byId = new Map(
        (reportDashboardData || []).map((r) => {
          const rr = readRow(r);
          return [rr.id, r];
        })
      );

      const selectedForCards = finalIds.map((id) => {
        const row = byId.get(id);
        const rr = readRow(row);
        const typeText =
          QTYPE_ID_TO_TEXT[quesTypeMapForChosen[id]] || rr.typeText;
        return { question_id: rr.id, text: rr.text, type: typeText };
      });
      setSelectedQuestions(selectedForCards);

      setVersion((v) => v + 1);

      // ---------- MESSAGE BOX (only generic note when fallback was needed) ----------
      const chapterTopicShortfall =
        chapterTopicRequested > 0 && chapterTopicPicked < chapterTopicRequested;

      if (chapterTopicShortfall && (usedSubjectFill || usedBackfill)) {
        setMessageBox(
          <div>
            <p style={{ margin: "4px 0" }}>
              The chapter or topic that you selected had only some questions
              available. The remaining slots were filled from the available pool
              of questions.
            </p>
          </div>
        );
        setMessageBoxHeight("auto");
        setActiveImg(InfoIcon); // or WarnningIcon if you prefer
        setIsMessageBoxVisible(true);
      } else {
        // hide message when not applicable
        setIsMessageBoxVisible(false);
      }

      console.groupEnd();
    } catch (e) {
      console.error("❌ handleAutoGenerate failed:", e);
    }
  };

  // In QuestionPaperDetail (parent) [attached_file:2]
  const handleRemoveQuestion = (quesId) => {
    const sid = String(activeSubjectId);

    // 1) Remove from subjectWiseSelectedRowIds and add to subjectWiseDeletedRowIds
    const selMap =
      JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds")) || {};
    const delMap =
      JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds")) || {};
    const currentSel = Array.isArray(selMap[sid]) ? selMap[sid] : [];
    const currentDel = Array.isArray(delMap[sid]) ? delMap[sid] : [];

    const newSel = currentSel.filter((id) => id !== quesId);
    const newDel = Array.from(new Set([...currentDel, quesId]));
    selMap[sid] = newSel;
    delMap[sid] = newDel;
    localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));
    localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

    // 2) Update section map and right-pane sectionWiseQuestions
    const secMapAll =
      JSON.parse(localStorage.getItem("subjectWiseSectionMap")) || {};
    const secMap = secMapAll[sid] || {};
    const sectionLabel = secMap[quesId];
    if (sectionLabel) {
      const updatedBySection = { ...(sectionWiseQuestions || {}) };
      if (Array.isArray(updatedBySection[sectionLabel])) {
        updatedBySection[sectionLabel] = updatedBySection[sectionLabel].filter(
          (q) => q.id !== quesId
        );
      }
      setSectionWiseQuestions(updatedBySection);
      delete secMap[quesId];
      secMapAll[sid] = secMap;
      localStorage.setItem("subjectWiseSectionMap", JSON.stringify(secMapAll));
    }

    // 3) Update selectedQuestions cards (right pane)
    setSelectedQuestions((prev) =>
      Array.isArray(prev)
        ? prev.filter(
            (q) => (q.id ?? q.questionid ?? q.parsequessetquestionid) !== quesId
          )
        : prev
    );

    // 4) Update difficulty counters (requires lookups)
    // Try to infer difficulty from sectionWiseQuestions leftovers or cached datasets in localStorage/type map.
    const quesTypeAll =
      JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds")) || {};
    const typeMap = quesTypeAll[sid] || {};
    // If difficulty is known in selectedQuestions items, adjust counts
    // Fallback: no-op if not determinable from parent state
    setDifficultyCount((prev) => {
      // No concrete difficulty without table row context; keep as-is.
      return prev;
    });

    // 5) Optional: ensure reportDashboardData (in TableDetailsSelectedQuestions) reacts via version bump
    setVersion((v) => v + 1);
  };

  const ensureOptionsFor = async (ids) => {
    const missing = ids.filter((id) => !questionOptions?.[id]);
    if (missing.length === 0) return;

    const res = await fetch(
      `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ques_id_list: missing }),
      }
    );
    if (!res.ok) return;

    const data = await res.json();
    const fetchedMap = {};
    data?.data?.questions?.forEach((q) => {
      fetchedMap[q.ques_id] = q.ques_options || [];
    });

    setQuestionOptions((prev) => ({ ...(prev || {}), ...fetchedMap }));
  };

  // In QuestionPaperDetail (parent) [attached_file:2]
  // const handleReplaceQuestion = (currentQuesId) => {
  //   const sid = String(activeSubjectId);

  //   // 0) Resolve helper references from parent state/props
  //   // reportDashboardData: array rows used by table, with indices aligned to table headers minus "Section"
  //   // headers: take from selected table headers cached in parent or inject via a ref/callback if needed
  //   // If headers are not directly in parent, cache them via a callback prop from child.
  //   const tableHeaders = headersRef.current || []; // maintain via a ref set from child
  //   const groupIdxAllQ = tableHeaders.findIndex(h => h.toLowerCase().includes('group id')) - 1; // -1: reportDashboardData has no "Section"
  //   const qTypeIdxAllQ = tableHeaders.findIndex(h => h.toLowerCase().includes('question type')) - 1; // -1: reportDashboardData has no "Section"

  //   // 1) Validate current exists in reportDashboardData
  //   const matchedRow = Array.isArray(reportDashboardData) ? reportDashboardData.find(r => r[0] === currentQuesId) : null;
  //   if (!matchedRow) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorIcon);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>This question is missing from the current question set and cannot be replaced.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   const currentGroupId = matchedRow?.[groupIdxAllQ];

  //   // 2) Read selected IDs for subject
  //   const selMap = JSON.parse(localStorage.getItem('subjectWiseSelectedRowIds') || '{}');
  //   const selectedIds = Array.isArray(selMap[sid]) ? selMap[sid] : [];

  //   // 3) Build candidate pool in same group, not already selected, not the same ID
  //   const candidates = (reportDashboardData || []).filter(r =>
  //     r[groupIdxAllQ] === currentGroupId &&
  //     r[0] !== currentQuesId &&
  //     !selectedIds.includes(r[0])
  //   );

  //   if (candidates.length === 0) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorIcon);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>No available questions in the list to replace the selected question.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   const replacementRow = candidates[0];
  //   const replacementId = replacementRow[0];

  //   // 4) Swap IDs in subjectWiseSelectedRowIds
  //   const newSelectedIds = selectedIds.map(id => (id === currentQuesId ? replacementId : id));
  //   selMap[sid] = newSelectedIds;
  //   localStorage.setItem('subjectWiseSelectedRowIds', JSON.stringify(selMap));

  //   // 5) Update subjectWiseQuesTypeIds mapping
  //   const quesTypeAll = JSON.parse(localStorage.getItem('subjectWiseQuesTypeIds') || '{}');
  //   const perSubTypeMap = { ...(quesTypeAll[sid] || {}) };
  //   const quesTypeText = qTypeIdxAllQ >= 0 ? replacementRow[qTypeIdxAllQ] : null;
  //   const quesTypeId = ({
  //     'Single Correct MCQ': 1,
  //     'Multi Correct MCQ': 2,
  //     'Fill in the blanks': 3,
  //     'True/False': 4,
  //   })[quesTypeText] ?? null;

  //   if (quesTypeId != null) {
  //     perSubTypeMap[replacementId] = quesTypeId;
  //   }
  //   delete perSubTypeMap[currentQuesId];
  //   localStorage.setItem('subjectWiseQuesTypeIds', JSON.stringify({ ...quesTypeAll, [sid]: perSubTypeMap }));

  //   // 6) Preserve section placement: move within same section label
  //   const secMapAll = JSON.parse(localStorage.getItem('subjectWiseSectionMap') || '{}');
  //   const secMap = { ...(secMapAll[sid] || {}) };
  //   const sectionLabel = secMap[currentQuesId] || '';
  //   if (sectionLabel) {
  //     // Move mapping to new id
  //     delete secMap[currentQuesId];
  //     secMap[replacementId] = sectionLabel;
  //     localStorage.setItem('subjectWiseSectionMap', JSON.stringify({ ...secMapAll, [sid]: secMap }));
  //   }

  //   // 7) Update sectionWiseQuestions right pane list
  //   setSectionWiseQuestions(prev => {
  //     const updated = { ...(prev || {}) };
  //     if (sectionLabel && Array.isArray(updated[sectionLabel])) {
  //       // Find index and replace in place
  //       const idx = updated[sectionLabel].findIndex(q => q.id === currentQuesId);
  //       if (idx >= 0) {
  //         // Render text using the same renderer used in table preview for consistency
  //         const replacementText = QuestionTextRenderer
  //           ? <QuestionTextRenderer questionText={replacementRow[2]} />
  //           : replacementRow[2];
  //         updated[sectionLabel] = [
  //           ...updated[sectionLabel].slice(0, idx),
  //           { id: replacementId, text: replacementText },
  //           ...updated[sectionLabel].slice(idx + 1),
  //         ];
  //       }
  //     }
  //     return updated;
  //   });

  //   // 8) Update selectedQuestions cards if used in preview sidebar
  //   setSelectedQuestions(prev => {
  //     if (!Array.isArray(prev)) return prev;
  //     const idx = prev.findIndex(q => (q.id ?? q.questionid ?? q.parsequessetquestionid) === currentQuesId);
  //     if (idx === -1) return prev;
  //     const replacementCard = {
  //       ...(prev[idx] || {}),
  //       id: replacementId,
  //       questionid: replacementId,
  //       parsequessetquestionid: replacementId,
  //       text: replacementRow[2],
  //     };
  //     return [
  //       ...prev.slice(0, idx),
  //       replacementCard,
  //       ...prev.slice(idx + 1),
  //     ];
  //   });

  //   // 9) Nudge children to refetch/realign order
  //   setVersion(v => v + 1);
  // };

  // In QuestionPaperDetail (parent) [attached_file:2]
  // const handleReplaceQuestion = async (currentQuesId) => {
  //   const sid = String(activeSubjectId);

  //   // 0) Resolve helper references from parent state/props
  //   const tableHeaders = headersRef.current || [];
  //   const groupIdxAllQ = tableHeaders.findIndex(h => h.toLowerCase().includes('group id')) - 1;
  //   const qTypeIdxAllQ = tableHeaders.findIndex(h => h.toLowerCase().includes('question type')) - 1;

  //   // 1) Validate current exists in reportDashboardData
  //   const matchedRow = Array.isArray(reportDashboardData) ? reportDashboardData.find(r => r[0] === currentQuesId) : null;
  //   if (!matchedRow) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorIcon);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>This question is missing from the current question set and cannot be replaced.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   const currentGroupId = matchedRow?.[groupIdxAllQ];

  //   // 2) Read selected IDs for subject
  //   const selMap = JSON.parse(localStorage.getItem('subjectWiseSelectedRowIds') || '{}');
  //   const selectedIds = Array.isArray(selMap[sid]) ? selMap[sid] : [];

  //   // 3) Build candidate pool in same group, not already selected, not the same ID
  //   const candidates = (reportDashboardData || []).filter(r =>
  //     r[groupIdxAllQ] === currentGroupId &&
  //     r[0] !== currentQuesId &&
  //     !selectedIds.includes(r[0])
  //   );

  //   if (candidates.length === 0) {
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorIcon);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>No available questions in the list to replace the selected question.</span>
  //         </div>
  //       </div>
  //     );
  //     return;
  //   }

  //   const replacementRow = candidates[0];
  //   const replacementId = replacementRow[0];

  //   // 4) Swap IDs in subjectWiseSelectedRowIds
  //   const newSelectedIds = selectedIds.map(id => (id === currentQuesId ? replacementId : id));
  //   selMap[sid] = newSelectedIds;
  //   localStorage.setItem('subjectWiseSelectedRowIds', JSON.stringify(selMap));

  //   // 5) Update subjectWiseQuesTypeIds mapping
  //   const quesTypeAll = JSON.parse(localStorage.getItem('subjectWiseQuesTypeIds') || '{}');
  //   const perSubTypeMap = { ...(quesTypeAll[sid] || {}) };
  //   const quesTypeText = qTypeIdxAllQ >= 0 ? replacementRow[qTypeIdxAllQ] : null;
  //   const quesTypeId = ({
  //     'Single Correct MCQ': 1,
  //     'Multi Correct MCQ': 2,
  //     'Fill in the blanks': 3,
  //     'True/False': 4,
  //   })[quesTypeText] ?? null;

  //   if (quesTypeId != null) {
  //     perSubTypeMap[replacementId] = quesTypeId;
  //   }
  //   delete perSubTypeMap[currentQuesId];
  //   localStorage.setItem('subjectWiseQuesTypeIds', JSON.stringify({ ...quesTypeAll, [sid]: perSubTypeMap }));

  //   // 6) Preserve section placement: move within same section label
  //   const secMapAll = JSON.parse(localStorage.getItem('subjectWiseSectionMap') || '{}');
  //   const secMap = { ...(secMapAll[sid] || {}) };
  //   const sectionLabel = secMap[currentQuesId] || '';
  //   if (sectionLabel) {
  //     delete secMap[currentQuesId];
  //     secMap[replacementId] = sectionLabel;
  //     localStorage.setItem('subjectWiseSectionMap', JSON.stringify({ ...secMapAll, [sid]: secMap }));
  //   }

  //   // 7) Update sectionWiseQuestions right pane list
  //   setSectionWiseQuestions(prev => {
  //     const updated = { ...(prev || {}) };
  //     if (sectionLabel && Array.isArray(updated[sectionLabel])) {
  //       const idx = updated[sectionLabel].findIndex(q => q.id === currentQuesId);
  //       if (idx >= 0) {
  //         const replacementText = QuestionTextRenderer
  //           ? <QuestionTextRenderer questionText={replacementRow[2]} />
  //           : replacementRow[2];
  //         updated[sectionLabel] = [
  //           ...updated[sectionLabel].slice(0, idx),
  //           { id: replacementId, text: replacementText },
  //           ...updated[sectionLabel].slice(idx + 1),
  //         ];
  //       }
  //     }
  //     return updated;
  //   });

  //   // 8) Update selectedQuestions cards
  //   setSelectedQuestions(prev => {
  //     if (!Array.isArray(prev)) return prev;
  //     const idx = prev.findIndex(q => (q.id ?? q.questionid ?? q.parsequessetquestionid) === currentQuesId);
  //     if (idx === -1) return prev;
  //     const replacementCard = {
  //       ...(prev[idx] || {}),
  //       id: replacementId,
  //       questionid: replacementId,
  //       parsequessetquestionid: replacementId,
  //       text: replacementRow[2],
  //     };
  //     return [
  //       ...prev.slice(0, idx),
  //       replacementCard,
  //       ...prev.slice(idx + 1),
  //     ];
  //   });

  //   // 9) ✅ Fetch and update options for the replacement question
  //   try {
  //     const response = await fetch(
  //       `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ ques_id_list: [replacementId] }),
  //       }
  //     );

  //     if (response.ok) {
  //       const result = await response.json();
  //       const newOptions = {};
  //       result.data?.questions?.forEach((q) => {
  //         newOptions[q.ques_id] = q.ques_options || [];
  //       });

  //       // ✅ Update questionOptions state: remove old ID, add new ID
  //       setQuestionOptions((prev) => {
  //         const updated = { ...prev };
  //         delete updated[currentQuesId]; // Remove old question's options
  //         return { ...updated, ...newOptions }; // Add new question's options
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching replacement question options:", error);
  //   }

  //   // 10) Nudge children to refetch/realign order
  //   setVersion(v => v + 1);
  // };

  // In QuestionPaperDetail (parent) [attached_file:2]
  const handleReplaceQuestion = async (currentQuesId) => {
    const sid = String(activeSubjectId);

    // 0) Resolve helper references from parent state/props
    const tableHeaders = headersRef.current || [];
    const groupIdxAllQ =
      tableHeaders.findIndex((h) => h.toLowerCase().includes("group id")) - 1;
    const qTypeIdxAllQ =
      tableHeaders.findIndex((h) => h.toLowerCase().includes("question type")) -
      1;

    // 1) Validate current exists in reportDashboardData
    const matchedRow = Array.isArray(reportDashboardData)
      ? reportDashboardData.find((r) => r[0] === currentQuesId)
      : null;
    if (!matchedRow) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              This question is missing from the current question set and cannot
              be replaced.
            </span>
          </div>
        </div>
      );
      return;
    }

    const currentGroupId = matchedRow?.[groupIdxAllQ];

    // 2) Read selected IDs for subject
    const selMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const selectedIds = Array.isArray(selMap[sid]) ? selMap[sid] : [];

    // 3) Build candidate pool in same group, not already selected, not the same ID
    const candidates = (reportDashboardData || []).filter(
      (r) =>
        r[groupIdxAllQ] === currentGroupId &&
        r[0] !== currentQuesId &&
        !selectedIds.includes(r[0])
    );

    if (candidates.length === 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              No available questions in the list to replace the selected
              question.
            </span>
          </div>
        </div>
      );
      return;
    }

    const replacementRow = candidates[0];
    const replacementId = replacementRow[0];

    // 4) Swap IDs in subjectWiseSelectedRowIds
    const newSelectedIds = selectedIds.map((id) =>
      id === currentQuesId ? replacementId : id
    );
    selMap[sid] = newSelectedIds;
    localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));

    // 5) Update subjectWiseQuesTypeIds mapping
    const quesTypeAll = JSON.parse(
      localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
    );
    const perSubTypeMap = { ...(quesTypeAll[sid] || {}) };
    const quesTypeText =
      qTypeIdxAllQ >= 0 ? replacementRow[qTypeIdxAllQ] : null;
    const quesTypeId =
      {
        "Single Correct MCQ": 1,
        "Multi Correct MCQ": 2,
        "Fill in the blanks": 3,
        "True/False": 4,
      }[quesTypeText] ?? null;

    if (quesTypeId != null) {
      perSubTypeMap[replacementId] = quesTypeId;
    }
    delete perSubTypeMap[currentQuesId];
    localStorage.setItem(
      "subjectWiseQuesTypeIds",
      JSON.stringify({ ...quesTypeAll, [sid]: perSubTypeMap })
    );

    // 6) Preserve section placement: move within same section label
    const secMapAll = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const secMap = { ...(secMapAll[sid] || {}) };
    const sectionLabel = secMap[currentQuesId] || "";
    if (sectionLabel) {
      delete secMap[currentQuesId];
      secMap[replacementId] = sectionLabel;
      localStorage.setItem(
        "subjectWiseSectionMap",
        JSON.stringify({ ...secMapAll, [sid]: secMap })
      );
    }

    // 7) Update sectionWiseQuestions right pane list
    setSectionWiseQuestions((prev) => {
      const updated = { ...(prev || {}) };
      if (sectionLabel && Array.isArray(updated[sectionLabel])) {
        const idx = updated[sectionLabel].findIndex(
          (q) => q.id === currentQuesId
        );
        if (idx >= 0) {
          const replacementText = QuestionTextRenderer ? (
            <QuestionTextRenderer questionText={replacementRow[2]} />
          ) : (
            replacementRow[2]
          );
          updated[sectionLabel] = [
            ...updated[sectionLabel].slice(0, idx),
            { id: replacementId, text: replacementText },
            ...updated[sectionLabel].slice(idx + 1),
          ];
        }
      }
      return updated;
    });

    // 8) Update selectedQuestions cards
    setSelectedQuestions((prev) => {
      if (!Array.isArray(prev)) return prev;
      const idx = prev.findIndex(
        (q) =>
          (q.id ?? q.questionid ?? q.parsequessetquestionid) === currentQuesId
      );
      if (idx === -1) return prev;
      const replacementCard = {
        ...(prev[idx] || {}),
        id: replacementId,
        questionid: replacementId,
        parsequessetquestionid: replacementId,
        text: replacementRow[2],
      };
      return [...prev.slice(0, idx), replacementCard, ...prev.slice(idx + 1)];
    });

    // 9) ✅ Fetch and update options for the replacement question
    try {
      // console.log("🔄 Fetching options only for replaced question ID:", replacementId);
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ques_id_list: [replacementId] }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        const newOptions = {};
        result.data?.questions?.forEach((q) => {
          newOptions[q.ques_id] = q.ques_options || [];
        });

        // ✅ Update questionOptions state: remove old ID, add new ID
        setQuestionOptions((prev) => {
          const updated = { ...prev };
          delete updated[currentQuesId]; // Remove old question's options
          return { ...updated, ...newOptions }; // Add new question's options
        });
      }
    } catch (error) {
      console.error("Error fetching replacement question options:", error);
    }

    // 10) Nudge children to refetch/realign order
    setVersion((v) => v + 1);
  };

  return (
    <div
      className="create-role-container"
      style={{ cursor: isSaving || loadingTab ? "wait" : undefined }}
    >
      {/* {loadingTab && (
        <div className="tab-loader-overlay">
          <div className="load-subjects-spinner"></div>
          <span>Loading subject data...</span>
        </div>
      )} */}
      <div
        className={`create-role-container-ques-paper-del ${
          showFlagModal ? "hide-sticky-header" : ""
        }`}
      >
        <span className="create-role-heading">Create Question Paper</span>
        <div className="create-test-section-btns-container-ques-paper-dels">
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={() => {
              if (hasUnsavedChanges) {
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <div className="loader-tc"></div>
                      <span>
                        You have unsaved changes. Do you want to discard them
                        and exit?
                      </span>
                    </div>
                    <div
                      className="messagebox-insider2"
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                          setHasUnsavedChanges(false);
                          localStorage.removeItem("subjectWiseSelectedRowIds");
                          localStorage.removeItem("subjectWiseDeletedRowIds");
                          localStorage.removeItem("subjectWiseQuesTypeIds");
                          localStorage.removeItem("subjectWiseSectionMap");
                          navigate(-1);
                        }}
                      >
                        YES
                      </button>
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                        }}
                      >
                        NO
                      </button>
                    </div>
                  </div>
                );
                setActiveImg(WarnningIcon);
                setIsMessageBoxVisible(true);
                setNoTimeSet(false);
              } else {
                navigate(-1); // Only navigate if no unsaved changes
                localStorage.removeItem("subjectWiseSelectedRowIds");
                localStorage.removeItem("subjectWiseDeletedRowIds");
                localStorage.removeItem("subjectWiseQuesTypeIds");
                localStorage.removeItem("subjectWiseSectionMap");
              }
            }}
          >
            CANCEL
          </button>
          {/* <button className="create-test-section-btn-ques-paper-del"
            disabled={isActiveSubjectReadOnly()}
            style={{
              backgroundColor: isActiveSubjectReadOnly() ? "#d3d3d3" : "white",
              cursor: isActiveSubjectReadOnly() ? "not-allowed" : "pointer",
              color: isActiveSubjectReadOnly() ? "" : "#424342",
            }}
            onClick={() => handleSaveQuestionPaper(1)}>SAVE DRAFT</button> */}

          <button
            className="create-test-section-btn-ques-paper-del"
            disabled={isActiveSubjectReadOnly() || isSaving || loadingTab}
            // style={{
            //   backgroundColor: (isActiveSubjectReadOnly() || isSaving || loadingTab) ? "#d3d3d3" : "white",
            //   cursor: (isActiveSubjectReadOnly() || isSaving || loadingTab) ? "not-allowed" : "pointer",
            //   color: (isActiveSubjectReadOnly() || isSaving || loadingTab) ? "" : "#424342",
            // }}
            style={{
              backgroundColor:
                isActiveSubjectReadOnly() || isSaving || loadingTab
                  ? "#d3d3d3"
                  : "white",
              cursor:
                isSaving || loadingTab
                  ? "wait"
                  : isActiveSubjectReadOnly()
                  ? "not-allowed"
                  : "pointer",
              color:
                isActiveSubjectReadOnly() || isSaving || loadingTab
                  ? ""
                  : "#424342",
            }}
            onClick={() => handleSaveQuestionPaper(1)}
          >
            SAVE DRAFT
          </button>
          {(() => {
            const selectedQuesIds =
              JSON.parse(
                localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
              )[activeSubjectId] || [];
            // const isDisabled = isActiveSubjectReadOnly();
            const isDisabled =
              isActiveSubjectReadOnly() || isSaving || loadingTab;
            return (
              <button
                className="create-test-section-btn-ques-paper-del"
                style={{
                  marginRight: "0px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                  backgroundColor: isDisabled ? "#d3d3d3" : "white",
                  // cursor: isDisabled ? "not-allowed" : "pointer",
                  cursor:
                    isSaving || loadingTab
                      ? "wait"
                      : isDisabled
                      ? "not-allowed"
                      : "pointer",
                  color: isDisabled ? "" : "#424342",
                }}
                onClick={() => handleSaveQuestionPaper(2)}
                disabled={isDisabled}
                onMouseEnter={(e) => {
                  if (!isDisabled) {
                    e.target.style.backgroundColor = "#fa4741";
                    e.target.style.color = "white";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isDisabled) {
                    e.target.style.backgroundColor = "white";
                    e.target.style.color = "#424342";
                  }
                }}
              >
                SAVE
              </button>
            );
          })()}
        </div>
      </div>
      <div className="display-ques-paper-del">
        <div className="personal-header">
          <div className="header">
            {" "}
            <label>QUESTION PAPER DETAIL</label>{" "}
          </div>
          <div className="accordion-btn" onClick={toggleAccordionSubjects}>
            {" "}
            {isOpenSubject ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}{" "}
          </div>
        </div>
        {isOpenSubject && (
          <div className="accordion-content">
            <div className="display-test-data-container-ques-paper-del">
              <div className="display-grid-container-ques-paper-del">
                <div className="item1">
                  {" "}
                  <p>
                    {" "}
                    <span>Course:</span>{" "}
                    {data?.ques_paper_details?.course_name || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item2">
                  {" "}
                  <p>
                    {" "}
                    <span>Question Paper Type:</span>{" "}
                    {data?.ques_paper_details?.ques_paper_type_name || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item3">
                  {" "}
                  <p>
                    {" "}
                    <span>Test Series</span>{" "}
                    {data?.ques_paper_details?.test_series_name || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item5">
                  {" "}
                  <p>
                    {" "}
                    <span>Class:</span>{" "}
                    {data?.classes?.length > 0
                      ? data.classes.length === 1
                        ? data.classes[0].class_name
                        : data.classes.length === 2
                        ? `${data.classes[0].class_name}, ${data.classes[1].class_name}`
                        : "Multiple"
                      : "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item6">
                  {" "}
                  <p>
                    {" "}
                    <span style={{ marginRight: "18px" }}>
                      Created By:
                    </span>{" "}
                    {data?.ques_paper_details?.created_by || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item4">
                  {" "}
                  <p>
                    {" "}
                    <span>Assigned On:</span>{" "}
                    {data?.ques_paper_details?.assigned_on || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item8">
                  {" "}
                  <p>
                    {" "}
                    <span>Question Paper:</span>{" "}
                    {data?.ques_paper_details?.ques_paper_name || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item9">
                  {" "}
                  <p>
                    {" "}
                    <span style={{ marginRight: "18px" }}>
                      Description:
                    </span>{" "}
                    {data?.ques_paper_details?.description || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item7">
                  {" "}
                  <p>
                    {" "}
                    <span>Due Date:</span>{" "}
                    {data?.ques_paper_details?.due_date || "N/A"}{" "}
                  </p>{" "}
                </div>
                <div className="item9">
                  {/* {groupedScopes ? Object.entries(groupedScopes).map(([scopeId, names]) => {
                    const label = scopeTypeMap[scopeId] || "Unknown"; let displayValue = ""; if (names.length === 1) { displayValue = names[0]; } else if (names.length === 2) { displayValue = `${names[0]}, ${names[1]}`; } else if (names.length > 2) { displayValue = "Multiple"; }
                    return (<p key={scopeId}> <span>{label}:</span> {displayValue} </p>);
                  }) : "N/A"} */}
                  {groupedScopes && Object.keys(groupedScopes).length > 0 ? (
                    Object.entries(groupedScopes).map(([scopeId, names]) => {
                      const label = scopeTypeMap[scopeId] || "Scope";
                      let displayValue = "";

                      if (names.length === 1) {
                        displayValue = names[0];
                      } else if (names.length === 2) {
                        displayValue = `${names[0]}, ${names[1]}`;
                      } else if (names.length > 2) {
                        displayValue = "Multiple";
                      }

                      // Handle empty or missing display values
                      if (!displayValue) {
                        displayValue = "N/A";
                      }

                      return (
                        <p key={scopeId}>
                          <span>{label}:</span> {displayValue}
                        </p>
                      );
                    })
                  ) : (
                    <p>
                      <span>Scope:</span> N/A
                    </p>
                  )}
                </div>
                <div className="item10-ques-paper-guideline">
                  {" "}
                  <p>
                    {" "}
                    <span style={{ marginRight: "18px" }}>Guideline:</span>{" "}
                    {data?.ques_paper_details?.guidelines || "N/A"}{" "}
                  </p>
                </div>
                <div className="item9-ques-paper-status">
                  <p>
                    {/* <span>Status:</span> */}
                    {/* <span className={`status-label status-${activeSubjectStatus}`}>{statusName}</span> */}
                    <span>Status:</span> {allStatuses}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div style={{ marginTop: "20px" }}>
        {/* <TabComponent
            accessibleSubjects={accessibleSubjects}
            onTabChange={handleTabChange}
            hasUnsavedChanges={hasUnsavedChanges}
            activeSubjectId={activeSubjectId}
          /> */}
        {accessibleSubjects.length > 0 && (
          <TabComponent
            accessibleSubjects={accessibleSubjects}
            onTabChange={handleTabChange}
            hasUnsavedChanges={hasUnsavedChanges}
            activeSubjectId={activeSubjectId}
          />
        )}
        <div className="display-ques-paper-del-subjects">
          <div className="accordion-content">
            <div className="display-subjects-test-data-container-ques-paper-del">
              <div className="display-grid-container-ques-paper-subjects-del">
                {/* <div className="item1-subjects-details-content" style={{ height: "0px" }} >
                  {specialInstructions?.[activeSubjectId] && specialInstructions[activeSubjectId].trim() !== "" && (
                    <> <img src={NotesIcon} alt="note icon" /> <p>{specialInstructions[activeSubjectId]}</p></>
                  )}
                </div>
                <div className="section-selection-details-subject" style={{marginLeft: "30px"}}>
                  {sectionDetailsPerSubject?.[activeSubjectId] && (
                    <div className="section-details-content-subject">
                      <p>Mandatory Questions:</p>
                      <ul style={{ marginLeft: "20px", marginTop: "12px", display: "flex", flexDirection: "column", gap: "5px",color: "#424242", fontSize: "14px" }}>
                        {Object.entries(sectionDetailsPerSubject[activeSubjectId]).map(
                          ([sectionName, details]) => {
                            const typeName = questionTypeMap[details.section_question_type_id] || "";
                              return (
                                <li key={sectionName}>
                                  {sectionName} ({typeName}) - {details.mandatory_ques_cnt}/{details.total_ques_cnt}
                                </li>
                              );
                            }
                          )}
                      </ul>
                    </div>
                  )}
                 </div> */}
                {/* Special Instructions (conditionally rendered) */}
                {specialInstructions?.[activeSubjectId]?.trim() !== "" && (
                  <div className="item1-subjects-details-content">
                    <img src={NotesIcon} alt="note icon" />
                    <p>{specialInstructions[activeSubjectId]}</p>
                  </div>
                )}

                {/* Mandatory Questions (move to top row if no instructions) */}
                {sectionDetailsPerSubject?.[activeSubjectId] && (
                  <div
                    className={
                      specialInstructions?.[activeSubjectId]?.trim()
                        ? "section-selection-details-subject"
                        : "section-selection-details-subject no-instructions"
                    }
                    style={{ marginLeft: "30px" }}
                  >
                    <div className="section-details-content-subject">
                      <p>Mandatory Questions:</p>
                      <ul
                        style={{
                          marginLeft: "20px",
                          marginTop: "12px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          color: "#424242",
                          fontSize: "14px",
                        }}
                      >
                        {/* {Object.entries(sectionDetailsPerSubject[activeSubjectId]).map(
                              ([sectionName, details]) => {
                                const typeName =
                                  questionTypeMap[details.section_question_type_id] || "";
                                return (
                                  <li key={sectionName}>
                                    {sectionName} ({typeName}) - {details.mandatory_ques_cnt}/
                                    {details.total_ques_cnt}
                                  </li>
                                );
                              }
                            )} */}
                        {Object.entries(
                          sectionDetailsPerSubject[activeSubjectId]
                        )
                          .sort(([a], [b]) => a.localeCompare(b)) // ✅ sorts by sectionName
                          .map(([sectionName, details]) => {
                            const typeName =
                              questionTypeMap[
                                details.section_question_type_id
                              ] || "";
                            return (
                              <li key={sectionName}>
                                Section {sectionName} ({typeName}) -{" "}
                                {details.mandatory_ques_cnt}/
                                {details.total_ques_cnt}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                )}
                <div
                  className="item3-subject-apply-template"
                  style={{
                    height: "0px",
                    // marginTop: specialInstructions?.[activeSubjectId]?.trim() &&
                    // sectionDetailsPerSubject?.[activeSubjectId] ?
                    //  "54px" : "194px",
                    marginTop: dynamicMarginTop,
                  }}
                >
                  <SectionSelectedDropdown
                    label="Apply Template"
                    selected={selectedTemplateId}
                    setSelected={(selectedOption) => {
                      setSelectedTemplateId(selectedOption || null);
                    }}
                    options={[
                      { id: "", label: "Select" },
                      ...templateData.map((template) => ({
                        id: template.id,
                        label: `${template.name} - ${template.description}`,
                      })),
                    ]}
                    Height="auto"
                    OverFlow="auto"
                    minheight="300px"
                    disabled={isActiveSubjectReadOnly()}
                  />
                </div>
                <div
                  className="item3-subject-apply-template"
                  style={{ height: "0px", marginTop: dynamicMarginTop }}
                >
                  {/* <ExcludeInput label="Exclude Repeated Questions" value={`${excludeRepeatCount} ${excludeRepeatCount === 1 ? 'time' : 'times'}`}
                    onChange={(e) => {
                      if (isActiveSubjectReadOnly() || data?.ques_paper_details?.ques_paper_type === 1) return; const val = e.target.value.replace(/[^\d]/g, ""); if (/^\d*$/.test(val)) {
                        const count = parseInt(val || 0, 10);
                        setExcludeRepeatCount(count); setSectionSettingsBySubject(prev => ({ ...prev, [activeSubjectId]: { ...(prev[activeSubjectId] || {}), excludeRepeatCount: count, }, })); setExcludeRepeatEdited(true);
                      }
                    }} disabled={isActiveSubjectReadOnly() || data?.ques_paper_details?.ques_paper_type === 1} /> */}
                  <ExcludeInput
                    label="Exclude Repeated Questions"
                    value={excludeRepeatCount.toString()}
                    suffix={Number(excludeRepeatCount) <= 1 ? "time" : "times"}
                    onChange={(e) => {
                      if (
                        isActiveSubjectReadOnly() ||
                        data?.ques_paper_details?.ques_paper_type === 1
                      )
                        return;
                      const val = e.target.value.replace(/[^\d]/g, "");
                      if (/^\d*$/.test(val)) {
                        const count = parseInt(val || 0, 10);
                        setExcludeRepeatCount(count);
                        setSectionSettingsBySubject((prev) => ({
                          ...prev,
                          [activeSubjectId]: {
                            ...(prev[activeSubjectId] || {}),
                            excludeRepeatCount: count,
                          },
                        }));
                        setExcludeRepeatEdited(true);
                      }
                    }}
                    disabled={
                      isActiveSubjectReadOnly() ||
                      data?.ques_paper_details?.ques_paper_type === 1
                    }
                  />
                </div>
                {/* <div className="item4" style={{ height: "100px" }}>
                  <SectionSelectedDropdown label="Number of Section(s):" 
                  selected={sectionSettingsBySubject[activeSubjectId]?.selectedSections ??
                   draftData?.subjects?.find((s) => s.subject_id === activeSubjectId)?.no_of_sections ?? 1} 
                   setSelected={(id) => { setSelectedSections(id); setSectionSettingsBySubject((prev) => ({ ...prev, 
                   [activeSubjectId]: { ...(prev[activeSubjectId] || {}), selectedSections: id, }, })); setHasUnsavedChanges(true);}} 
                   options={[{ id: 1, label: "1" }, { id: 2, label: "2" }, { id: 3, label: "3" }, { id: 4, label: "4" }]} 
                  disabled={isActiveSubjectReadOnly() || isFixedLayout}
                   />
                </div> */}
                {/* <div className="item4" style={{ height: "100px" }}>
                  <SectionSelectedDropdown label="Section Naming Pattern" selected={selecteSectionTypeID}
                    setSelected={(id) => {
                      setSelecteSectionTypeID(id);
                      setSectionSettingsBySubject((prev) => ({
                        ...prev,
                        [activeSubjectId]: {
                          ...(prev[activeSubjectId] || {}),
                          selecteSectionTypeID: id,
                        },
                      }));
                    }}
                    options={[
                      { id: 1, label: "Alphabetic" },
                      { id: 2, label: "Numeric" },
                    ]}
                    disabled={isActiveSubjectReadOnly() || isFixedLayout}
                  />
                </div> */}
                <div className="item5-subject-progress">
                  {/* Grouped progress bars */}
                  <div
                    className="progress-group"
                    style={
                      allRecommendedZero
                        ? { minHeight: "200px", opacity: 0.6 }
                        : {}
                    }
                  >
                    <div className="legend-container">
                      <div className="legend-item">
                        <span className="legend-box recommended"></span>
                        <span>Recommended</span>
                      </div>
                      <div className="legend-item">
                        <span className="legend-box-group">
                          <span className="legend-box present-green"></span>
                          <span className="legend-box present-yellow"></span>
                          <span className="legend-box present-red"></span>
                        </span>
                        <span>Present</span>
                      </div>
                    </div>
                    {/* <div className="circular-progress-container">
                        <svg viewBox="0 0 64 64">
                          <circle className="circular-progress-bg" cx="32" cy="32" r="27"></circle>
                          <circle 
                            className="circular-progress-fill" 
                            cx="32" 
                            cy="32" 
                            r="27"
                            style={{
                              strokeDashoffset: 169.56 - (overallFillPercent / 100) * 169.56
                            }}
                          ></circle>
                        </svg>
                        <div className="circular-progress-text">
                          {Math.round(overallFillPercent)}%
                        </div>
                      </div>
                      <div className="progress-text-info">
                        <div className="progress-subject-name">
                          {activeSubject?.subject_name}
                        </div>
                        <div className={`progress-fraction-display ${selectedCount === overallRecommendedCount ? 'complete' : ''}`}>
                          <span className="current-count">{selectedCount}</span>
                          <span className="separator">/</span>
                          <span>{overallRecommendedCount}</span>
                        </div>
                      </div> */}

                    {/* <div className={`progress-pill ${isSelected ? 'show rise' : 'hide fall'}`}>
                        <div className="pill-left">
                          <div className="circular-progress-container">
                            <svg viewBox="0 0 64 64">
                              <circle className="circular-progress-bg" cx="32" cy="32" r="27" />
                              <circle
                                className="circular-progress-fill"
                                cx="32" cy="32" r="27"
                                style={{ strokeDashoffset: 169.56 - (overallFillPercent / 100) * 169.56 }}
                              />
                            </svg>
                            <div className="circular-progress-text">{Math.round(overallFillPercent)}%</div>
                          </div>
                        </div>

                        <div className="pill-right">
                          <span className="fraction">{selectedCount}</span>
                          <span className="slash">/</span>
                          <span className="total">{overallRecommendedCount}</span>
                        </div>
                      </div> */}

                    <DraggablePill defaultX={1700} defaultY={500}>
                      <div
                        className={`progress-pill ${
                          isSelected ? "show rise" : "hide fall"
                        }`}
                      >
                        <div className="pill-left">
                          <div className="circular-progress-container">
                            <svg viewBox="0 0 64 64">
                              <circle
                                className="circular-progress-bg"
                                cx="32"
                                cy="32"
                                r="27"
                              />
                              <circle
                                className="circular-progress-fill"
                                cx="32"
                                cy="32"
                                r="27"
                                style={{
                                  strokeDashoffset:
                                    169.56 -
                                    (overallFillPercent / 100) * 169.56,
                                }}
                              />
                            </svg>
                            <div className="circular-progress-text">
                              {Math.round(overallFillPercent)}%
                            </div>
                          </div>
                        </div>

                        <div className="pill-right">
                          <span className="fraction">{selectedCount}</span>
                          <span className="slash">/</span>
                          <span className="total">
                            {overallRecommendedCount}
                          </span>
                        </div>
                      </div>
                    </DraggablePill>

                    {/* Easy */}
                    <div className="progress-container">
                      <span className="progress-label">{recommendedEasy}</span>
                      <div
                        className="progress-bar"
                        style={{
                          height: `${easyBarHeight}px`,
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          className="progress-fill"
                          style={{
                            height: `${easyFillHeight}px`,
                            backgroundColor: "#4A9D45",
                          }}
                        ></div>
                      </div>
                      <span
                        className="progress-value-outside-easy"
                        style={{
                          bottom: easyBottom,
                          color: "#4A9D45",
                          fontSize: "12px",
                          position: "absolute",
                        }}
                      >
                        {easyCount}{" "}
                      </span>
                      <span className="progress-title">Easy</span>
                    </div>
                    {/* Medium */}
                    <div className="progress-container">
                      <span className="progress-label">
                        {recommendedMedium}
                      </span>
                      <div
                        className="progress-bar"
                        style={{
                          height: `${mediumBarHeight}px`,
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          className="progress-fill"
                          style={{
                            height: `${mediumFillHeight}px`,
                            backgroundColor: "#FFBD20",
                          }}
                        ></div>
                      </div>
                      <span
                        className="progress-value-outside-easy"
                        style={{
                          bottom: mediumBottom,
                          color: "#FFBD20",
                          fontSize: "12px",
                          position: "absolute",
                        }}
                      >
                        {mediumCount}
                      </span>
                      <span className="progress-title">Med.</span>
                    </div>
                    {/* tough */}
                    <div className="progress-container">
                      <span className="progress-label">{recommendedTough}</span>
                      <div
                        className="progress-bar"
                        style={{
                          height: `${toughBarHeight}px`,
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          className="progress-fill"
                          style={{
                            height: `${toughFillHeight}px`,
                            backgroundColor: "#FA4741",
                          }}
                        ></div>
                      </div>
                      <span
                        className="progress-value-outside-easy"
                        style={{
                          bottom: toughBottom,
                          color: "#FA4741",
                          fontSize: "12px",
                          position: "absolute",
                        }}
                      >
                        {toughCount}
                      </span>
                      <span className="progress-title">Tough</span>
                    </div>
                  </div>
                  <div className="progress-container horizontal">
                    {/* <span className="progress-title">{activeSubject?.subject_name} Overall Progress({totaldiff}/{overallRecommendedCount})</span> */}
                    <span className="progress-title">
                      {activeSubject?.subject_name} Overall Progress(
                      {selectedCount}/{overallRecommendedCount})
                    </span>
                    <div
                      className="progress-bar horizontal"
                      style={{
                        width: "368px",
                        minWidth: "368px",
                        maxWidth: "368px",
                        position: "relative",
                        border: "1px solid #ccc",
                        backgroundColor: "#f1f1f1",
                        height: "20px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        className="progress-fill horizontal"
                        style={{
                          width: `${overallFillPercent}%`,
                          backgroundColor: "#337AB7",
                          height: "100%",
                          // display: cappedOverallCount > 0 ? "flex" : "none",
                          display: selectedCount > 0 ? "flex" : "none",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-tags-header-ques">
              <div className="header">
                {" "}
                <label>FILTER BY TAGS</label>{" "}
              </div>
              <div
                className="accordion-btn"
                onClick={toggleAccordionSubjectsFilterTags}
              >
                {" "}
                {isOpenSubjectFilterTags ? (
                  <div className="minus"></div>
                ) : (
                  <div className="plus">+</div>
                )}{" "}
              </div>
            </div>
            {isOpenSubjectFilterTags && (
              <div ref={tagFilterRef}>
                <div className="display-test-data-container-ques-paper-del-filter-tags">
                  <div className="display-grid-container-ques-paper-del-filter-tags">
                    {tags
                      .filter((tag) => tag.parse_tag_type === 1)
                      .map(
                        (tag) =>
                          tag.parse_tag_id !== 8 && (
                            <div className="grid-item" key={tag.parse_tag_id}>
                              <DropDownFilterTags
                                label={tag.parse_tag_name}
                                setSelected={(selectedOption) =>
                                  handleDropdownChange(tag, selectedOption)
                                }
                                options={tag.parse_tag_value.map((value) => ({
                                  label: value.tag_value,
                                  id: value.parse_tag_value_id,
                                }))}
                                selected={
                                  selectedTags.find(
                                    (t) => t.tag_id === tag.parse_tag_id
                                  )?.tag_value_id || null
                                }
                                disabled={isActiveSubjectReadOnly()}
                              />
                            </div>
                          )
                      )}
                    <div></div>
                    {tags
                      .filter((tag) => tag.parse_tag_type === 2)
                      .map((tag) => (
                        <div className="grid-item" key={tag.parse_tag_id}>
                          <div className="check-box-tag-impt">
                            {/* <input type="checkbox" id={`checkbox-${tag.parse_tag_id}`} className="cr-custom-checkbox-tags" onChange={(e) => handleCheckboxChange(tag, e.target.checked)} /> */}
                            <input
                              type="checkbox"
                              id={`checkbox-${tag.parse_tag_id}`}
                              className="cr-custom-checkbox-tags"
                              onChange={(e) =>
                                handleCheckboxChange(tag, e.target.checked)
                              }
                              checked={selectedTags.some(
                                (t) =>
                                  t.tag_id === tag.parse_tag_id &&
                                  t.tag_value_id === 1
                              )}
                              style={{ opacity: isReadOnlyMode ? 0.6 : 1 }}
                              disabled={isActiveSubjectReadOnly()}
                            />
                            <label htmlFor={`checkbox-${tag.parse_tag_id}`}>
                              {" "}
                              {tag.parse_tag_name}{" "}
                            </label>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}

            {data?.ques_paper_details?.parse_ques_set_ques_type?.includes(
              1
            ) && (
              <>
                <div className="filter-tags-header-ques">
                  <div className="header">
                    <label>SINGLE SELECT QUESTIONS</label>
                  </div>
                  <div
                    className="accordion-btn"
                    onClick={toggleAccordionSingleSelectQues}
                  >
                    {" "}
                    {isOpenSingleSelectQues ? (
                      <div className="minus"></div>
                    ) : (
                      <div className="plus">+</div>
                    )}{" "}
                  </div>
                </div>
                {isOpenSingleSelectQues && (
                  <div className="accordion-content-single-selecte-ques">
                    <div className="table-wrapper-cols-selection-cr-test">
                      <table className="table-tc-create-test">
                        <thead>
                          {" "}
                          <tr>
                            {" "}
                            <td>Chapter/Topic</td>{" "}
                            <td>Fixed Ques Count(optional)</td>
                            <td
                              style={{
                                display: "flex",
                                justifyItems: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                className="delete-question-checkbox-dqc"
                                checked={enableSingleSlider}
                                onChange={() =>
                                  setEnableSingleSlider((prev) => !prev)
                                }
                              />
                              Difficulty Level
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {chapterData.map((chapter) => {
                            const isChecked =
                              checkedChaptersByType.single[
                                chapter.chapter_id
                              ] || false;
                            const isExpanded =
                              expandedChaptersByType.single[
                                chapter.chapter_id
                              ] || false;
                            return (
                              <React.Fragment key={chapter.chapter_id}>
                                <tr
                                  style={{
                                    height: "62px",
                                    opacity: isChecked ? 1 : 0.8,
                                    borderBottom: expandedChaptersByType[
                                      chapter.chapter_id
                                    ]
                                      ? ""
                                      : "1px solid #d6d6d6",
                                  }}
                                >
                                  <td style={{ width: "600px" }}>
                                    <input
                                      type="checkbox"
                                      className="delete-question-checkbox-dqc"
                                      checked={isChecked}
                                      onChange={() =>
                                        handleChapterCheck(
                                          chapter.chapter_id,
                                          "single"
                                        )
                                      }
                                      style={{
                                        opacity: isReadOnlyMode ? 0.6 : 1,
                                      }}
                                      disabled={isActiveSubjectReadOnly()}
                                    />
                                    <span
                                      onClick={() => {
                                        if (!isReadOnlyMode && isChecked) {
                                          handleChapterExpand(
                                            chapter.chapter_id,
                                            "single"
                                          );
                                        }
                                      }}
                                      style={{
                                        marginRight: "4px",
                                        fontWeight: "400",
                                        cursor: isChecked
                                          ? "pointer"
                                          : "not-allowed",
                                        opacity: isChecked ? 1 : 0.5,
                                        color: "#424242",
                                      }}
                                    >
                                      {isExpanded ? (
                                        <span className="question-paper-details-icon minus"></span>
                                      ) : (
                                        <span className="question-paper-details-icon plus"></span>
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        opacity: isChecked ? 1 : 0.8,
                                        color: "#424242",
                                      }}
                                    >
                                      {" "}
                                      {chapter.chapter_name}{" "}
                                    </span>
                                  </td>
                                  <td style={{ width: "250px" }}>
                                    <input
                                      type="text"
                                      className="input-details-nts-cr-test"
                                      maxLength={3}
                                      value={
                                        difficultyDistributions.single[
                                          chapter.chapter_id
                                        ]?.total || ""
                                      }
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d*$/.test(val)) {
                                          const parsed = parseInt(val || 0, 10);
                                          const easyRatio =
                                            (activeSubject?.easy || 0) /
                                            (overallRecommended || 1);
                                          const mediumRatio =
                                            (activeSubject?.medium || 0) /
                                            (overallRecommended || 1);
                                          let easyCount = Math.round(
                                            parsed * easyRatio
                                          );
                                          let mediumCount = Math.round(
                                            parsed * mediumRatio
                                          );
                                          let toughCount =
                                            parsed - easyCount - mediumCount;
                                          if (toughCount < 0) toughCount = 0;
                                          setDifficultyDistributions(
                                            (prev) => ({
                                              ...prev,
                                              single: {
                                                ...prev.single,
                                                [chapter.chapter_id]: {
                                                  total: parsed,
                                                  firstSegment: easyCount,
                                                  secondSegment: mediumCount,
                                                  calculatedValue: toughCount,
                                                },
                                              },
                                            })
                                          );
                                        }
                                      }}
                                      // onChange={(e) => {
                                      //   const val = e.target.value;
                                      //   if (/^\d*$/.test(val)) {
                                      //     const parsed = parseInt(val || 0, 10);

                                      //     // ✅ Mark as manually set
                                      //     setManualChapterFixedCounts((prev) => ({
                                      //       ...prev,
                                      //       single: {
                                      //         ...prev.single,
                                      //         [chapter.chapter_id]: true,
                                      //       },
                                      //     }));

                                      //     const easyRatio = (activeSubject?.easy || 0) / (overallRecommended || 1);
                                      //     const mediumRatio = (activeSubject?.medium || 0) / (overallRecommended || 1);
                                      //     const easy = Math.round(parsed * easyRatio);
                                      //     const medium = Math.round(parsed * mediumRatio);
                                      //     const tough = parsed - easy - medium;

                                      //     setDifficultyDistributions((prev) => ({
                                      //       ...prev,
                                      //       single: {
                                      //         ...prev.single,
                                      //         [chapter.chapter_id]: {
                                      //           total: parsed,
                                      //           firstSegment: easy,
                                      //           secondSegment: medium,
                                      //           calculatedValue: tough,
                                      //         },
                                      //       },
                                      //     }));
                                      //   }
                                      // }}
                                      readOnly={!isChecked}
                                      style={{ opacity: isChecked ? 1 : 0.8 }}
                                    />
                                  </td>
                                  <td>
                                    <MultiProgress
                                      total={parseInt(
                                        difficultyDistributions.single[
                                          chapter.chapter_id
                                        ]?.total || 0
                                      )}
                                      onSliderChange={(values) =>
                                        handleSliderChange(
                                          chapter.chapter_id,
                                          values,
                                          "single"
                                        )
                                      }
                                      defaultValues={
                                        difficultyDistributions.single[
                                          chapter.chapter_id
                                        ]
                                      }
                                      isEnabled={enableSingleSlider}
                                    />
                                  </td>
                                </tr>
                                {isExpanded && isChecked && (
                                  <tr
                                    style={{
                                      borderBottom: "1px solid #d6d6d6",
                                      color: "#424242",
                                    }}
                                  >
                                    <td colSpan="3">
                                      <div className="chapter-list-create-test">
                                        <ul>
                                          <li
                                            style={{
                                              marginBottom: "14px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              ref={(el) => {
                                                if (el) {
                                                  const totalTopics =
                                                    topicData[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  const selectedTopics =
                                                    selectedTopicsByType.single[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  el.indeterminate =
                                                    selectedTopics > 0 &&
                                                    selectedTopics <
                                                      totalTopics;
                                                }
                                              }}
                                              className={
                                                selectedTopicsByType.single[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                                  ? "delete-question-checkbox-dqc"
                                                  : selectedTopicsByType.single[
                                                      chapter.chapter_id
                                                    ]?.length > 0
                                                  ? "expend-chapt-sub-check-box indeterminate"
                                                  : "expend-chapt-sub-check-box"
                                              }
                                              onChange={() =>
                                                handleSelectAllTopics(
                                                  chapter.chapter_id,
                                                  "single"
                                                )
                                              }
                                              checked={
                                                selectedTopicsByType.single[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                              }
                                            />
                                            Topics
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                marginLeft: "560px",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="delete-question-checkbox-dqc"
                                                checked={
                                                  fixedTopicEnabledByType
                                                    .single[
                                                    chapter.chapter_id
                                                  ] || false
                                                }
                                                onChange={() => {
                                                  setFixedTopicEnabledByType(
                                                    (prev) => ({
                                                      ...prev,
                                                      single: {
                                                        ...prev.single,
                                                        [chapter.chapter_id]:
                                                          !prev.single[
                                                            chapter.chapter_id
                                                          ],
                                                      },
                                                    })
                                                  );
                                                }}
                                                disabled={!isChecked}
                                              />
                                              Set Fixed Count(optional)
                                            </div>
                                          </li>
                                          {Array.isArray(
                                            topicData[chapter.chapter_id]
                                          ) &&
                                          topicData[chapter.chapter_id].length >
                                            0 ? (
                                            topicData[chapter.chapter_id].map(
                                              (topic) => (
                                                <li
                                                  key={topic.topic_id}
                                                  className="chapter-item-cr-ts"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    paddingRight: "20px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                      marginTop: "8px",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="delete-question-checkbox-dqc"
                                                      checked={
                                                        selectedTopicsByType.single[
                                                          chapter.chapter_id
                                                        ]?.includes(
                                                          topic.topic_id
                                                        ) || false
                                                      }
                                                      onChange={() =>
                                                        handleTopicCheck(
                                                          chapter.chapter_id,
                                                          topic.topic_id,
                                                          "single"
                                                        )
                                                      }
                                                      disabled={!isChecked}
                                                      style={{
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                    />
                                                    {topic.topic_name}
                                                  </div>
                                                  {fixedTopicEnabledByType
                                                    .single[
                                                    chapter.chapter_id
                                                  ] && (
                                                    <input
                                                      type="text"
                                                      className="input-details-nts-cr-test"
                                                      style={{
                                                        width: "48px",
                                                        height: "18px",
                                                        marginRight: "130px",
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                      maxLength={3}
                                                      value={
                                                        fixedTopicCountsByType
                                                          .single?.[
                                                          chapter.chapter_id
                                                        ]?.[topic.topic_id] ||
                                                        ""
                                                      }
                                                      onChange={(e) => {
                                                        const val =
                                                          e.target.value;
                                                        if (/^\d*$/.test(val)) {
                                                          const parsed =
                                                            parseInt(
                                                              val || 0,
                                                              10
                                                            );

                                                          setFixedTopicCountsByType(
                                                            (prev) => {
                                                              const updatedChapter =
                                                                {
                                                                  ...prev
                                                                    .single?.[
                                                                    chapter
                                                                      .chapter_id
                                                                  ],
                                                                  [topic.topic_id]:
                                                                    parsed,
                                                                };

                                                              // 🔢 Auto-sum total fixed for this chapter
                                                              const chapterTotal =
                                                                Object.values(
                                                                  updatedChapter
                                                                ).reduce(
                                                                  (sum, num) =>
                                                                    sum +
                                                                    (parseInt(
                                                                      num
                                                                    ) || 0),
                                                                  0
                                                                );

                                                              // 🔁 Ratio logic from subject-level recommendation
                                                              const recommendedEasy =
                                                                activeSubject?.easy ||
                                                                0;
                                                              const recommendedMedium =
                                                                activeSubject?.medium ||
                                                                0;
                                                              const recommendedTough =
                                                                activeSubject?.tough ||
                                                                0;
                                                              const overallRecommended =
                                                                recommendedEasy +
                                                                  recommendedMedium +
                                                                  recommendedTough ||
                                                                1;

                                                              const easyCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedEasy /
                                                                      overallRecommended)
                                                                );
                                                              const mediumCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedMedium /
                                                                      overallRecommended)
                                                                );
                                                              const toughCount =
                                                                chapterTotal -
                                                                easyCount -
                                                                mediumCount;

                                                              // ✅ Update difficultyDistributions
                                                              setDifficultyDistributions(
                                                                (prevDiff) => ({
                                                                  ...prevDiff,
                                                                  single: {
                                                                    ...prevDiff.single,
                                                                    [chapter.chapter_id]:
                                                                      {
                                                                        total:
                                                                          chapterTotal,
                                                                        firstSegment:
                                                                          easyCount,
                                                                        secondSegment:
                                                                          mediumCount,
                                                                        calculatedValue:
                                                                          toughCount,
                                                                      },
                                                                  },
                                                                })
                                                              );

                                                              return {
                                                                ...prev,
                                                                single: {
                                                                  ...prev.single,
                                                                  [chapter.chapter_id]:
                                                                    updatedChapter,
                                                                },
                                                              };
                                                            }
                                                          );
                                                        }
                                                      }}
                                                      // onChange={(e) => {
                                                      //   const val = e.target.value;
                                                      //   if (/^\d*$/.test(val)) {
                                                      //     const parsed = parseInt(val || 0, 10);

                                                      //     setFixedTopicCountsByType((prev) => {
                                                      //       const updatedChapter = {
                                                      //         ...prev.single?.[chapter.chapter_id],
                                                      //         [topic.topic_id]: parsed,
                                                      //       };

                                                      //       const chapterTotal = Object.values(updatedChapter).reduce(
                                                      //         (sum, num) => sum + (parseInt(num) || 0),
                                                      //         0
                                                      //       );

                                                      //       const isManual = manualChapterFixedCounts.single?.[chapter.chapter_id];

                                                      //       if (!isManual) {
                                                      //         const recommendedEasy = activeSubject?.easy || 0;
                                                      //         const recommendedMedium = activeSubject?.medium || 0;
                                                      //         const recommendedTough = activeSubject?.tough || 0;
                                                      //         const overall = recommendedEasy + recommendedMedium + recommendedTough || 1;

                                                      //         const easy = Math.round(chapterTotal * (recommendedEasy / overall));
                                                      //         const medium = Math.round(chapterTotal * (recommendedMedium / overall));
                                                      //         const tough = chapterTotal - easy - medium;

                                                      //         setDifficultyDistributions((prevDiff) => ({
                                                      //           ...prevDiff,
                                                      //           single: {
                                                      //             ...prevDiff.single,
                                                      //             [chapter.chapter_id]: {
                                                      //               total: chapterTotal,
                                                      //               firstSegment: easy,
                                                      //               secondSegment: medium,
                                                      //               calculatedValue: tough,
                                                      //             },
                                                      //           },
                                                      //         }));
                                                      //       }

                                                      //       return {
                                                      //         ...prev,
                                                      //         single: {
                                                      //           ...prev.single,
                                                      //           [chapter.chapter_id]: updatedChapter,
                                                      //         },
                                                      //       };
                                                      //     });
                                                      //   }
                                                      // }}
                                                      readOnly={!isChecked}
                                                    />
                                                  )}
                                                </li>
                                              )
                                            )
                                          ) : (
                                            <div className="chapter-details">
                                              {" "}
                                              No topics available{" "}
                                            </div>
                                          )}
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="total-question-count-cr-test">
                      <span>Total Fixed Questions: </span>{" "}
                      {totalChapterQuestionCount}
                    </div>
                  </div>
                )}
              </>
            )}

            {data?.ques_paper_details?.parse_ques_set_ques_type?.includes(
              2
            ) && (
              <>
                <div className="filter-tags-header-ques">
                  <div className="header">
                    <label>MULTI SELECT QUESTIONS</label>
                  </div>
                  <div
                    className="accordion-btn"
                    onClick={toggleAccordionMultiSelectQues}
                  >
                    {" "}
                    {isOpenMultiSelectQues ? (
                      <div className="minus"></div>
                    ) : (
                      <div className="plus">+</div>
                    )}{" "}
                  </div>
                </div>
                {isOpenMultiSelectQues && (
                  <div className="accordion-content-multi-selecte-ques">
                    <div className="table-wrapper-cols-selection-cr-test">
                      <table className="table-tc-create-test">
                        <thead>
                          {" "}
                          <tr>
                            {" "}
                            <td>Chapter/Topic</td>{" "}
                            <td>Fixed Ques Count(optional)</td>
                            <td
                              style={{
                                display: "flex",
                                justifyItems: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                className="delete-question-checkbox-dqc"
                                checked={enableMultiSlider}
                                onChange={() =>
                                  setEnableMultiSlider((prev) => !prev)
                                }
                              />
                              Difficulty Level
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {chapterData.map((chapter) => {
                            const isChecked =
                              checkedChaptersByType.multi[chapter.chapter_id] ||
                              false;
                            const isExpanded =
                              expandedChaptersByType.multi[
                                chapter.chapter_id
                              ] || false;
                            return (
                              <React.Fragment key={chapter.chapter_id}>
                                <tr
                                  style={{
                                    height: "62px",
                                    opacity: isChecked ? 1 : 0.8,
                                    borderBottom: expandedChaptersByType[
                                      chapter.chapter_id
                                    ]
                                      ? ""
                                      : "1px solid #d6d6d6",
                                  }}
                                >
                                  <td style={{ width: "600px" }}>
                                    <input
                                      type="checkbox"
                                      className="delete-question-checkbox-dqc"
                                      checked={isChecked}
                                      onChange={() =>
                                        handleChapterCheck(
                                          chapter.chapter_id,
                                          "multi"
                                        )
                                      }
                                      style={{
                                        opacity: isReadOnlyMode ? 0.6 : 1,
                                      }}
                                      disabled={isActiveSubjectReadOnly()}
                                    />
                                    <span
                                      onClick={() => {
                                        if (!isReadOnlyMode && isChecked) {
                                          handleChapterExpand(
                                            chapter.chapter_id,
                                            "multi"
                                          );
                                        }
                                      }}
                                      style={{
                                        marginRight: "4px",
                                        fontWeight: "400",
                                        cursor: isChecked
                                          ? "pointer"
                                          : "not-allowed",
                                        opacity: isChecked ? 1 : 0.5,
                                        color: "#424242",
                                      }}
                                    >
                                      {isExpanded ? (
                                        <span className="question-paper-details-icon minus"></span>
                                      ) : (
                                        <span className="question-paper-details-icon plus"></span>
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        opacity: isChecked ? 1 : 0.8,
                                        color: "#424242",
                                      }}
                                    >
                                      {chapter.chapter_name}
                                    </span>
                                  </td>
                                  <td style={{ width: "250px" }}>
                                    <input
                                      type="text"
                                      className="input-details-nts-cr-test"
                                      maxLength={3}
                                      value={
                                        difficultyDistributions.multi[
                                          chapter.chapter_id
                                        ]?.total || ""
                                      }
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d*$/.test(val)) {
                                          const parsed = parseInt(val || 0, 10);

                                          const easyRatio =
                                            (activeSubject?.easy || 0) /
                                            (overallRecommended || 1);
                                          const mediumRatio =
                                            (activeSubject?.medium || 0) /
                                            (overallRecommended || 1);

                                          const easyCount = Math.round(
                                            parsed * easyRatio
                                          );
                                          const mediumCount = Math.round(
                                            parsed * mediumRatio
                                          );
                                          let toughCount =
                                            parsed - easyCount - mediumCount;
                                          if (toughCount < 0) toughCount = 0;

                                          setDifficultyDistributions(
                                            (prev) => ({
                                              ...prev,
                                              multi: {
                                                ...prev.multi,
                                                [chapter.chapter_id]: {
                                                  total: parsed,
                                                  firstSegment: easyCount,
                                                  secondSegment: mediumCount,
                                                  calculatedValue: toughCount,
                                                },
                                              },
                                            })
                                          );
                                        }
                                      }}
                                      readOnly={!isChecked}
                                      style={{ opacity: isChecked ? 1 : 0.8 }}
                                    />
                                  </td>
                                  <td>
                                    <MultiProgress
                                      total={parseInt(
                                        difficultyDistributions.multi[
                                          chapter.chapter_id
                                        ]?.total || 0,
                                        10
                                      )}
                                      onSliderChange={(values) =>
                                        handleSliderChange(
                                          chapter.chapter_id,
                                          values,
                                          "multi"
                                        )
                                      }
                                      defaultValues={
                                        difficultyDistributions.multi[
                                          chapter.chapter_id
                                        ]
                                      }
                                      isEnabled={enableMultiSlider}
                                    />
                                  </td>
                                </tr>
                                {isExpanded && isChecked && (
                                  <tr
                                    style={{
                                      borderBottom: "1px solid #d6d6d6",
                                      color: "#424242",
                                    }}
                                  >
                                    <td colSpan="3">
                                      <div className="chapter-list-create-test">
                                        <ul>
                                          <li
                                            style={{
                                              marginBottom: "4px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              ref={(el) => {
                                                if (el) {
                                                  const totalTopics =
                                                    topicData[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  const selectedTopics =
                                                    selectedTopicsByType.multi[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  el.indeterminate =
                                                    selectedTopics > 0 &&
                                                    selectedTopics <
                                                      totalTopics;
                                                }
                                              }}
                                              className={
                                                selectedTopicsByType.multi[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                                  ? "delete-question-checkbox-dqc"
                                                  : selectedTopicsByType.multi[
                                                      chapter.chapter_id
                                                    ]?.length > 0
                                                  ? "expend-chapt-sub-check-box indeterminate"
                                                  : "expend-chapt-sub-check-box"
                                              }
                                              onChange={() =>
                                                handleSelectAllTopics(
                                                  chapter.chapter_id,
                                                  "multi"
                                                )
                                              }
                                              checked={
                                                selectedTopicsByType.multi[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                              }
                                            />
                                            Topics
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                marginLeft: "560px",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="delete-question-checkbox-dqc"
                                                checked={
                                                  fixedTopicEnabledByType.multi[
                                                    chapter.chapter_id
                                                  ] || false
                                                }
                                                onChange={() => {
                                                  setFixedTopicEnabledByType(
                                                    (prev) => ({
                                                      ...prev,
                                                      multi: {
                                                        ...prev.multi,
                                                        [chapter.chapter_id]:
                                                          !prev.multi[
                                                            chapter.chapter_id
                                                          ],
                                                      },
                                                    })
                                                  );
                                                }}
                                                disabled={!isChecked}
                                              />
                                              Set Fixed Count(optional)
                                            </div>
                                          </li>
                                          {Array.isArray(
                                            topicData[chapter.chapter_id]
                                          ) &&
                                          topicData[chapter.chapter_id].length >
                                            0 ? (
                                            topicData[chapter.chapter_id].map(
                                              (topic) => (
                                                <li
                                                  key={topic.topic_id}
                                                  className="chapter-item-cr-ts"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    paddingRight: "20px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                      marginTop: "8px",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="delete-question-checkbox-dqc"
                                                      checked={
                                                        selectedTopicsByType.multi[
                                                          chapter.chapter_id
                                                        ]?.includes(
                                                          topic.topic_id
                                                        ) || false
                                                      }
                                                      // onChange={() => handleTopicCheck(chapter.chapter_id, topic.topic_id)}
                                                      onChange={() =>
                                                        handleTopicCheck(
                                                          chapter.chapter_id,
                                                          topic.topic_id,
                                                          "multi"
                                                        )
                                                      }
                                                      disabled={!isChecked}
                                                      style={{
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                    />
                                                    {topic.topic_name}
                                                  </div>
                                                  {fixedTopicEnabledByType
                                                    .multi[
                                                    chapter.chapter_id
                                                  ] && (
                                                    <input
                                                      type="text"
                                                      placeholder=""
                                                      className="input-details-nts-cr-test"
                                                      style={{
                                                        width: "48px",
                                                        height: "18px",
                                                        marginRight: "130px",
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                      maxLength={3}
                                                      value={
                                                        fixedTopicCountsByType
                                                          .multi?.[
                                                          chapter.chapter_id
                                                        ]?.[topic.topic_id] ||
                                                        ""
                                                      }
                                                      onChange={(e) => {
                                                        const val =
                                                          e.target.value;
                                                        if (/^\d*$/.test(val)) {
                                                          const parsed =
                                                            parseInt(
                                                              val || 0,
                                                              10
                                                            );

                                                          setFixedTopicCountsByType(
                                                            (prev) => {
                                                              const updatedChapter =
                                                                {
                                                                  ...prev
                                                                    .multi?.[
                                                                    chapter
                                                                      .chapter_id
                                                                  ],
                                                                  [topic.topic_id]:
                                                                    parsed,
                                                                };

                                                              // 🔢 Auto-sum total fixed for this chapter
                                                              const chapterTotal =
                                                                Object.values(
                                                                  updatedChapter
                                                                ).reduce(
                                                                  (sum, num) =>
                                                                    sum +
                                                                    (parseInt(
                                                                      num
                                                                    ) || 0),
                                                                  0
                                                                );

                                                              // 🔁 Ratio logic from subject-level recommendation
                                                              const recommendedEasy =
                                                                activeSubject?.easy ||
                                                                0;
                                                              const recommendedMedium =
                                                                activeSubject?.medium ||
                                                                0;
                                                              const recommendedTough =
                                                                activeSubject?.tough ||
                                                                0;
                                                              const overallRecommended =
                                                                recommendedEasy +
                                                                  recommendedMedium +
                                                                  recommendedTough ||
                                                                1;

                                                              const easyCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedEasy /
                                                                      overallRecommended)
                                                                );
                                                              const mediumCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedMedium /
                                                                      overallRecommended)
                                                                );
                                                              const toughCount =
                                                                chapterTotal -
                                                                easyCount -
                                                                mediumCount;

                                                              // ✅ Update difficultyDistributions
                                                              setDifficultyDistributions(
                                                                (prevDiff) => ({
                                                                  ...prevDiff,
                                                                  multi: {
                                                                    ...prevDiff.multi,
                                                                    [chapter.chapter_id]:
                                                                      {
                                                                        total:
                                                                          chapterTotal,
                                                                        firstSegment:
                                                                          easyCount,
                                                                        secondSegment:
                                                                          mediumCount,
                                                                        calculatedValue:
                                                                          toughCount,
                                                                      },
                                                                  },
                                                                })
                                                              );

                                                              return {
                                                                ...prev,
                                                                multi: {
                                                                  ...prev.multi,
                                                                  [chapter.chapter_id]:
                                                                    updatedChapter,
                                                                },
                                                              };
                                                            }
                                                          );
                                                        }
                                                      }}
                                                      readOnly={!isChecked}
                                                    />
                                                  )}
                                                </li>
                                              )
                                            )
                                          ) : (
                                            <div className="chapter-details">
                                              {" "}
                                              No topics available{" "}
                                            </div>
                                          )}
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="total-question-count-cr-test">
                      {" "}
                      <span>Total Fixed Questions: </span>{" "}
                      {totalChapterQuestionCount}{" "}
                    </div>
                  </div>
                )}
              </>
            )}

            {data?.ques_paper_details?.parse_ques_set_ques_type?.includes(
              3
            ) && (
              <>
                <div className="filter-tags-header-ques">
                  <div className="header">
                    <label>FILL-IN THE BLANKS QUESTIONS</label>
                  </div>
                  <div
                    className="accordion-btn"
                    onClick={toggleAccordionFillInBlancksQues}
                  >
                    {" "}
                    {isOpenFillInBlanckQues ? (
                      <div className="minus"></div>
                    ) : (
                      <div className="plus">+</div>
                    )}{" "}
                  </div>
                </div>
                {isOpenFillInBlanckQues && (
                  <div className="accordion-content-multi-selecte-ques">
                    <div className="table-wrapper-cols-selection-cr-test">
                      <table className="table-tc-create-test">
                        <thead>
                          {" "}
                          <tr>
                            {" "}
                            <td>Chapter/Topic</td>{" "}
                            <td>Fixed Ques Count(optional)</td>
                            <td
                              style={{
                                display: "flex",
                                justifyItems: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                className="delete-question-checkbox-dqc"
                                checked={enableBooleanSlider}
                                onChange={() =>
                                  setEnableBooleanSlider((prev) => !prev)
                                }
                              />
                              Difficulty Level
                            </td>
                          </tr>{" "}
                        </thead>
                        <tbody>
                          {chapterData.map((chapter) => {
                            const isChecked =
                              checkedChaptersByType.fill[chapter.chapter_id] ||
                              false;
                            const isExpanded =
                              expandedChaptersByType.fill[chapter.chapter_id] ||
                              false;
                            return (
                              <React.Fragment key={chapter.chapter_id}>
                                {/* Chapter Row */}
                                <tr
                                  style={{
                                    height: "62px",
                                    opacity: isChecked ? 1 : 0.8,
                                    borderBottom: expandedChaptersByType[
                                      chapter.chapter_id
                                    ]
                                      ? ""
                                      : "1px solid #d6d6d6",
                                  }}
                                >
                                  <td style={{ width: "600px" }}>
                                    <input
                                      type="checkbox"
                                      className="delete-question-checkbox-dqc"
                                      checked={isChecked}
                                      onChange={() =>
                                        handleChapterCheck(
                                          chapter.chapter_id,
                                          "fill"
                                        )
                                      }
                                      style={{
                                        opacity: isReadOnlyMode ? 0.6 : 1,
                                      }}
                                      disabled={isActiveSubjectReadOnly()}
                                    />
                                    <span
                                      onClick={() => {
                                        if (!isReadOnlyMode && isChecked) {
                                          handleChapterExpand(
                                            chapter.chapter_id,
                                            "fill"
                                          );
                                        }
                                      }}
                                      style={{
                                        marginRight: "4px",
                                        fontWeight: "400",
                                        cursor: isChecked
                                          ? "pointer"
                                          : "not-allowed",
                                        opacity: isChecked ? 1 : 0.5,
                                        color: "#424242",
                                      }}
                                    >
                                      {isExpanded ? (
                                        <span className="question-paper-details-icon minus"></span>
                                      ) : (
                                        <span className="question-paper-details-icon plus"></span>
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        opacity: isChecked ? 1 : 0.8,
                                        color: "#424242",
                                      }}
                                    >
                                      {" "}
                                      {chapter.chapter_name}{" "}
                                    </span>
                                  </td>
                                  <td style={{ width: "250px" }}>
                                    <input
                                      type="text"
                                      className="input-details-nts-cr-test"
                                      value={
                                        difficultyDistributions.fill[
                                          chapter.chapter_id
                                        ]?.total || ""
                                      }
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d*$/.test(val)) {
                                          const parsed = parseInt(val || 0, 10);

                                          const easyRatio =
                                            (activeSubject?.easy || 0) /
                                            (overallRecommended || 1);
                                          const mediumRatio =
                                            (activeSubject?.medium || 0) /
                                            (overallRecommended || 1);

                                          const easyCount = Math.round(
                                            parsed * easyRatio
                                          );
                                          const mediumCount = Math.round(
                                            parsed * mediumRatio
                                          );
                                          let toughCount =
                                            parsed - easyCount - mediumCount;
                                          if (toughCount < 0) toughCount = 0;

                                          setDifficultyDistributions(
                                            (prev) => ({
                                              ...prev,
                                              fill: {
                                                ...prev.fill,
                                                [chapter.chapter_id]: {
                                                  total: parsed,
                                                  firstSegment: easyCount,
                                                  secondSegment: mediumCount,
                                                  calculatedValue: toughCount,
                                                },
                                              },
                                            })
                                          );
                                        }
                                      }}
                                      readOnly={!isChecked}
                                      style={{ opacity: isChecked ? 1 : 0.8 }}
                                    />
                                  </td>
                                  <td>
                                    <MultiProgress
                                      total={parseInt(
                                        difficultyDistributions.fill[
                                          chapter.chapter_id
                                        ]?.total || 0,
                                        10
                                      )}
                                      onSliderChange={(values) =>
                                        handleSliderChange(
                                          chapter.chapter_id,
                                          values,
                                          "fill"
                                        )
                                      }
                                      defaultValues={
                                        difficultyDistributions.fill[
                                          chapter.chapter_id
                                        ]
                                      }
                                      isEnabled={enableBooleanSlider}
                                    />
                                  </td>
                                </tr>
                                {isExpanded && isChecked && (
                                  <tr
                                    style={{
                                      borderBottom: "1px solid #d6d6d6",
                                      color: "#424242",
                                    }}
                                  >
                                    <td colSpan="3">
                                      <div className="chapter-list-create-test">
                                        <ul>
                                          <li
                                            style={{
                                              marginBottom: "14px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              ref={(el) => {
                                                if (el) {
                                                  const totalTopics =
                                                    topicData[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  const selectedTopics =
                                                    selectedTopicsByType.fill[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  el.indeterminate =
                                                    selectedTopics > 0 &&
                                                    selectedTopics <
                                                      totalTopics;
                                                }
                                              }}
                                              className={
                                                selectedTopicsByType.fill[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                                  ? "delete-question-checkbox-dqc"
                                                  : selectedTopicsByType.fill[
                                                      chapter.chapter_id
                                                    ]?.length > 0
                                                  ? "expend-chapt-sub-check-box indeterminate"
                                                  : "expend-chapt-sub-check-box"
                                              }
                                              onChange={() =>
                                                handleSelectAllTopics(
                                                  chapter.chapter_id,
                                                  "fill"
                                                )
                                              }
                                              checked={
                                                selectedTopicsByType.fill[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                              }
                                            />
                                            Topics
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                marginLeft: "560px",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="delete-question-checkbox-dqc"
                                                checked={
                                                  fixedTopicEnabledByType.fill[
                                                    chapter.chapter_id
                                                  ] || false
                                                }
                                                onChange={() => {
                                                  setFixedTopicEnabledByType(
                                                    (prev) => ({
                                                      ...prev,
                                                      fill: {
                                                        ...prev.fill,
                                                        [chapter.chapter_id]:
                                                          !prev.fill[
                                                            chapter.chapter_id
                                                          ],
                                                      },
                                                    })
                                                  );
                                                }}
                                                disabled={!isChecked}
                                              />
                                              Set Fixed Count(optional){" "}
                                            </div>
                                          </li>
                                          {Array.isArray(
                                            topicData[chapter.chapter_id]
                                          ) &&
                                          topicData[chapter.chapter_id].length >
                                            0 ? (
                                            topicData[chapter.chapter_id].map(
                                              (topic) => (
                                                <li
                                                  key={topic.topic_id}
                                                  className="chapter-item-cr-ts"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    paddingRight: "20px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                      marginTop: "8px",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="delete-question-checkbox-dqc"
                                                      checked={
                                                        selectedTopicsByType.fill[
                                                          chapter.chapter_id
                                                        ]?.includes(
                                                          topic.topic_id
                                                        ) || false
                                                      }
                                                      // onChange={() => handleTopicCheck(chapter.chapter_id, topic.topic_id)}
                                                      onChange={() =>
                                                        handleTopicCheck(
                                                          chapter.chapter_id,
                                                          topic.topic_id,
                                                          "fill"
                                                        )
                                                      }
                                                      disabled={!isChecked}
                                                      style={{
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                    />
                                                    {topic.topic_name}
                                                  </div>
                                                  {fixedTopicEnabledByType.fill[
                                                    chapter.chapter_id
                                                  ] && (
                                                    <input
                                                      type="text"
                                                      placeholder=""
                                                      className="input-details-nts-cr-test"
                                                      style={{
                                                        width: "48px",
                                                        height: "18px",
                                                        marginRight: "130px",
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                      maxLength={3}
                                                      value={
                                                        fixedTopicCountsByType
                                                          .fill?.[
                                                          chapter.chapter_id
                                                        ]?.[topic.topic_id] ||
                                                        ""
                                                      }
                                                      // onChange={(e) => {
                                                      //   const val = e.target.value;
                                                      //   if (/^\d*$/.test(val)) {
                                                      //     const parsed = parseInt(val || 0, 10);
                                                      //     setFixedTopicCountsByType((prev) => ({
                                                      //       ...prev,
                                                      //       fill: {
                                                      //         ...prev.fill,
                                                      //         [chapter.chapter_id]: {
                                                      //           ...prev.fill?.[chapter.chapter_id],
                                                      //           [topic.topic_id]: parsed,
                                                      //         },
                                                      //       },
                                                      //     }));
                                                      //   }
                                                      // }}
                                                      onChange={(e) => {
                                                        const val =
                                                          e.target.value;
                                                        if (/^\d*$/.test(val)) {
                                                          const parsed =
                                                            parseInt(
                                                              val || 0,
                                                              10
                                                            );

                                                          setFixedTopicCountsByType(
                                                            (prev) => {
                                                              const updatedChapter =
                                                                {
                                                                  ...prev
                                                                    .fill?.[
                                                                    chapter
                                                                      .chapter_id
                                                                  ],
                                                                  [topic.topic_id]:
                                                                    parsed,
                                                                };

                                                              // 🔢 Auto-sum total fixed for this chapter
                                                              const chapterTotal =
                                                                Object.values(
                                                                  updatedChapter
                                                                ).reduce(
                                                                  (sum, num) =>
                                                                    sum +
                                                                    (parseInt(
                                                                      num
                                                                    ) || 0),
                                                                  0
                                                                );

                                                              // 🔁 Ratio logic from subject-level recommendation
                                                              const recommendedEasy =
                                                                activeSubject?.easy ||
                                                                0;
                                                              const recommendedMedium =
                                                                activeSubject?.medium ||
                                                                0;
                                                              const recommendedTough =
                                                                activeSubject?.tough ||
                                                                0;
                                                              const overallRecommended =
                                                                recommendedEasy +
                                                                  recommendedMedium +
                                                                  recommendedTough ||
                                                                1;

                                                              const easyCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedEasy /
                                                                      overallRecommended)
                                                                );
                                                              const mediumCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedMedium /
                                                                      overallRecommended)
                                                                );
                                                              const toughCount =
                                                                chapterTotal -
                                                                easyCount -
                                                                mediumCount;

                                                              // ✅ Update difficultyDistributions
                                                              setDifficultyDistributions(
                                                                (prevDiff) => ({
                                                                  ...prevDiff,
                                                                  fill: {
                                                                    ...prevDiff.fill,
                                                                    [chapter.chapter_id]:
                                                                      {
                                                                        total:
                                                                          chapterTotal,
                                                                        firstSegment:
                                                                          easyCount,
                                                                        secondSegment:
                                                                          mediumCount,
                                                                        calculatedValue:
                                                                          toughCount,
                                                                      },
                                                                  },
                                                                })
                                                              );

                                                              return {
                                                                ...prev,
                                                                fill: {
                                                                  ...prev.fill,
                                                                  [chapter.chapter_id]:
                                                                    updatedChapter,
                                                                },
                                                              };
                                                            }
                                                          );
                                                        }
                                                      }}
                                                      readOnly={!isChecked}
                                                    />
                                                  )}
                                                </li>
                                              )
                                            )
                                          ) : (
                                            <div className="chapter-details">
                                              {" "}
                                              No topics available{" "}
                                            </div>
                                          )}
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="total-question-count-cr-test">
                      <span>Total Fixed Questions: </span>{" "}
                      {totalChapterQuestionCount}
                    </div>
                  </div>
                )}
              </>
            )}

            {data?.ques_paper_details?.parse_ques_set_ques_type?.includes(
              4
            ) && (
              <>
                <div className="filter-tags-header-ques">
                  <div className="header">
                    {" "}
                    <label>BOOLEAN QUESTIONS</label>{" "}
                  </div>
                  <div
                    className="accordion-btn"
                    onClick={toggleAccordionBoolean}
                  >
                    {" "}
                    {isOpenBooleanQues ? (
                      <div className="minus"></div>
                    ) : (
                      <div className="plus">+</div>
                    )}{" "}
                  </div>
                </div>
                {isOpenBooleanQues && (
                  <div>
                    <div className="table-wrapper-cols-selection-cr-test">
                      <table className="table-tc-create-test">
                        <thead>
                          {" "}
                          <tr>
                            {" "}
                            <td>Chapter/Topic</td>{" "}
                            <td>Fixed Ques Count(optional)</td>
                            <td
                              style={{
                                display: "flex",
                                justifyItems: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                className="delete-question-checkbox-dqc"
                                checked={enableFillSlider}
                                onChange={() =>
                                  setEnableFillSlider((prev) => !prev)
                                }
                              />
                              Difficulty Level
                            </td>
                          </tr>{" "}
                        </thead>
                        <tbody>
                          {chapterData.map((chapter) => {
                            const isChecked =
                              checkedChaptersByType.boolean[
                                chapter.chapter_id
                              ] || false;
                            const isExpanded =
                              expandedChaptersByType.boolean[
                                chapter.chapter_id
                              ] || false;
                            return (
                              <React.Fragment key={chapter.chapter_id}>
                                <tr
                                  style={{
                                    height: "62px",
                                    opacity: isChecked ? 1 : 0.8,
                                    borderBottom: expandedChaptersByType[
                                      chapter.chapter_id
                                    ]
                                      ? ""
                                      : "1px solid #d6d6d6",
                                  }}
                                >
                                  <td style={{ width: "600px" }}>
                                    <input
                                      type="checkbox"
                                      className="delete-question-checkbox-dqc"
                                      checked={isChecked}
                                      onChange={() =>
                                        handleChapterCheck(
                                          chapter.chapter_id,
                                          "boolean"
                                        )
                                      }
                                      style={{
                                        opacity: isReadOnlyMode ? 0.6 : 1,
                                      }}
                                      disabled={isActiveSubjectReadOnly()}
                                    />
                                    <span
                                      onClick={() => {
                                        if (!isReadOnlyMode && isChecked) {
                                          handleChapterExpand(
                                            chapter.chapter_id,
                                            "boolean"
                                          );
                                        }
                                      }}
                                      style={{
                                        marginRight: "4px",
                                        fontWeight: "400",
                                        cursor: isChecked
                                          ? "pointer"
                                          : "not-allowed",
                                        opacity: isChecked ? 1 : 0.5,
                                        color: "#424242",
                                      }}
                                    >
                                      {isExpanded ? (
                                        <span className="question-paper-details-icon minus"></span>
                                      ) : (
                                        <span className="question-paper-details-icon plus"></span>
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        opacity: isChecked ? 1 : 0.8,
                                        color: "#424242",
                                      }}
                                    >
                                      {chapter.chapter_name}
                                    </span>
                                  </td>
                                  <td style={{ width: "250px" }}>
                                    <input
                                      type="text"
                                      className="input-details-nts-cr-test"
                                      value={
                                        difficultyDistributions.boolean[
                                          chapter.chapter_id
                                        ]?.total || ""
                                      }
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d*$/.test(val)) {
                                          const parsed = parseInt(val || 0, 10);

                                          const easyRatio =
                                            (activeSubject?.easy || 0) /
                                            (overallRecommended || 1);
                                          const mediumRatio =
                                            (activeSubject?.medium || 0) /
                                            (overallRecommended || 1);

                                          const easyCount = Math.round(
                                            parsed * easyRatio
                                          );
                                          const mediumCount = Math.round(
                                            parsed * mediumRatio
                                          );
                                          let toughCount =
                                            parsed - easyCount - mediumCount;
                                          if (toughCount < 0) toughCount = 0;
                                          setDifficultyDistributions(
                                            (prev) => ({
                                              ...prev,
                                              boolean: {
                                                ...prev.boolean,
                                                [chapter.chapter_id]: {
                                                  total: parsed,
                                                  firstSegment: easyCount,
                                                  secondSegment: mediumCount,
                                                  calculatedValue: toughCount,
                                                },
                                              },
                                            })
                                          );
                                        }
                                      }}
                                      readOnly={!isChecked}
                                      style={{ opacity: isChecked ? 1 : 0.8 }}
                                    />
                                  </td>
                                  <td>
                                    <MultiProgress
                                      total={parseInt(
                                        difficultyDistributions.boolean[
                                          chapter.chapter_id
                                        ]?.total || 0,
                                        10
                                      )}
                                      onSliderChange={(values) =>
                                        handleSliderChange(
                                          chapter.chapter_id,
                                          values,
                                          "boolean"
                                        )
                                      }
                                      defaultValues={
                                        difficultyDistributions.boolean[
                                          chapter.chapter_id
                                        ]
                                      }
                                      isEnabled={enableFillSlider}
                                    />
                                  </td>
                                </tr>
                                {isExpanded && isChecked && (
                                  <tr
                                    style={{
                                      borderBottom: "1px solid #d6d6d6",
                                      color: "#424242",
                                    }}
                                  >
                                    <td colSpan="3">
                                      <div className="chapter-list-create-test">
                                        <ul>
                                          <li
                                            style={{
                                              marginBottom: "14px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              ref={(el) => {
                                                if (el) {
                                                  const totalTopics =
                                                    topicData[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  const selectedTopics =
                                                    selectedTopicsByType
                                                      .boolean[
                                                      chapter.chapter_id
                                                    ]?.length || 0;
                                                  el.indeterminate =
                                                    selectedTopics > 0 &&
                                                    selectedTopics <
                                                      totalTopics;
                                                }
                                              }}
                                              className={
                                                selectedTopicsByType.boolean[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                                  ? "delete-question-checkbox-dqc"
                                                  : selectedTopicsByType
                                                      .boolean[
                                                      chapter.chapter_id
                                                    ]?.length > 0
                                                  ? "expend-chapt-sub-check-box indeterminate"
                                                  : "expend-chapt-sub-check-box"
                                              }
                                              onChange={() =>
                                                handleSelectAllTopics(
                                                  chapter.chapter_id,
                                                  "boolean"
                                                )
                                              }
                                              checked={
                                                selectedTopicsByType.boolean[
                                                  chapter.chapter_id
                                                ]?.length ===
                                                topicData[chapter.chapter_id]
                                                  ?.length
                                              }
                                            />
                                            Topics
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                marginLeft: "560px",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="delete-question-checkbox-dqc"
                                                checked={
                                                  fixedTopicEnabledByType
                                                    .boolean[
                                                    chapter.chapter_id
                                                  ] || false
                                                }
                                                onChange={() => {
                                                  setFixedTopicEnabledByType(
                                                    (prev) => ({
                                                      ...prev,
                                                      boolean: {
                                                        ...prev.boolean,
                                                        [chapter.chapter_id]:
                                                          !prev.boolean[
                                                            chapter.chapter_id
                                                          ],
                                                      },
                                                    })
                                                  );
                                                }}
                                                disabled={!isChecked}
                                              />
                                              Set Fixed Count(optional)
                                            </div>
                                          </li>
                                          {Array.isArray(
                                            topicData[chapter.chapter_id]
                                          ) &&
                                          topicData[chapter.chapter_id].length >
                                            0 ? (
                                            topicData[chapter.chapter_id].map(
                                              (topic) => (
                                                <li
                                                  key={topic.topic_id}
                                                  className="chapter-item-cr-ts"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    paddingRight: "20px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "8px",
                                                      marginTop: "8px",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="delete-question-checkbox-dqc"
                                                      checked={
                                                        selectedTopicsByType.boolean[
                                                          chapter.chapter_id
                                                        ]?.includes(
                                                          topic.topic_id
                                                        ) || false
                                                      }
                                                      // onChange={() => handleTopicCheck(chapter.chapter_id, topic.topic_id)}
                                                      onChange={() =>
                                                        handleTopicCheck(
                                                          chapter.chapter_id,
                                                          topic.topic_id,
                                                          "boolean"
                                                        )
                                                      }
                                                      disabled={!isChecked}
                                                      style={{
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                    />
                                                    {topic.topic_name}
                                                  </div>
                                                  {fixedTopicEnabledByType
                                                    .boolean[
                                                    chapter.chapter_id
                                                  ] && (
                                                    <input
                                                      type="text"
                                                      placeholder=""
                                                      className="input-details-nts-cr-test"
                                                      style={{
                                                        width: "48px",
                                                        height: "18px",
                                                        marginRight: "130px",
                                                        opacity: isChecked
                                                          ? 1
                                                          : 0.5,
                                                      }}
                                                      maxLength={3}
                                                      value={
                                                        fixedTopicCountsByType
                                                          .boolean?.[
                                                          chapter.chapter_id
                                                        ]?.[topic.topic_id] ||
                                                        ""
                                                      }
                                                      // onChange={(e) => {
                                                      //   const val = e.target.value;
                                                      //   if (/^\d*$/.test(val)) {
                                                      //     const parsed = parseInt(val || 0, 10);
                                                      //     setFixedTopicCountsByType((prev) => ({
                                                      //       ...prev,
                                                      //       boolean: {
                                                      //         ...prev.boolean,
                                                      //         [chapter.chapter_id]: {
                                                      //           ...prev.boolean?.[chapter.chapter_id],
                                                      //           [topic.topic_id]: parsed,
                                                      //         },
                                                      //       },
                                                      //     }));
                                                      //   }
                                                      // }}
                                                      onChange={(e) => {
                                                        const val =
                                                          e.target.value;
                                                        if (/^\d*$/.test(val)) {
                                                          const parsed =
                                                            parseInt(
                                                              val || 0,
                                                              10
                                                            );

                                                          setFixedTopicCountsByType(
                                                            (prev) => {
                                                              const updatedChapter =
                                                                {
                                                                  ...prev
                                                                    .boolean?.[
                                                                    chapter
                                                                      .chapter_id
                                                                  ],
                                                                  [topic.topic_id]:
                                                                    parsed,
                                                                };

                                                              // 🔢 Auto-sum total fixed for this chapter
                                                              const chapterTotal =
                                                                Object.values(
                                                                  updatedChapter
                                                                ).reduce(
                                                                  (sum, num) =>
                                                                    sum +
                                                                    (parseInt(
                                                                      num
                                                                    ) || 0),
                                                                  0
                                                                );

                                                              // 🔁 Ratio logic from subject-level recommendation
                                                              const recommendedEasy =
                                                                activeSubject?.easy ||
                                                                0;
                                                              const recommendedMedium =
                                                                activeSubject?.medium ||
                                                                0;
                                                              const recommendedTough =
                                                                activeSubject?.tough ||
                                                                0;
                                                              const overallRecommended =
                                                                recommendedEasy +
                                                                  recommendedMedium +
                                                                  recommendedTough ||
                                                                1;

                                                              const easyCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedEasy /
                                                                      overallRecommended)
                                                                );
                                                              const mediumCount =
                                                                Math.round(
                                                                  chapterTotal *
                                                                    (recommendedMedium /
                                                                      overallRecommended)
                                                                );
                                                              const toughCount =
                                                                chapterTotal -
                                                                easyCount -
                                                                mediumCount;

                                                              // ✅ Update difficultyDistributions
                                                              setDifficultyDistributions(
                                                                (prevDiff) => ({
                                                                  ...prevDiff,
                                                                  boolean: {
                                                                    ...prevDiff.boolean,
                                                                    [chapter.chapter_id]:
                                                                      {
                                                                        total:
                                                                          chapterTotal,
                                                                        firstSegment:
                                                                          easyCount,
                                                                        secondSegment:
                                                                          mediumCount,
                                                                        calculatedValue:
                                                                          toughCount,
                                                                      },
                                                                  },
                                                                })
                                                              );

                                                              return {
                                                                ...prev,
                                                                boolean: {
                                                                  ...prev.boolean,
                                                                  [chapter.chapter_id]:
                                                                    updatedChapter,
                                                                },
                                                              };
                                                            }
                                                          );
                                                        }
                                                      }}
                                                      readOnly={!isChecked}
                                                    />
                                                  )}
                                                </li>
                                              )
                                            )
                                          ) : (
                                            <div className="chapter-details">
                                              {" "}
                                              No topics available{" "}
                                            </div>
                                          )}
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="total-question-count-cr-test">
                      <span>Total Fixed Questions: </span>{" "}
                      {totalChapterQuestionCount}
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="create-ques-paper-ques-list-container-text">
              <span>QUESTIONS LIST</span>
            </div>
            <div>
              <div className="create-ques-paper-ques-list-container">
                <TableDetailsQuesList
                  isReadOnly={isActiveSubjectReadOnly()}
                  // selectedTags={finalTags} filters={finalFilters}
                  selectedTags={memoizedTags}
                  filters={memoizedFilters}
                  setMessageBox={setMessageBox}
                  messageBox={messageBox}
                  setIsMessageBoxVisible={setIsMessageBoxVisible}
                  setActiveImg={setActiveImg}
                  setNoTimeSet={setNoTimeSet}
                  dataClient={data}
                  setSelectedQuestions={setSelectedQuestions}
                  setSelectedHeaders={setSelectedHeaders}
                  setDifficultyCount={setDifficultyCount}
                  userId={userId}
                  showFlagModal={showFlagModal}
                  setShowFlagModal={setShowFlagModal}
                  subjectId={activeSubject?.subject_id}
                  courseId={data?.ques_paper_details?.course_id}
                  scopeRefIds={scopeRefIds}
                  // setAllQuestions={setAllQuestions}
                  setReportDashboardData={setReportDashboardData}
                  reportDashboardData={reportDashboardData}
                  draftData={draftData}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  selectedQuestions={selectedQuestions}
                  activeSubjectId={activeSubjectId}
                  // setSelectedQuestions={setSelectedQuestions}
                  setVersion={setVersion}
                  excludeRepeatCount={excludeRepeatCount}
                  clientBranchId={clientBranchId}
                  scopeId={scopeId}
                  loadingTab={loadingTab}
                  setLoadingTab={setLoadingTab}
                />
              </div>
              <div className="ques-list-auto-generat-btn">
                <button onClick={handleAutoGenerate}>Auto Generate</button>
              </div>
            </div>

            <div className="create-ques-paper-ques-selected-container-text">
              <span>SELECTED QUESTIONS</span>
            </div>
            <div className="create-ques-paper-ques-selected-container">
              <TableDetailsSelectedQues
                selectedQuestions={selectedQuestions}
                selectedHeaders={selectedHeaders}
                selectedSections={selectedSections}
                // setQuestionIds={setFinalSelectedQuesIds}
                setSectionWiseQuestions={setSectionWiseQuestions}
                selecteSectionTypeID={selecteSectionTypeID}
                // tableQuestions={allQuestions}
                setIsMessageBoxVisible={setIsMessageBoxVisible}
                setActiveImg={setActiveImg}
                setMessageBox={setMessageBox}
                allQuesList={reportDashboardData}
                setSelectedQuestions={setSelectedQuestions}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                draftData={draftData}
                isReadOnlyMode={isReadOnlyMode}
                setDifficultyCount={setDifficultyCount}
                activeSubjectId={activeSubjectId}
                version={version}
                setVersion={setVersion}
                sectionWiseQuestions={sectionWiseQuestions}
              />
            </div>
            {[...Array(selectedSections)].map((_, index) => {
              const sectionLabel =
                selecteSectionTypeID === 2
                  ? `${index + 1}`
                  : String.fromCharCode(65 + index);
              const questionsInSection =
                sectionWiseQuestions[sectionLabel] || [];
              const isOpen =
                index === 0
                  ? isOpenSectionAQues
                  : index === 1
                  ? isOpenSectionBQues
                  : index === 2
                  ? isOpenSectionCQues
                  : index === 3
                  ? isOpenSectionDQues
                  : false;
              // const sectionKey = `Section ${sectionLabel}`; // matches "Section A"
              const subjectKey = activeSubjectId; // keep as number if your keys are numbers
              const sectionKey = sectionLabel;
              const sectionData =
                sectionDetailsPerSubject?.[subjectKey]?.[sectionKey];
              // const sectionData = sectionDetailsPerSubject?.[subjectKey]?.[sectionKey];
              const typeName =
                questionTypeMap[sectionData?.section_question_type_id] || "";

              const toggleFunction =
                index === 0
                  ? toggleAccordionSectionA
                  : index === 1
                  ? toggleAccordionSectionB
                  : index === 2
                  ? toggleAccordionSectionC
                  : index === 3
                  ? toggleAccordionSectionD
                  : null;
              return (
                <React.Fragment key={index}>
                  <div className="filter-tags-header-ques">
                    <div className="header">
                      <label>
                        SECTION {sectionLabel} -{" "}
                        <span style={{ textTransform: "capitalize" }}>
                          {typeName}
                        </span>{" "}
                        ({questionsInSection.length} of{" "}
                        {data?.ques_paper_details?.ques_paper_type === 1
                          ? // DPP
                            (activeSubject?.easy || 0) +
                            (activeSubject?.medium || 0) +
                            (activeSubject?.tough || 0)
                          : data?.ques_paper_details?.ques_paper_type === 2
                          ? // TEST → use same map that shows 15/20, 35/35
                            sectionDetailsPerSubject?.[activeSubjectId]?.[
                              sectionLabel
                            ]?.total_ques_cnt || 0
                          : 0}{" "}
                        QUESTIONS)
                      </label>
                    </div>
                    <div
                      className="accordion-btn"
                      onClick={() => toggleFunction()}
                    >
                      {isOpen ? (
                        <div className="minus"></div>
                      ) : (
                        <div className="plus">+</div>
                      )}
                    </div>
                  </div>
                  {isOpen && (
                    <div className="test-data-section-A-questions">
                      <div className="test-data-section-A-questions-container">
                        <div className="item1">
                          {/* <FormInputs label="Instructions"
                            // value={sectionInstructions[sectionLabel] || ""}
                            value={sectionInstructions[`${activeSubjectId}_${sectionLabel}`] || ""}
                            onChange={(e) =>
                              handleSectionInstructionChange(sectionLabel, e.target.value)
                            } /> */}
                          <div className="formInput">
                            <label>
                              Instructions
                              <textarea
                                value={
                                  sectionInstructions[
                                    `${activeSubjectId}_${sectionLabel}`
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleSectionInstructionChange(
                                    sectionLabel,
                                    e.target.value
                                  )
                                }
                                rows={4} // ✅ you can change height dynamically
                              />
                            </label>
                          </div>
                        </div>
                        <div className="question-list-items-container">
                          <ul>
                            {" "}
                            {questionsInSection.map((q, idx) => (
                              <li key={q.id}>
                                {" "}
                                {idx + 1}. {q.text}{" "}
                              </li>
                            ))}{" "}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
            {showTemplatePopup && (
              <div className="popup-overlay-template-layout">
                <div className="popup-box-template-layout">
                  <h3>Save as Template</h3>

                  <div className="input-wrapper-apply-pattern">
                    <label>Template Name</label>
                    <input
                      type="text"
                      value={templateName}
                      onChange={(e) => {
                        setTemplateName(e.target.value);
                        if (templateNameError && e.target.value.trim())
                          setTemplateNameError(false);
                      }}
                      className={
                        templateNameError
                          ? "input-box error-border"
                          : "input-box"
                      }
                      placeholder="Enter template name"
                    />
                    <span className="error-text-pattern">
                      {templateNameError ? "Template name is required." : ""}
                    </span>
                  </div>

                  <div className="input-wrapper-apply-pattern">
                    <label>Template Description</label>
                    <input
                      type="text"
                      value={templateDesc}
                      onChange={(e) => {
                        setTemplateDesc(e.target.value);
                        if (templateDescError && e.target.value.trim())
                          setTemplateDescError(false);
                      }}
                      className={
                        templateDescError
                          ? "input-box error-border"
                          : "input-box"
                      }
                      placeholder="Enter template description"
                    />
                    <span className="error-text-pattern">
                      {templateDescError
                        ? "Template description is required."
                        : ""}
                    </span>
                  </div>

                  {templatePopupError && (
                    <div
                      className="error-text-pattern"
                      style={{ color: "red", marginBottom: "20px" }}
                    >
                      {templatePopupError}
                    </div>
                  )}

                  <div className="popup-actions-template-layout">
                    <button
                      className="testreportcard-cancel-btn"
                      onClick={() => {
                        setShowTemplatePopup(false);
                        setHasUnsavedChanges(false);
                        window.location.reload();
                        // navigate("/DashboardCreateQuestionpaper");
                        // window.location.href = "/DashboardCreateQuestionpaper";
                      }}
                    >
                      CANCEL
                    </button>
                    <button
                      className="testreportcard-cancel-btn"
                      onClick={handleCreateTemplate}
                      style={{ width: "140px" }}
                    >
                      SAVE TEMPLATE
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showPreviewPopup && (
              <div
                className="popup-overlay-template-layout"
                onClick={() => setShowPreviewPopup(false)}
              >
                <button
                  className="popup-close-outside"
                  aria-label="Close"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowPreviewPopup(false);
                  }}
                >
                  ×
                </button>
                <div
                  className="popup-box-template-layout"
                  style={{
                    width: "60vw",
                    height: "80vh",
                    paddingRight: "10px",
                    color: "#424242",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Fixed Header Section */}
                  <div
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#fff",
                      zIndex: 2,
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h3 style={{ margin: 0, color: "rgb(106, 106, 106)" }}>
                        Preview Selected Questions
                        <span
                          style={{
                            marginLeft: "10px",
                            cursor: "pointer",
                            fontSize: "12px",
                            textDecoration: "underline",
                          }}
                          onClick={() => setShowOptions((prev) => !prev)}
                        >
                          {/* {showOptions ? "With Options" : "Without Options"}  */}
                          {showOptions ? "Hide Options" : "Show Options"}
                        </span>
                      </h3>
                      {/* <span style={{ cursor: "pointer", fontSize: "20px", fontWeight: "bold", padding: "4px 8px", borderRadius: "4px", color: "#666", }} onClick={() => setShowPreviewPopup(false)} title="Close" > × </span> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        marginBottom: "10px",
                        fontSize: "14px",
                        marginTop: "10px",
                      }}
                    >
                      {/* Left Column */}
                      <div style={{ flex: "0 0 48%" }}>
                        <p style={{ marginBottom: "8px" }}>
                          <span>Course:</span>{" "}
                          {data?.ques_paper_details?.course_name || "N/A"}
                        </p>
                        <p>
                          <span>Question Paper Type:</span>{" "}
                          {data?.ques_paper_details?.ques_paper_type_name ||
                            "N/A"}
                        </p>
                      </div>
                      {/* Right Column */}
                      <div style={{ flex: "0 0 48%" }}>
                        <p style={{ marginBottom: "8px" }}>
                          <span>Class:</span>{" "}
                          {data?.classes?.length > 0
                            ? data.classes.map((c) => c.class_name).join(", ")
                            : "N/A"}
                        </p>
                        <p>
                          <span>Question Paper:</span>{" "}
                          {data?.ques_paper_details?.ques_paper_name || "N/A"}
                        </p>
                      </div>
                      {/* <div style={{ flex: "0 0 100%", display: "flex", justifyContent: "flex-end", marginTop: "-40px" }}>
                      <ToggleButton
                        label="Display Options"
                        setValues={(val) => setShowOptions(val === 1)}
                      />
                    </div> */}
                    </div>
                    <hr
                      style={{ borderTop: "1px solid #ccc", marginBottom: "0" }}
                    />
                  </div>
                  <div style={{ overflowY: "auto", padding: "10px" }}>
                    {/* {Object.entries(sectionWiseQuestions)
                      .sort(([a], [b]) => a.localeCompare(b)) 
                      .map(([sectionName, questions]) => (
                      <div key={sectionName} style={{ marginBottom: "20px" }}>
                        <h4 style={{ marginBottom: "10px", textAlign: "center" }}>Section {sectionName}</h4>
                        {questions.length > 0 ? (
                          <ul style={{ paddingLeft: "20px" }}>
                            {questions.map((ques, index) => {
                              const quesId = ques.id || ques.parse_ques_set_question_id;
                              const options = questionOptions[quesId] || [];
                              return (
                                <li key={quesId || index} style={{ marginBottom: "16px" }}>
                                  <div style={{ marginBottom: "4px" }}>
                                    {index + 1}. {ques.text}
                                  </div>
                                  {showOptions && (
                                    <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                                      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                        {[0, 1].map((col) => (
                                          <ul
                                            key={col}
                                            style={{
                                              flex: "1 1 45%",
                                              paddingLeft: "20px",
                                              marginTop: "5px",
                                              listStyleType: "disc",
                                            }}
                                          >
                                            {options
                                              .filter((_, idx) => idx % 2 === col)
                                              .map((option, idx) => {
                                                const globalIndex = col + idx * 2;
                                                return (
                                                  <li
                                                    key={option.option_id || globalIndex}
                                                    style={{ padding: "10px" }}
                                                  >
                                                    {String.fromCharCode(65 + globalIndex).toLowerCase()}.
                                                    <QuestionTextRenderer questionText={option.option_text} />
                                                  </li>
                                                );
                                              })}
                                          </ul>
                                        ))}
                                      </div>
                                    </ul>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p>No questions in this section.</p>
                        )}
                      </div>
                    ))} */}
                    {Object.entries(sectionWiseQuestions)
                      .sort(([a], [b]) => a.localeCompare(b))
                      .map(([sectionName, questions]) => (
                        <div key={sectionName} style={{ marginBottom: "20px" }}>
                          <h4
                            style={{
                              marginBottom: "10px",
                              textAlign: "center",
                            }}
                          >
                            Section {sectionName}
                          </h4>

                          {questions.length > 0 ? (
                            <ul>
                              {questions.map((ques, index) => {
                                const quesId =
                                  ques.id ?? ques.parse_ques_set_question_id;
                                const options = questionOptions[quesId] || [];

                                return (
                                  <li
                                    key={quesId ?? index}
                                    style={{ marginBottom: "16px" }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 12,
                                      }}
                                    >
                                      <img
                                        src={DeleteIcon}
                                        alt="replaceicon"
                                        style={{
                                          width: "24px",
                                          cursor: "pointer",
                                          opacity: isReadOnlyMode ? 0.6 : 1,
                                        }}
                                        onClick={() =>
                                          handleRemoveQuestion(quesId)
                                        }
                                      />
                                      <img
                                        src={ReplaceIcon}
                                        alt="replaceicon"
                                        style={{
                                          width: "24px",
                                          cursor: "pointer",
                                          opacity: isReadOnlyMode ? 0.6 : 1,
                                        }}
                                        onClick={() =>
                                          handleReplaceQuestion(ques.id)
                                        }
                                      />
                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        {index + 1}. {ques.text}
                                        {/* Or: <QuestionTextRenderer questionText={ques.text} /> */}
                                      </div>
                                      {/* <button
                                        style={{ color: "#fa4741", cursor: "pointer", whiteSpace: "nowrap" }}
                                        onClick={() => handleRemoveQuestion(quesId)}
                                        title="Remove"
                                      >
                                        Remove
                                      </button>
                                       <button
                                        style={{ marginLeft: 'auto', cursor: 'pointer', color: '#337ab7' }}
                                        // onClick={() => handleReplaceQuestion(ques.id)}
                                        title="Replace"
                                      >
                                        Replace
                                      </button> */}
                                    </div>
                                    {showOptions && (
                                      <ul
                                        style={{
                                          paddingLeft: "20px",
                                          marginTop: "5px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "20px",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          {[0, 1].map((col) => (
                                            <ul
                                              key={col}
                                              style={{
                                                flex: "1 1 45%",
                                                paddingLeft: "60px",
                                                marginTop: "5px",
                                                listStyleType: "disc",
                                              }}
                                            >
                                              {options
                                                .filter(
                                                  (_, idx) => idx % 2 === col
                                                )
                                                .map((option, idx) => {
                                                  const globalIndex =
                                                    col + idx * 2;
                                                  return (
                                                    <li
                                                      key={
                                                        option.option_id ??
                                                        `${quesId}-${globalIndex}`
                                                      }
                                                      style={{
                                                        padding: "10px",
                                                      }}
                                                    >
                                                      {String.fromCharCode(
                                                        65 + globalIndex
                                                      ).toLowerCase()}
                                                      <span
                                                        style={{
                                                          marginRight: "2px",
                                                        }}
                                                      >
                                                        .
                                                      </span>
                                                      <QuestionTextRenderer
                                                        questionText={
                                                          option.option_text
                                                        }
                                                      />
                                                    </li>
                                                  );
                                                })}
                                            </ul>
                                          ))}
                                        </div>
                                      </ul>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          ) : (
                            <p>No questions in this section.</p>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "20px",
            gap: "20px",
          }}
        >
          <div className="create-ques-paper-ques-bank-preview-valiedate">
            <button onClick={handlePreviewClick}> Preview </button>{" "}
          </div>
          <div className="create-ques-paper-ques-bank-preview-valiedate">
            <button
              onClick={handleValidate}
              disabled={isActiveSubjectReadOnly()}
              style={{
                backgroundColor: isActiveSubjectReadOnly()
                  ? "#d3d3d3"
                  : "white",
                cursor: isActiveSubjectReadOnly() ? "not-allowed" : "pointer",
                color: isActiveSubjectReadOnly() ? "" : "#424342",
              }}
            >
              {" "}
              Validate{" "}
            </button>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuestionPaperDetail;

// Save previous tab selections to localStorage for showing in new tabs correctly easy, medium, tough(SHASHI KANT ON FRIDAY)
//   useEffect(() => {
//   const savePreviousTabSelections = () => {
//     const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     const updated = { ...existing };
//     localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
//   };

//   window.addEventListener("beforeunload", savePreviousTabSelections);
//   return () => window.removeEventListener("beforeunload", savePreviousTabSelections);
// }, []);

// const statusMap = { 0: "Inactive", 1: "Draft", 2: "Submitted", 3: "Reviewed", 4: "Approved" };

//   const allStatuses = accessibleSubjects
//   .filter(subj => subj.isAccessible) // ✅ Only show subjects assigned to current user
//   .map((subj, index, filteredList) => {
//     const draftSubject = draftData?.subjects?.find(s => s.subject_id === subj.subject_id);
//     const statusCode = draftSubject?.status;
//     const statusText = statusMap[statusCode] || "Assigned";
//     const isActive = subj.subject_id === activeSubjectId;

//     return (
//       <span key={subj.subject_id}>
//         <span style={{ fontWeight: isActive ? 'bold' : 'normal' }}>
//           {subj.subject_name} - {statusText}
//         </span>
//         {index !== filteredList.length - 1 && " | "}
//       </span>
//     );
//   });

// `Section ${sectionLabel} only allows "${readableType}" questions,
// but found mismatched type for question ID(s): ${mismatchedQuesIds.join(", ")}.`

// useEffect(() => {
//   if (draftData && draftData.subjects?.length > 0) {
//     const firstSubject = draftData.subjects[0];

//     if (typeof firstSubject.no_of_sections === "number") {
//       setSectionsTypeID(firstSubject.no_of_sections);
//       setSelectedSections(firstSubject.no_of_sections);
//     }

//     // ✅ Prepare selectedTagsBySubject mapping
//     const tagsBySubject = {};

//     draftData.subjects.forEach((subject) => {
//       if (subject.parse_tags?.length > 0) {
//         tagsBySubject[subject.subject_id] = subject.parse_tags.map((tag) => ({
//           tag_id: tag.parse_tag_id,
//           tag_value_id: tag.parse_tag_value_id,
//         }));
//       }
//     });

//     setSelectedTagsBySubject(tagsBySubject);

//     // ✅ Also set selectedTags for current active tab
//     if (activeSubjectId) {
//       setSelectedTags(tagsBySubject[activeSubjectId] || []);
//     } else {
//       setSelectedTags(tagsBySubject[firstSubject.subject_id] || []);
//     }
//   }
// }, [draftData, activeSubjectId]);

// useEffect(() => {
// if (draftData && draftData.subjects?.length > 0) {
//   const firstSubject = draftData.subjects[0];

//   if (typeof firstSubject.no_of_sections === "number") {
//     setSectionsTypeID(firstSubject.no_of_sections);
//     setSelectedSections(firstSubject.no_of_sections);
//   }
//   // ✅ Initialize sectionSettingsBySubject from draftData
//   const newSettings = {};
//   draftData.subjects.forEach(subject => {
//     newSettings[subject.subject_id] = {
//       selectedSections: subject.no_of_sections || 1,
//       excludeRepeatCount: subject.exclude_repeat_n_times || 0,
//       selecteSectionTypeID: subject.section_naming_type || 1,
//     };
//   });
//   setSectionSettingsBySubject(newSettings);

//   // ✅ Prepare selectedTagsBySubject mapping
//   const tagsBySubject = {};
//   draftData.subjects.forEach((subject) => {
//     if (subject.parse_tags?.length > 0) {
//       tagsBySubject[subject.subject_id] = subject.parse_tags.map((tag) => ({
//         tag_id: tag.parse_tag_id,
//         tag_value_id: tag.parse_tag_value_id,
//       }));
//     }
//   });
//   setSelectedTagsBySubject(tagsBySubject);
//     // ✅ Also set selectedTags for current active tab
//     if (activeSubjectId) {
//       setSelectedTags(tagsBySubject[activeSubjectId] || []);
//     } else {
//       setSelectedTags(tagsBySubject[firstSubject.subject_id] || []);
//     }
//   }
// }, [draftData, activeSubjectId]);

// 🟢 Final Save - Only selected questions and deleted questions
//     const subjectWise = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     const quesTypeLocal = JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds") || "{}");
//     const deletedData = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");

//     const selectedIds = subjectWise[activeSubjectId] || [];
//     const selectedIdsSet = new Set(selectedIds);
//     const localTypeMap = quesTypeLocal[activeSubjectId] || {};
//     const deletedIdsArray = deletedData[activeSubjectId] || [];

//     const allQuesMap = new Map();

//     // ✅ Step 1: Selected questions with status 1
//     reportDashboardData.forEach((row, index) => {
//       const quesId = row[0];
//       if (!selectedIdsSet.has(quesId)) return;

//       const quesTypeStr = row[2];
//       const quesTypeId = localTypeMap[quesId] || quesTypeMapping[quesTypeStr] || null;

//       let sectionName = null;
//       for (const [sectionLabel, questions] of Object.entries(sectionWiseQuestions)) {
//         if (questions.find((q) => q.id === quesId || q.parse_ques_set_question_id === quesId)) {
//           sectionName = sectionLabel;
//           break;
//         }
//       }

//       allQuesMap.set(quesId, {
//         parse_ques_set_question_id: quesId,
//         org_ques_position: index + 1,
//         status: 1,
//         section_name: sectionName,
//         ques_type_id: quesTypeId,
//         added_by: userName,
//         removed_by: userName,
//       });
//     });
// // ✅ Step 2: Deleted questions with status 2
//   deletedIdsArray.forEach((quesId, index) => {
//     if (!allQuesMap.has(quesId)) {
//       const quesTypeId = localTypeMap[quesId] || 0;
//       allQuesMap.set(quesId, {
//         parse_ques_set_question_id: quesId,
//         org_ques_position: selectedIds.length + index + 1,
//         status: 2,
//         section_name: null,
//         ques_type_id: quesTypeId,
//         added_by: userName,
//         removed_by: userName,
//       });
//     } else {
//       const existing = allQuesMap.get(quesId);
//       existing.status = 2;
//     }
//   });
//   questionsPayload = Array.from(allQuesMap.values());

// const handleTabChange = (subjectId, requestedId = null) => {
//   const newSubjectId = requestedId ?? subjectId;

//   if (hasUnsavedChanges && newSubjectId !== activeSubjectId) {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>You have unsaved changes. Please save draft before switching tabs.</span>
//         </div>
//       </div>
//     );
//     setActiveImg(WarnningIcon);
//     setIsMessageBoxVisible(true);
//     return;
//   }

//   setActiveSubjectId(newSubjectId); // ✅ tab state change

//   const settings = sectionSettingsBySubject[newSubjectId] || {};
//   setExcludeRepeatCount(settings.excludeRepeatCount || 0);
//   setSelectedSections(settings.selectedSections || 1);
//   setSelecteSectionTypeID(settings.selecteSectionTypeID || 1);
//   setSelectedTags(selectedTagsBySubject[newSubjectId] || []);
// };

// AUTO SAVE FUNCTION onClick={handleAutoGenerate}

// const getQuesTypeId = (type) => {
//   return type === "single" ? 1 : type === "multi" ? 2 : type === "fill" ? 3 : 4;
// };

// const matchesAllTags = (question) => {
//   return finalTags.every((tag) => {
//     if (tag.tag_value_id === 0) return true;
//     return question.parse_tags?.some((qt) => qt.parse_tag_id === tag.tag_id && qt.parse_tag_value_id === tag.tag_value_id);
//   });
// };
// const handleAutoGenerate = () => {
//   const selected = [];

//   const quesTypes = ["single", "multi", "fill", "boolean"];

//   for (const type of quesTypes) {
//     const chapterCheck = checkedChaptersByType[type];
//     const topicsByChapter = selectedTopicsByType[type];
//     const fixedCounts = fixedTopicCountsByType[type];
//     const fixedEnabled = fixedTopicEnabledByType[type];
//     const difficulty = difficultyDistributions[type];

//     Object.entries(chapterCheck).forEach(([chapterId, isChecked]) => {
//       if (!isChecked) return;

//       const topicIds = topicsByChapter?.[chapterId] || [];
//       const chapterQuestions = reportDashboardData.filter((q) =>
//         q.chapter_id === parseInt(chapterId) &&
//         topicIds.includes(q.topic_id) &&
//         q.ques_type_id === getQuesTypeId(type) &&
//         matchesAllTags(q)
//       );

//       console.log(`🔍 Chapter ${chapterId} - Filtered questions:`, chapterQuestions);

//       let easy = difficulty?.[chapterId]?.firstSegment || 0;
//       let medium = difficulty?.[chapterId]?.secondSegment || 0;
//       let tough = difficulty?.[chapterId]?.calculatedValue || 0;

//       const easyQ = chapterQuestions.filter((q) => q.difficulty_level === "Easy").slice(0, easy);
//       const mediumQ = chapterQuestions.filter((q) => q.difficulty_level === "Medium").slice(0, medium);
//       const toughQ = chapterQuestions.filter((q) => q.difficulty_level === "Tough").slice(0, tough);

//       let chapterSelection = [...easyQ, ...mediumQ, ...toughQ];

//       // Fixed topic count logic
//       if (fixedEnabled?.[chapterId]) {
//         chapterSelection = [];
//         topicIds.forEach((topicId) => {
//           const count = fixedCounts?.[chapterId]?.[topicId] || 0;
//           const filtered = chapterQuestions
//             .filter((q) => q.topic_id === topicId)
//             .slice(0, count);
//           chapterSelection.push(...filtered);
//           console.log(`📌 Topic ${topicId} fixed count: ${count}, Selected:`, filtered);
//         });
//       }
//       selected.push(...chapterSelection);
//     });
//   }

//   console.log("✅ Auto-generated selected questions:", selected);

//   setSelectedQuestions(selected);
//   setFinalSelectedQuesIds(selected.map((q) => q.parse_ques_set_question_id));
//   setMessageBox(`Auto-selected ${selected.length} questions.`);
//   setIsMessageBoxVisible(true);
// };

{
  /* <div className="progress-container">
                      <span className="progress-label">{recommendedEasy}</span>
                      <div className="progress-bar" style={{ height: `${easyBarHeight}px`, display: 'flex', alignItems: 'flex-end'}} >
                        <div className="progress-fill" style={{ height: `${easyFillHeight}px`, backgroundColor: "#4A9D45", }} ></div>
                      </div>
                      <span className="progress-value-outside-easy" style={{ bottom: easyBottom, color: "#4A9D45", fontSize: "12px", position: "absolute", }} > {easyCount} </span>
                      <span className="progress-title">Easy</span>
                    </div> */
}
// Fill height based on count (but visually capped at 190)
// const easyFillHeight = Math.min(easyCount * unitHeight, maxFillVisualHeight);
// const mediumFillHeight = Math.min(mediumCount * unitHeight, maxFillVisualHeight);  // const maxOverall = (activeSubject?.easy || 0) + (activeSubject?.medium || 0) + (activeSubject?.tough || 0);
// const overall = easyCount + mediumCount + toughCount;
// const overallProgressPercent = maxOverall ? Math.min((overall / maxOverall) * 100, 100) : 0;
// const maxFillVisualWidth = 360;
// const overallCount = easyCount + mediumCount + toughCount;
// const progressBarWidth = Math.min(overallRecommended * unitWidth, maxFillVisualWidth);
// const progressFillWidth = Math.min(overallCount * unitWidth, maxFillVisualWidth);
// const maxFillVisualHeight = 210;
// const cappedOverallCount = cappedEasyCount + cappedMediumCount + cappedToughCount;
// const overallFillWidth = Math.min(cappedOverall * unitWidth, 368);
// const toughFillHeight = Math.min(toughCount * unitHeight, maxFillVisualHeight);
// const cappedOverall = cappedEasyCount + cappedMediumCount + cappedToughCount;

{
  /* <button className="create-test-section-btn-ques-paper-del" onClick={() => navigate(-1)}>CANCEL</button>
   */
}
{
  /* <button
            className="create-test-section-btn-ques-paper-del"
            onClick={() => {
              if (hasUnsavedChanges) {
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <div className="loader-tc"></div>
                      <span>You have unsaved changes. Please save your draft before exiting.</span>
                    </div>
                  </div>
                );
                setActiveImg(WarnningIcon);
                setIsMessageBoxVisible(true);
                setNoTimeSet(false)
              } else {
                navigate(-1); // Only navigate if no unsaved changes
                localStorage.removeItem("subjectWiseSelectedRowIds");
                localStorage.removeItem("subjectWiseDeletedRowIds");
                localStorage.removeItem("subjectWiseQuesTypeIds");
                localStorage.removeItem("subjectWiseSectionMap")
              }
            }}
          >
            CANCEL
          </button> */
}

{
  /* <button className="create-test-section-btn-ques-paper-del"
            style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040", backgroundColor: finalSelectedQuesIds.length > 0 ? "" : "#d3d3d3", cursor: finalSelectedQuesIds.length > 0 ? "pointer" : "not-allowed", color: finalSelectedQuesIds.length > 0 ? "#424342" : "", }}
            onClick={() => handleSaveQuestionPaper(2)}
            disabled={finalSelectedQuesIds.length === 0}
            onMouseEnter={(e) => { if (finalSelectedQuesIds.length > 0) { e.target.style.backgroundColor = "#fa4741"; e.target.style.color = "white"; } }}
            onMouseLeave={(e) => { if (finalSelectedQuesIds.length > 0) { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; } }} >
            SAVE
          </button> */
}

// SHOW CORRECT ANSWER SECTION WISE
// {["A", "B", "C", "D"]
// .filter((sectionName) => (sectionWiseQuestions[sectionName] || []).length > 0)
// .map((sectionName) => {
//   const questions = sectionWiseQuestions[sectionName];

//   return (
//     <div key={sectionName} style={{ marginBottom: "20px" }}>
//       <h4 style={{ marginBottom: "10px", textAlign: "center" }}>
//         Section {sectionName}
//       </h4>
//       <ul style={{ paddingLeft: "20px" }}>
//         {questions.map((ques, index) => {
//           const quesId = ques.id || ques.parse_ques_set_question_id;
//           const options = questionOptions[quesId] || [];

//           return (
//             <li key={quesId || index} style={{ marginBottom: "16px" }}>
//               <div style={{ marginBottom: "4px" }}>
//                 {index + 1}. {ques.text}
//               </div>
//               {showOptions && (
//                 <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
//                   <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
//                     {[0, 1].map((col) => (
//                       <ul
//                         key={col}
//                         style={{
//                           flex: "1 1 45%",
//                           paddingLeft: "20px",
//                           marginTop: "5px",
//                           listStyleType: "disc",
//                         }}
//                       >
//                         {options
//                           .filter((_, idx) => idx % 2 === col)
//                           .map((option, idx) => {
//                             const globalIndex = col + idx * 2;
//                             return (
//                               <li
//                                 key={option.option_id || globalIndex}
//                                 style={{ padding: "10px" }}
//                               >
//                                 {String.fromCharCode(65 + globalIndex).toLowerCase()}.
//                                 <QuestionTextRenderer questionText={option.option_text} />
//                               </li>
//                             );
//                           })}
//                       </ul>
//                     ))}
//                   </div>
//                 </ul>
//               )}
//             </li>
//           );
//         })}
//       </ul>
//     </div>
//   );
// })}

{
  /* <div className="progress-container">
                      <span className="progress-label">{recommendedEasy}</span>
                      <div className="progress-bar" style={{ height: `${easyBarHeight}px`, display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }}>
                        <div className="progress-fill" style={{ height: `${easyFillHeight}px`, backgroundColor: "#4A9D45" }}></div>
                      </div>
                      <span className="progress-value-outside-easy" style={{ bottom: easyBottom, color: "#4A9D45", fontSize: "12px", position: "absolute" }}>
                        {cappedEasyCount}
                      </span>
                      <span className="progress-title">Easy</span>
                    </div> */
}
{
  /* <div className="progress-container">
                      <span className="progress-label"> {recommendedMedium} </span>
                      <div className="progress-bar" style={{ height: `${mediumBarHeight}px`, display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }} >
                        <div className="progress-fill" style={{ height: `${mediumFillHeight}px`, backgroundColor: "#FFBD20", }} ></div> </div>
                      <span className="progress-value-outside-medium" style={{ bottom: mediumBottom, color: "#FFBD20", fontSize: "12px", position: "absolute", }} >
                        {cappedMediumCount}
                      </span>
                      <span className="progress-title">Med.</span>
                    </div> */
}
{
  /* <div className="progress-container">
                      <span className="progress-label">{recommendedTough}</span>
                      <div className="progress-bar" style={{ height: `${toughBarHeight}px`, display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }} >
                        <div className="progress-fill" style={{ height: `${toughFillHeight}px`, backgroundColor: "#FA4741", }} ></div>
                      </div>
                      <span className="progress-value-outside-tough" style={{ bottom: toughBottom, color: "#FA4741", fontSize: "12px", position: "absolute", }} >
                        {cappedToughCount}
                      </span>
                      <span className="progress-title">Tough</span>
                    </div> */
}

// const switchTab = async (newSubjectId) => {
//   setActiveSubjectId(newSubjectId);

//   const settings = sectionSettingsBySubject[newSubjectId] || {};
//   setExcludeRepeatCount(settings.excludeRepeatCount || 0);
//   setSelectedSections(settings.selectedSections || 1);
//   setSelecteSectionTypeID(settings.selecteSectionTypeID || 1);

//   try {
//     const url = `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/?ques_paper_id=${questionPaperId}&subject_ids=${newSubjectId}`;
//     const response = await fetch(url, {
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//         "Content-Type": "application/json",
//       },
//     });
//     if (!response.ok) throw new Error("Draft API failed");

//     const result = await response.json();
//     const draftSubject = result.subjects?.find(sub => sub.subject_id === newSubjectId);
//     const tagList = draftSubject?.parse_tags || [];

//     // ✅ Normalize into { tag_id, tag_value_id }
//     const formattedTags = tagList.map(tag => ({
//       tag_id: tag.parse_tag_id,
//       tag_value_id: tag.parse_tag_value_id,
//     }));

//     // ✅ Save to subject-wise tags
//     setSelectedTagsBySubject(prev => ({
//       ...prev,
//       [newSubjectId]: formattedTags,
//     }));

//     // ✅ Set as active subject's selected tags
//     setSelectedTags(formattedTags);
//   } catch (err) {
//     console.error("Error fetching draft tags on tab switch", err);
//   }
// };

// const switchTab = async (newSubjectId) => {
// console.log(newSubjectId, questionPaperId, "newSubjectId from switchTab");
// setActiveSubjectId(newSubjectId);

// const settings = sectionSettingsBySubject[newSubjectId] || {};
// setExcludeRepeatCount(settings.excludeRepeatCount || 0);
// setSelectedSections(settings.selectedSections || 1);
// setSelecteSectionTypeID(settings.selecteSectionTypeID || 1);

// try {
//   const subjectStatus = subjectStatusById[newSubjectId]; // stored when layout loaded

//   if (subjectStatus === 0) {
//     // 🔹 Assigned → Layout API
//     const url = `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`;
//     const response = await fetch(url, {
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//         "Content-Type": "application/json",
//       },
//     });
//     if (!response.ok) throw new Error("Layout API failed");

//     const result = await response.json();
//     const layoutSubject = result.question_paper.subjects?.find(
//       (s) => s.subject_id === newSubjectId
//     );

//     if (layoutSubject?.chapters?.length) {
//       const checked = {};
//       layoutSubject.chapters.forEach((ch) => {
//         checked[ch.chapter_id] = true;
//       });

//       // ✅ Step 1: mark chapters checked
//       setCheckedChaptersByType((prev) => ({
//         ...prev,
//         single: { ...prev.single, ...checked },
//         multi: { ...prev.multi, ...checked },
//         fill: { ...prev.fill, ...checked },
//         boolean: { ...prev.boolean, ...checked },
//       }));

//       // ✅ Step 2: fetch topics for these chapters
//       try {
//         const topicsResponse = await fetch(
//           `${FULL_API_BASE_URL}/get-topics-by-chapter-list/`,
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               chapter_ids: layoutSubject.chapters.map((c) => c.chapter_id),
//             }),
//           }
//         );
//         if (!topicsResponse.ok) throw new Error("Topics API failed");
//         const topicsResult = await topicsResponse.json();

//         // Build mapping chapter_id → [topic_ids]
//         const selectedTopics = {};
//         topicsResult?.topics?.forEach((topic) => {
//           if (!selectedTopics[topic.chapter_id]) {
//             selectedTopics[topic.chapter_id] = [];
//           }
//           selectedTopics[topic.chapter_id].push(topic.topic_id);
//         });

//         // ✅ Step 3: mark topics selected
//         setSelectedTopicsByType((prev) => ({
//           ...prev,
//           single: { ...prev.single, ...selectedTopics },
//           multi: { ...prev.multi, ...selectedTopics },
//           fill: { ...prev.fill, ...selectedTopics },
//           boolean: { ...prev.boolean, ...selectedTopics },
//         }));
//       } catch (err) {
//         console.error("Error fetching topics for Assigned subject", err);
//       }
//     }
//   } else if (subjectStatus === 1) {
//     // else if (subjectStatus === 1 || subjectStatus === 2) {
//     // 🔹 Draft → Draft API
//     const url = `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/?ques_paper_id=${questionPaperId}&subject_ids=${newSubjectId}`;
//     const response = await fetch(url, {
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//         "Content-Type": "application/json",
//       },
//     });
//     if (!response.ok) throw new Error("Draft API failed");

//     const result = await response.json();
//     const draftSubject = result.subjects?.find(
//       (sub) => sub.subject_id === newSubjectId
//     );
//     const tagList = draftSubject?.parse_tags || [];

//     const formattedTags = tagList.map((tag) => ({
//       tag_id: tag.parse_tag_id,
//       tag_value_id: tag.parse_tag_value_id,
//     }));

//     setSelectedTagsBySubject((prev) => ({
//       ...prev,
//       [newSubjectId]: formattedTags,
//     }));
//     setSelectedTags(formattedTags);
//   }
// } catch (err) {
//   console.error("Error in switchTab", err);
// }
// };

// const recommendedEasy = activeSubject?.easy || 0;
// const recommendedMedium = activeSubject?.medium || 0;
// const recommendedTough = activeSubject?.tough || 0;
// const selectedEasy = difficultyCount.easy || 0;
// const selectedMedium = difficultyCount.medium || 0;
// const selectedTough = difficultyCount.tough || 0;

// if (selectedEasy !== recommendedEasy) {
//   return `Easy question count must be exactly ${recommendedEasy}. You have selected ${selectedEasy}.`;
// }

// if (selectedMedium !== recommendedMedium) {
//   return `Medium question count must be exactly ${recommendedMedium}. You have selected ${selectedMedium}.`;
// }

// if (selectedTough !== recommendedTough) {
//   return `Tough question count must be exactly ${recommendedTough}. You have selected ${selectedTough}.`;
// }
// const unassignedQuestions = selectedQuestions.filter(q => !q.section_name);
// const unassignedQuestions = selectedQuestions.filter((q) => {
//   const quesId = q[0];
//   return !Object.values(sectionWiseQuestions).some((questions) =>
//     questions.find((secQ) => secQ.id === quesId || secQ.parse_ques_set_question_id === quesId)
//   );
// });

// if (unassignedQuestions.length > 0) {
//   return `${unassignedQuestions.length} question(s) do not have a section assigned.`;
// }

// HANDLE SECTION QUESTION COUNT ERRORS
// if (selectedSections > 1) {
//   for (let i = 0; i < selectedSections; i++) {
//     const sectionLabel = selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
//     const sectionKey = sectionLabel;
//     const sectionData = sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
//     const questionsInSection = sectionWiseQuestions[sectionLabel] || [];

//     // const totalExpected = sectionData?.total_ques_cnt ?? 0;
//     const totalExpected = sectionData?.total_ques_cnt ?? questionsInSection.length;

//     if (questionsInSection.length !== totalExpected) {
//       return `Section ${sectionLabel}: Selected ${questionsInSection.length} of ${totalExpected} questions.`
//     }
//   }
// }

// HANDLE SECTION QUESTION TYPE ERRORS
// if (selectedSections > 0) {
//   const localQuesTypeMap = JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds") || "{}")[activeSubjectId] || {};

//   for (let i = 0; i < selectedSections; i++) {
//     const sectionLabel = selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
//     const sectionKey = `Section ${sectionLabel}`;
//     const questionsInSection = sectionWiseQuestions[sectionLabel] || [];

//     const sectionData = sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
//     const expectedTypeId = sectionData?.section_question_type_id;

//     if (!expectedTypeId) continue;

//     const mismatchedQuesIds = questionsInSection.filter((question) => {
//       const qid = question.id || question.ques_id || question.parse_ques_set_question_id;
//       const actualTypeId = parseInt(localQuesTypeMap[qid]);
//       return actualTypeId !== expectedTypeId;
//     });

//     if (mismatchedQuesIds.length > 0) {
//       const readableType = questionTypeMap[expectedTypeId] || "Unknown";

//         return `Section ${sectionLabel} only allows "${readableType}" questions, but found ${mismatchedQuesIds.length} mismatched question(s).`

//     }
//   }
// }

// const handleSaveQuestionPaper = async (status = 2) => {
//   if (!data) return;

//   const recommendedEasy = activeSubject?.easy || 0;
//   const recommendedMedium = activeSubject?.medium || 0;
//   const recommendedTough = activeSubject?.tough || 0;
//   const selectedEasy = difficultyCount.easy || 0;
//   const selectedMedium = difficultyCount.medium || 0;
//   const selectedTough = difficultyCount.tough || 0;

//   // ✅ Show warning ONLY on final save
//   if (status === 2 &&
//     (selectedEasy !== recommendedEasy ||
//      selectedMedium !== recommendedMedium ||
//      selectedTough !== recommendedTough)
//   ) {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             Recommended counts (Easy: {recommendedEasy}, Medium: {recommendedMedium}, Tough: {recommendedTough})
//             do not match your selection (Easy: {selectedEasy}, Medium: {selectedMedium}, Tough: {selectedTough}).
//             Do you still want to proceed?
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{ display: "flex", gap: "10px", marginTop: "10px" }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               saveQuestionPaper(status); // ✅ continue final save
//             }}
//           >
//             YES
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(WarnningIcon);
//     setIsMessageBoxVisible(true);
//     return; // 🛑 stop until user confirms
//   }

//   // ✅ For draft (status=1) or if no mismatch on final → save directly
//   await saveQuestionPaper(status);
// };

// useEffect(() => {
//   if (!allTopicsLoaded) return;  // ✅ wait until all topics fetched

//   const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);

//   setFinalTags(hasValidTags ? [...selectedTags] : []);

//   let filters = generateFiltersV2();

//   // ✅ If filters are empty → send default filter
//   if (!filters || filters.length === 0) {
//     filters = [
//       {
//         ques_types: [
//           {
//             ques_type_id: 0,
//             chapters: [
//               {
//                 chapter_id: 0,
//                 topics: [0],
//               },
//             ],
//           },
//         ],
//       },
//     ];
//   }

//   setFinalFilters(filters);
// }, [selectedTags, checkedChaptersByType, selectedTopicsByType, activeSubjectId, allTopicsLoaded]);

// setFinalFilters([]);
// setFinalTags([]);
// setSelectedTopicsByType({ single: {}, multi: {}, fill: {}, boolean: {} });
// setCheckedChaptersByType({ single: {}, multi: {}, fill: {}, boolean: {} });
// setReportDashboardData([]);

// const switchTab = async (newSubjectId) => {
//   setLoadingTab(true);   // 🟢 start loading
//   try {
//     setActiveSubjectId(newSubjectId);

//     const settings = sectionSettingsBySubject[newSubjectId] || {};
//     setExcludeRepeatCount(settings.excludeRepeatCount || 0);
//     setSelectedSections(settings.selectedSections || 1);
//     setSelecteSectionTypeID(settings.selecteSectionTypeID || 1);

//     const subjectStatus = subjectStatusById[newSubjectId]; // stored when layout loaded

//     if (subjectStatus === 0) {
//       // 🔹 Assigned → Layout API
//       const url = `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`;
//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//       });
//       if (!response.ok) throw new Error("Layout API failed");

//       const result = await response.json();
//       const layoutSubject = result.question_paper.subjects?.find(
//         (s) => s.subject_id === newSubjectId
//       );

//       if (layoutSubject?.chapters?.length) {
//         const checked = {};
//         layoutSubject.chapters.forEach((ch) => {
//           checked[ch.chapter_id] = true;
//         });

//         // ✅ Step 1: mark chapters checked
//         setCheckedChaptersByType((prev) => ({
//           ...prev,
//           single: { ...prev.single, ...checked },
//           multi: { ...prev.multi, ...checked },
//           fill: { ...prev.fill, ...checked },
//           boolean: { ...prev.boolean, ...checked },
//         }));

//         // ✅ Step 2: fetch topics for these chapters
//         try {
//           const topicsResponse = await fetch(
//             `${FULL_API_BASE_URL}/get-topics-by-chapter-list/`,
//             {
//               method: "POST",
//               headers: {
//                 Authorization: `Bearer ${accessToken}`,
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 chapter_ids: layoutSubject.chapters.map((c) => c.chapter_id),
//               }),
//             }
//           );
//           if (!topicsResponse.ok) throw new Error("Topics API failed");
//           const topicsResult = await topicsResponse.json();

//           // Build mapping chapter_id → [topic_ids]
//           const selectedTopics = {};
//           topicsResult?.topics?.forEach((topic) => {
//             if (!selectedTopics[topic.chapter_id]) {
//               selectedTopics[topic.chapter_id] = [];
//             }
//             selectedTopics[topic.chapter_id].push(topic.topic_id);
//           });

//           // ✅ Step 3: mark topics selected
//           setSelectedTopicsByType((prev) => ({
//             ...prev,
//             single: { ...prev.single, ...selectedTopics },
//             multi: { ...prev.multi, ...selectedTopics },
//             fill: { ...prev.fill, ...selectedTopics },
//             boolean: { ...prev.boolean, ...selectedTopics },
//           }));
//         } catch (err) {
//           console.error("Error fetching topics for Assigned subject", err);
//         }
//       }
//     } else if (subjectStatus === 1) {
//       // 🔹 Draft → Draft API
//       const url = `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/?ques_paper_id=${questionPaperId}&subject_ids=${newSubjectId}`;
//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//       });
//       if (!response.ok) throw new Error("Draft API failed");

//       const result = await response.json();
//       const draftSubject = result.subjects?.find(
//         (sub) => sub.subject_id === newSubjectId
//       );
//       const tagList = draftSubject?.parse_tags || [];

//       const formattedTags = tagList.map((tag) => ({
//         tag_id: tag.parse_tag_id,
//         tag_value_id: tag.parse_tag_value_id,
//       }));

//       setSelectedTagsBySubject((prev) => ({
//         ...prev,
//         [newSubjectId]: formattedTags,
//       }));
//       setSelectedTags(formattedTags);
//     }
//   } catch (err) {
//     console.error("Error in switchTab", err);
//   } finally {
//     setLoadingTab(false);  // 🔴 stop loading
//   }
// };

// const generateFiltersV2 = () => {
//   if (!data || !activeSubjectId) return [];

//   const activeSubject = data.subjects.find((subj) => subj.subject_id === activeSubjectId);
//   const courseId = data.ques_paper_details?.course_id || 0;
//   const validChapterIds = new Set(activeSubject?.chapters?.map(ch => ch.chapter_id) || []);
//   const activeQuesTypes = data.ques_paper_details?.parse_ques_set_ques_type || [];

//   const quesTypes = activeQuesTypes.map((quesTypeId) => {
//     let typeKey = "";
//     switch (quesTypeId) {
//       case 1: typeKey = "single"; break;
//       case 2: typeKey = "multi"; break;
//       case 3: typeKey = "fill"; break;
//       case 4: typeKey = "boolean"; break;
//       default: return null;
//     }

//     const chaptersObj = checkedChaptersByType[typeKey] || {};
//     const topicsObj = selectedTopicsByType[typeKey] || {};

//     const filteredChapters = Object.entries(chaptersObj)
//       .filter(([chapterId, isChecked]) => isChecked && validChapterIds.has(parseInt(chapterId)))
//       .map(([chapterId]) => ({
//         chapter_id: parseInt(chapterId),
//         topics: topicsObj[chapterId] || [],
//       }));

//     return {
//       ques_type_id: quesTypeId,
//       chapters: filteredChapters.length > 0
//         ? filteredChapters
//         : [{
//           chapter_id: 0,
//           topics: [0]
//         }]
//     };
//   }).filter(Boolean);

//   return [
//     {
//       ques_types: quesTypes
//     }
//   ];
// };

// useEffect(() => {
//   const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);

//   if (hasValidTags) {
//     setFinalTags([...selectedTags]);
//     setFinalFilters(generateFiltersV2());
//   } else {
//     setFinalTags([]);
//     setFinalFilters([]);
//   }
// }, [selectedTags, checkedChaptersByType, selectedTopicsByType, activeSubjectId]);
